module.exports = [{
  "type": "FeatureCollection",
  "features": [{
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.175846, -24.157831],
            [-55.161325, -24.191926],
            [-55.177824, -24.229017],
            [-55.208658, -24.241852],
            [-55.209532, -24.252207],
            [-55.192451, -24.268784],
            [-55.184395, -24.312591],
            [-55.195278, -24.32512],
            [-55.223375, -24.34058],
            [-55.230193, -24.352034],
            [-55.244879, -24.353588],
            [-55.257607, -24.365008],
            [-55.288388, -24.36366],
            [-55.316531, -24.353547],
            [-55.360012, -24.359492],
            [-55.373024, -24.374238],
            [-55.342097, -24.391424],
            [-55.326016, -24.410683],
            [-55.322082, -24.433312],
            [-55.363972, -24.436407],
            [-55.394941, -24.427646],
            [-55.422858, -24.432721],
            [-55.447143, -24.426769],
            [-55.464874, -24.435384],
            [-55.489375, -24.43978],
            [-55.508001, -24.424528],
            [-55.526808, -24.42087],
            [-55.494082, -24.390931],
            [-55.509314, -24.360833],
            [-55.521774, -24.363034],
            [-55.548877, -24.334342],
            [-55.566208, -24.329924],
            [-55.577658, -24.308111],
            [-55.539749, -24.297819],
            [-55.518113, -24.273571],
            [-55.502032, -24.268736],
            [-55.500562, -24.257809],
            [-55.475663, -24.260316],
            [-55.46539, -24.282123],
            [-55.442863, -24.28393],
            [-55.431841, -24.261085],
            [-55.44328, -24.244569],
            [-55.432065, -24.214995],
            [-55.434712, -24.198172],
            [-55.446891, -24.187612],
            [-55.4238, -24.180695],
            [-55.396772, -24.192122],
            [-55.393115, -24.205735],
            [-55.375537, -24.207658],
            [-55.359683, -24.190231],
            [-55.319694, -24.158608],
            [-55.315047, -24.136227],
            [-55.307545, -24.13134],
            [-55.268066, -24.135222],
            [-55.238958, -24.131779],
            [-55.228132, -24.139197],
            [-55.214436, -24.129643],
            [-55.175846, -24.157831]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "YBY PYTÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.162519, -23.322706],
            [-56.164556, -23.352693],
            [-56.15573, -23.390808],
            [-56.154287, -23.423068],
            [-56.166538, -23.451861],
            [-56.165695, -23.471384],
            [-56.147186, -23.492972],
            [-56.226352, -23.494395],
            [-56.265397, -23.528361],
            [-56.282016, -23.530416],
            [-56.309839, -23.543973],
            [-56.321518, -23.561159],
            [-56.333753, -23.565809],
            [-56.358484, -23.563533],
            [-56.377349, -23.580225],
            [-56.39737, -23.589224],
            [-56.421067, -23.592425],
            [-56.448349, -23.603409],
            [-56.46151, -23.61461],
            [-56.492886, -23.627736],
            [-56.510979, -23.631116],
            [-56.531221, -23.666498],
            [-56.556021, -23.698633],
            [-56.552555, -23.723792],
            [-56.575903, -23.739067],
            [-56.590174, -23.734539],
            [-56.60907, -23.745541],
            [-56.610633, -23.760358],
            [-56.636293, -23.777649],
            [-56.650258, -23.777794],
            [-56.67962, -23.794961],
            [-56.714672, -23.794122],
            [-56.703603, -23.773575],
            [-56.722858, -23.752014],
            [-56.737998, -23.742448],
            [-56.74868, -23.725769],
            [-56.814168, -23.700381],
            [-56.827053, -23.718289],
            [-56.849939, -23.719816],
            [-56.878602, -23.698976],
            [-56.900946, -23.699084],
            [-56.910449, -23.692645],
            [-56.972184, -23.695064],
            [-56.94624, -23.627715],
            [-56.940008, -23.577294],
            [-56.932975, -23.560066],
            [-56.959314, -23.521915],
            [-56.971677, -23.483441],
            [-56.966998, -23.468224],
            [-56.979582, -23.448158],
            [-56.967555, -23.437644],
            [-56.948807, -23.435403],
            [-56.925053, -23.445124],
            [-56.906258, -23.439452],
            [-56.883314, -23.443147],
            [-56.868424, -23.437473],
            [-56.811787, -23.439036],
            [-56.8043, -23.425255],
            [-56.776877, -23.435472],
            [-56.750304, -23.451018],
            [-56.726586, -23.432975],
            [-56.693488, -23.449982],
            [-56.673815, -23.44175],
            [-56.632783, -23.444628],
            [-56.607626, -23.458558],
            [-56.564763, -23.445305],
            [-56.529031, -23.456801],
            [-56.517521, -23.451021],
            [-56.515073, -23.427951],
            [-56.491376, -23.424027],
            [-56.476748, -23.4093],
            [-56.457163, -23.406073],
            [-56.43626, -23.418945],
            [-56.406107, -23.414353],
            [-56.384891, -23.390494],
            [-56.352985, -23.37959],
            [-56.361874, -23.363977],
            [-56.349741, -23.352712],
            [-56.314223, -23.345397],
            [-56.293294, -23.329823],
            [-56.250228, -23.321923],
            [-56.238682, -23.313947],
            [-56.221815, -23.317796],
            [-56.192149, -23.302885],
            [-56.174569, -23.301681],
            [-56.162519, -23.322706]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "TACUATÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.418195, -24.745574],
            [-56.405697, -24.782902],
            [-56.429472, -24.792398],
            [-56.436885, -24.832664],
            [-56.391188, -24.887284],
            [-56.398987, -24.904168],
            [-56.392175, -24.913352],
            [-56.400981, -24.928929],
            [-56.420049, -24.933647],
            [-56.427745, -24.944428],
            [-56.51948, -25.003886],
            [-56.545367, -25.00315],
            [-56.564484, -24.997337],
            [-56.580853, -24.988209],
            [-56.603446, -24.986135],
            [-56.633632, -24.957785],
            [-56.684737, -24.868785],
            [-56.680974, -24.856678],
            [-56.687431, -24.81002],
            [-56.654655, -24.802509],
            [-56.637784, -24.813914],
            [-56.615011, -24.803457],
            [-56.594692, -24.80111],
            [-56.564483, -24.789161],
            [-56.550679, -24.771389],
            [-56.538868, -24.770441],
            [-56.523623, -24.775424],
            [-56.502607, -24.760219],
            [-56.498112, -24.748978],
            [-56.474817, -24.719728],
            [-56.439204, -24.707113],
            [-56.429037, -24.71053],
            [-56.418195, -24.745574]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "UNIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.134739, -27.112273],
            [-56.146439, -27.121438],
            [-56.147174, -27.136496],
            [-56.169738, -27.1515],
            [-56.167893, -27.20465],
            [-56.181177, -27.227234],
            [-56.181851, -27.239675],
            [-56.168952, -27.266893],
            [-56.168231, -27.297061],
            [-56.124613, -27.306457],
            [-56.098127, -27.308322],
            [-56.175637, -27.340166],
            [-56.197087, -27.375038],
            [-56.20912, -27.385061],
            [-56.269638, -27.399057],
            [-56.292493, -27.411052],
            [-56.309819, -27.389717],
            [-56.272077, -27.310227],
            [-56.266434, -27.292387],
            [-56.284182, -27.268325],
            [-56.302769, -27.26267],
            [-56.305146, -27.246881],
            [-56.291289, -27.202771],
            [-56.277932, -27.17689],
            [-56.294974, -27.164478],
            [-56.330813, -27.177313],
            [-56.355149, -27.169912],
            [-56.371544, -27.176831],
            [-56.39179, -27.172745],
            [-56.417295, -27.178584],
            [-56.441311, -27.173439],
            [-56.471163, -27.19109],
            [-56.476901, -27.165951],
            [-56.462554, -27.150158],
            [-56.459289, -27.125903],
            [-56.47365, -27.100448],
            [-56.482484, -27.063631],
            [-56.469077, -27.05451],
            [-56.437354, -27.050781],
            [-56.429874, -27.055739],
            [-56.392806, -27.054981],
            [-56.313287, -27.064072],
            [-56.301545, -27.063463],
            [-56.285614, -27.080676],
            [-56.245082, -27.061785],
            [-56.186902, -27.039449],
            [-56.173379, -27.063585],
            [-56.169645, -27.080246],
            [-56.14056, -27.098492],
            [-56.134739, -27.112273]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CORONEL BOGADO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.908362, -26.220952],
            [-54.762849, -26.347881],
            [-54.696461, -26.404361],
            [-54.700296, -26.437831],
            [-54.711622, -26.455819],
            [-54.75219, -26.493033],
            [-54.783176, -26.511683],
            [-54.80343, -26.544182],
            [-54.83349, -26.545409],
            [-54.824528, -26.525561],
            [-54.850656, -26.511855],
            [-54.871656, -26.524477],
            [-54.911591, -26.503496],
            [-54.911623, -26.489051],
            [-54.926084, -26.474843],
            [-54.939318, -26.477404],
            [-54.953734, -26.463369],
            [-54.963299, -26.435946],
            [-54.976547, -26.441057],
            [-54.995901, -26.420895],
            [-55.009913, -26.424932],
            [-55.032113, -26.411122],
            [-55.024941, -26.393422],
            [-55.03936, -26.389839],
            [-55.036971, -26.374421],
            [-55.059126, -26.363404],
            [-55.075179, -26.363513],
            [-55.102743, -26.324683],
            [-55.120147, -26.322791],
            [-55.212023, -26.239977],
            [-55.205627, -26.233615],
            [-55.183572, -26.213433],
            [-55.165802, -26.216281],
            [-55.137617, -26.206572],
            [-55.123493, -26.219495],
            [-55.050071, -26.237717],
            [-55.035622, -26.237939],
            [-55.028005, -26.223637],
            [-55.009819, -26.235901],
            [-54.990062, -26.225255],
            [-54.981786, -26.238651],
            [-54.947425, -26.233791],
            [-54.957733, -26.222682],
            [-54.939366, -26.20852],
            [-54.908362, -26.220952]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CARLOS ANTONIO LÓPEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.254855, -24.766173],
            [-56.277746, -24.809199],
            [-56.197163, -24.940447],
            [-56.24882, -24.925567],
            [-56.262941, -24.927557],
            [-56.278033, -24.941122],
            [-56.298665, -24.939866],
            [-56.32813, -24.917344],
            [-56.353049, -24.920561],
            [-56.369432, -24.912318],
            [-56.392175, -24.913352],
            [-56.398987, -24.904168],
            [-56.391188, -24.887284],
            [-56.436885, -24.832664],
            [-56.429472, -24.792398],
            [-56.405697, -24.782902],
            [-56.418195, -24.745574],
            [-56.317287, -24.738429],
            [-56.302356, -24.735362],
            [-56.275064, -24.745758],
            [-56.254855, -24.766173]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "YATAITY DEL NORTE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.151384, -24.194697],
            [-56.158022, -24.219139],
            [-56.170484, -24.235816],
            [-56.155609, -24.282739],
            [-56.126647, -24.300913],
            [-56.125143, -24.342606],
            [-56.11616, -24.37041],
            [-56.123032, -24.379706],
            [-56.146344, -24.386994],
            [-56.180493, -24.42622],
            [-56.191355, -24.445808],
            [-56.232134, -24.432514],
            [-56.247123, -24.437512],
            [-56.271444, -24.456208],
            [-56.297862, -24.454699],
            [-56.287275, -24.485911],
            [-56.259449, -24.509874],
            [-56.262062, -24.53142],
            [-56.257301, -24.559862],
            [-56.309038, -24.583888],
            [-56.449813, -24.58601],
            [-56.479171, -24.589137],
            [-56.479833, -24.567934],
            [-56.519532, -24.567994],
            [-56.519679, -24.53185],
            [-56.526194, -24.531722],
            [-56.524735, -24.47153],
            [-56.540039, -24.462218],
            [-56.5397, -24.428109],
            [-56.531514, -24.398975],
            [-56.538021, -24.380056],
            [-56.556044, -24.355462],
            [-56.545546, -24.343532],
            [-56.546522, -24.299135],
            [-56.493878, -24.301153],
            [-56.440975, -24.303412],
            [-56.365826, -24.299197],
            [-56.365836, -24.308323],
            [-56.286941, -24.308136],
            [-56.287015, -24.284275],
            [-56.272407, -24.284215],
            [-56.272567, -24.220945],
            [-56.198135, -24.22078],
            [-56.198547, -24.194775],
            [-56.151384, -24.194697]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "GUAJAYVI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.98744, -24.531236],
            [-55.976541, -24.543285],
            [-55.945353, -24.562912],
            [-55.940481, -24.57057],
            [-55.944019, -24.619265],
            [-55.935421, -24.623431],
            [-55.913896, -24.660447],
            [-55.88023, -24.672427],
            [-55.859494, -24.697307],
            [-55.853028, -24.721531],
            [-55.844395, -24.731452],
            [-55.839619, -24.761879],
            [-55.821896, -24.77385],
            [-55.783129, -24.781929],
            [-55.759969, -24.782908],
            [-55.750717, -24.776921],
            [-55.701991, -24.78397],
            [-55.708015, -24.790957],
            [-55.712114, -24.8199],
            [-55.729978, -24.825008],
            [-55.776427, -24.822422],
            [-55.781163, -24.837822],
            [-55.797103, -24.836629],
            [-55.826973, -24.845741],
            [-55.846136, -24.861453],
            [-55.868537, -24.857954],
            [-55.884079, -24.847499],
            [-55.938318, -24.846133],
            [-55.972534, -24.833745],
            [-55.990516, -24.838419],
            [-55.988705, -24.863221],
            [-56.024134, -24.888207],
            [-56.024258, -24.906038],
            [-56.050659, -24.906208],
            [-56.088941, -24.932729],
            [-56.102968, -24.922314],
            [-56.11883, -24.918813],
            [-56.128384, -24.935166],
            [-56.151114, -24.937293],
            [-56.161899, -24.928346],
            [-56.176524, -24.894305],
            [-56.167925, -24.892289],
            [-56.141319, -24.866401],
            [-56.126998, -24.86196],
            [-56.131489, -24.825661],
            [-56.102449, -24.776296],
            [-56.125925, -24.738171],
            [-56.124245, -24.726878],
            [-56.136656, -24.713128],
            [-56.141926, -24.669973],
            [-56.149587, -24.654208],
            [-56.172393, -24.626732],
            [-56.151867, -24.623141],
            [-56.132773, -24.606262],
            [-56.083023, -24.588018],
            [-56.038941, -24.580293],
            [-56.0189, -24.558057],
            [-55.98744, -24.531236]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "CAPIIBARY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.980663, -23.667947],
            [-55.97552, -23.744603],
            [-55.985046, -23.779069],
            [-56.020672, -23.800269],
            [-56.02729, -23.822219],
            [-56.055578, -23.842359],
            [-56.081813, -23.848902],
            [-56.097725, -23.859026],
            [-56.122868, -23.859706],
            [-56.136837, -23.867407],
            [-56.174422, -23.860184],
            [-56.204314, -23.878369],
            [-56.220009, -23.898],
            [-56.243592, -23.904991],
            [-56.260562, -23.897712],
            [-56.286735, -23.919189],
            [-56.301163, -23.914211],
            [-56.33013, -23.920308],
            [-56.369717, -23.915129],
            [-56.389658, -23.903743],
            [-56.423543, -23.891756],
            [-56.446281, -23.890915],
            [-56.45609, -23.873425],
            [-56.469995, -23.868566],
            [-56.483397, -23.876859],
            [-56.514077, -23.867091],
            [-56.534861, -23.872547],
            [-56.555269, -23.887104],
            [-56.564832, -23.886411],
            [-56.588091, -23.861836],
            [-56.577885, -23.834806],
            [-56.593214, -23.785021],
            [-56.472088, -23.651115],
            [-56.338146, -23.650822],
            [-56.114045, -23.605876],
            [-56.09405, -23.602035],
            [-56.069867, -23.607776],
            [-56.047371, -23.587458],
            [-56.021576, -23.599062],
            [-56.000919, -23.623406],
            [-55.980663, -23.667947]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "SANTA ROSA DEL AGUARAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.123032, -24.379706],
            [-56.103686, -24.399671],
            [-56.057731, -24.403086],
            [-56.052429, -24.421554],
            [-56.024048, -24.444144],
            [-56.012788, -24.482667],
            [-55.994696, -24.501697],
            [-55.98744, -24.531236],
            [-56.0189, -24.558057],
            [-56.038941, -24.580293],
            [-56.083023, -24.588018],
            [-56.132773, -24.606262],
            [-56.151867, -24.623141],
            [-56.172393, -24.626732],
            [-56.20397, -24.606213],
            [-56.204196, -24.584102],
            [-56.224784, -24.578822],
            [-56.257301, -24.559862],
            [-56.262062, -24.53142],
            [-56.259449, -24.509874],
            [-56.287275, -24.485911],
            [-56.297862, -24.454699],
            [-56.271444, -24.456208],
            [-56.247123, -24.437512],
            [-56.232134, -24.432514],
            [-56.191355, -24.445808],
            [-56.180493, -24.42622],
            [-56.146344, -24.386994],
            [-56.123032, -24.379706]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "YRYBUCUA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.464863, -24.078319],
            [-56.452727, -24.093498],
            [-56.428388, -24.110106],
            [-56.414384, -24.10318],
            [-56.39265, -24.120089],
            [-56.368464, -24.119805],
            [-56.329637, -24.140076],
            [-56.316651, -24.133964],
            [-56.287026, -24.152108],
            [-56.27656, -24.147582],
            [-56.260197, -24.157525],
            [-56.245, -24.153739],
            [-56.22343, -24.15878],
            [-56.202666, -24.143846],
            [-56.189059, -24.156885],
            [-56.160641, -24.149331],
            [-56.151384, -24.194697],
            [-56.198547, -24.194775],
            [-56.198135, -24.22078],
            [-56.272567, -24.220945],
            [-56.272407, -24.284215],
            [-56.287015, -24.284275],
            [-56.286941, -24.308136],
            [-56.365836, -24.308323],
            [-56.365826, -24.299197],
            [-56.440975, -24.303412],
            [-56.493878, -24.301153],
            [-56.484376, -24.265736],
            [-56.500288, -24.214001],
            [-56.500451, -24.197324],
            [-56.511664, -24.178583],
            [-56.51831, -24.1535],
            [-56.534672, -24.12804],
            [-56.536099, -24.097702],
            [-56.531031, -24.065429],
            [-56.534471, -24.054137],
            [-56.527217, -24.048718],
            [-56.486246, -24.063242],
            [-56.464863, -24.078319]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "LIBERACIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.065115, -25.333867],
            [-57.069728, -25.344201],
            [-57.060722, -25.359527],
            [-57.05945, -25.378636],
            [-57.069642, -25.399854],
            [-57.094805, -25.422755],
            [-57.11425, -25.429153],
            [-57.119071, -25.450818],
            [-57.131784, -25.455691],
            [-57.170696, -25.429062],
            [-57.195022, -25.401783],
            [-57.200046, -25.360514],
            [-57.186237, -25.342237],
            [-57.162801, -25.358429],
            [-57.127737, -25.34471],
            [-57.129629, -25.304682],
            [-57.110894, -25.311381],
            [-57.084703, -25.313544],
            [-57.065115, -25.333867]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "CAACUPÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.219913, -25.329638],
            [-57.247358, -25.317479],
            [-57.263685, -25.286552],
            [-57.299978, -25.231472],
            [-57.266827, -25.213439],
            [-57.249927, -25.208582],
            [-57.214592, -25.20801],
            [-57.19826, -25.19506],
            [-57.169169, -25.144912],
            [-57.151144, -25.129624],
            [-57.156385, -25.180967],
            [-57.17674, -25.211325],
            [-57.186592, -25.250339],
            [-57.197819, -25.263808],
            [-57.178151, -25.26914],
            [-57.200155, -25.31474],
            [-57.219913, -25.329638]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "ALTOS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.269082, -24.924028],
            [-57.257124, -24.954286],
            [-57.236079, -24.956669],
            [-57.199748, -24.971682],
            [-57.160999, -24.973513],
            [-57.120214, -25.00661],
            [-57.103678, -25.010618],
            [-57.066075, -25.003591],
            [-57.050596, -25.012718],
            [-57.039551, -25.00407],
            [-57.018101, -25.020104],
            [-57.009232, -25.013016],
            [-56.95923, -25.023378],
            [-56.929577, -25.021493],
            [-56.910611, -25.029028],
            [-56.950905, -25.10419],
            [-56.971995, -25.075856],
            [-57.017805, -25.069743],
            [-57.026115, -25.059871],
            [-57.042431, -25.0711],
            [-57.026603, -25.097273],
            [-57.033295, -25.119491],
            [-57.106956, -25.145227],
            [-57.131001, -25.141248],
            [-57.151008, -25.129589],
            [-57.169975, -25.11636],
            [-57.194949, -25.086044],
            [-57.225015, -25.090607],
            [-57.258432, -25.085441],
            [-57.278465, -25.093516],
            [-57.294053, -25.090127],
            [-57.302672, -25.07267],
            [-57.316967, -25.079886],
            [-57.385737, -25.066408],
            [-57.367145, -25.042229],
            [-57.332126, -25.005858],
            [-57.311273, -24.963954],
            [-57.304273, -24.9329],
            [-57.28733, -24.919469],
            [-57.269082, -24.924028]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "ARROYOS Y ESTEROS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.131001, -25.141248],
            [-57.120731, -25.154212],
            [-57.111367, -25.196605],
            [-57.097746, -25.211854],
            [-57.130636, -25.259891],
            [-57.129629, -25.304682],
            [-57.127737, -25.34471],
            [-57.162801, -25.358429],
            [-57.186237, -25.342237],
            [-57.200046, -25.360514],
            [-57.212768, -25.355857],
            [-57.219913, -25.329638],
            [-57.200155, -25.31474],
            [-57.178151, -25.26914],
            [-57.197819, -25.263808],
            [-57.186592, -25.250339],
            [-57.17674, -25.211325],
            [-57.156385, -25.180967],
            [-57.151144, -25.129624],
            [-57.151008, -25.129589],
            [-57.131001, -25.141248]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "ATYRÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.619033, -25.166777],
            [-56.66345, -25.26199],
            [-56.681537, -25.254945],
            [-56.69558, -25.241993],
            [-56.712253, -25.246217],
            [-56.714671, -25.2276],
            [-56.724055, -25.214366],
            [-56.746866, -25.209471],
            [-56.763643, -25.194932],
            [-56.774754, -25.218971],
            [-56.763308, -25.242831],
            [-56.766357, -25.258608],
            [-56.757427, -25.299846],
            [-56.747107, -25.327157],
            [-56.802284, -25.343549],
            [-56.820418, -25.354766],
            [-56.835826, -25.354698],
            [-56.837913, -25.336995],
            [-56.831412, -25.318833],
            [-56.850788, -25.315168],
            [-56.887586, -25.277589],
            [-56.882632, -25.25958],
            [-56.906197, -25.253367],
            [-56.90326, -25.241194],
            [-56.893683, -25.218333],
            [-56.894341, -25.204543],
            [-56.874201, -25.176305],
            [-56.862969, -25.135901],
            [-56.849557, -25.134542],
            [-56.828545, -25.144327],
            [-56.808816, -25.121432],
            [-56.750842, -25.109113],
            [-56.645493, -25.152],
            [-56.619033, -25.166777]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "CARAGUATAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.385737, -25.066408],
            [-57.316967, -25.079886],
            [-57.302672, -25.07267],
            [-57.294053, -25.090127],
            [-57.278465, -25.093516],
            [-57.272796, -25.117082],
            [-57.320735, -25.184803],
            [-57.324171, -25.201092],
            [-57.353069, -25.207975],
            [-57.373973, -25.206853],
            [-57.402491, -25.182251],
            [-57.398983, -25.170773],
            [-57.427015, -25.149884],
            [-57.437008, -25.129088],
            [-57.474415, -25.114231],
            [-57.478317, -25.103693],
            [-57.456977, -25.104586],
            [-57.440162, -25.096261],
            [-57.399767, -25.061616],
            [-57.385737, -25.066408]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "EMBOSCADA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.945256, -25.238892],
            [-56.941108, -25.288226],
            [-56.9461, -25.297064],
            [-56.927592, -25.311072],
            [-56.914775, -25.336378],
            [-56.878003, -25.360796],
            [-56.897122, -25.368594],
            [-56.875183, -25.387608],
            [-56.864062, -25.403776],
            [-56.868863, -25.418948],
            [-56.900499, -25.417857],
            [-56.908254, -25.438027],
            [-56.926296, -25.4562],
            [-56.947143, -25.460725],
            [-56.971998, -25.466238],
            [-56.989993, -25.444183],
            [-57.035365, -25.425128],
            [-57.037167, -25.376095],
            [-57.05945, -25.378636],
            [-57.060722, -25.359527],
            [-57.069728, -25.344201],
            [-57.065115, -25.333867],
            [-57.045162, -25.319231],
            [-57.022988, -25.309782],
            [-57.018776, -25.277499],
            [-57.022849, -25.264358],
            [-57.011921, -25.246623],
            [-56.967236, -25.248946],
            [-56.945256, -25.238892]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "EUSEBIO AYALA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.90326, -25.241194],
            [-56.906197, -25.253367],
            [-56.882632, -25.25958],
            [-56.887586, -25.277589],
            [-56.850788, -25.315168],
            [-56.831412, -25.318833],
            [-56.837913, -25.336995],
            [-56.835826, -25.354698],
            [-56.860264, -25.367381],
            [-56.878003, -25.360796],
            [-56.914775, -25.336378],
            [-56.927592, -25.311072],
            [-56.9461, -25.297064],
            [-56.941108, -25.288226],
            [-56.945256, -25.238892],
            [-56.942515, -25.220557],
            [-56.90326, -25.241194]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "ISLA PUCÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.860264, -25.367381],
            [-56.833997, -25.374896],
            [-56.831585, -25.403433],
            [-56.833505, -25.439068],
            [-56.80705, -25.437921],
            [-56.793364, -25.443516],
            [-56.773974, -25.4649],
            [-56.805761, -25.482386],
            [-56.807155, -25.49019],
            [-56.833765, -25.496335],
            [-56.851227, -25.507642],
            [-56.927, -25.508377],
            [-56.928506, -25.477141],
            [-56.947143, -25.460725],
            [-56.926296, -25.4562],
            [-56.908254, -25.438027],
            [-56.900499, -25.417857],
            [-56.868863, -25.418948],
            [-56.864062, -25.403776],
            [-56.875183, -25.387608],
            [-56.897122, -25.368594],
            [-56.878003, -25.360796],
            [-56.860264, -25.367381]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "ITACURUBÍ DE LA CORDILLERA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.684737, -24.868785],
            [-56.633632, -24.957785],
            [-56.603446, -24.986135],
            [-56.580853, -24.988209],
            [-56.564484, -24.997337],
            [-56.564242, -25.011932],
            [-56.56168, -25.166074],
            [-56.619033, -25.166777],
            [-56.645493, -25.152],
            [-56.750842, -25.109113],
            [-56.776604, -25.098609],
            [-56.837437, -25.050275],
            [-56.858994, -25.045958],
            [-56.876037, -25.033036],
            [-56.910611, -25.029028],
            [-56.929577, -25.021493],
            [-56.95923, -25.023378],
            [-57.009232, -25.013016],
            [-57.018101, -25.020104],
            [-57.039551, -25.00407],
            [-57.048962, -24.984312],
            [-57.030568, -24.977489],
            [-57.015346, -24.965914],
            [-57.004552, -24.942307],
            [-56.989293, -24.922646],
            [-56.980249, -24.896666],
            [-56.983023, -24.878519],
            [-56.954112, -24.863688],
            [-56.949319, -24.843279],
            [-56.860323, -24.875747],
            [-56.842861, -24.877233],
            [-56.812222, -24.868367],
            [-56.767447, -24.866964],
            [-56.749103, -24.873426],
            [-56.735332, -24.889018],
            [-56.720094, -24.888079],
            [-56.708214, -24.876302],
            [-56.689171, -24.878729],
            [-56.684737, -24.868785]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "JUAN DE MENA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.151008, -25.129589],
            [-57.151144, -25.129624],
            [-57.169169, -25.144912],
            [-57.19826, -25.19506],
            [-57.214592, -25.20801],
            [-57.249927, -25.208582],
            [-57.266827, -25.213439],
            [-57.255491, -25.197592],
            [-57.243847, -25.16678],
            [-57.234251, -25.158198],
            [-57.236292, -25.124325],
            [-57.222455, -25.100536],
            [-57.225015, -25.090607],
            [-57.194949, -25.086044],
            [-57.169975, -25.11636],
            [-57.151008, -25.129589]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "LOMA GRANDE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.66345, -25.26199],
            [-56.645915, -25.293723],
            [-56.623161, -25.313496],
            [-56.606851, -25.314133],
            [-56.561362, -25.306111],
            [-56.651069, -25.397533],
            [-56.672973, -25.413865],
            [-56.722019, -25.435117],
            [-56.728181, -25.379726],
            [-56.73445, -25.360994],
            [-56.748466, -25.34604],
            [-56.747107, -25.327157],
            [-56.757427, -25.299846],
            [-56.766357, -25.258608],
            [-56.763308, -25.242831],
            [-56.774754, -25.218971],
            [-56.763643, -25.194932],
            [-56.746866, -25.209471],
            [-56.724055, -25.214366],
            [-56.714671, -25.2276],
            [-56.712253, -25.246217],
            [-56.69558, -25.241993],
            [-56.681537, -25.254945],
            [-56.66345, -25.26199]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "MBOCAYATY DEL YHAGUY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.225015, -25.090607],
            [-57.222455, -25.100536],
            [-57.236292, -25.124325],
            [-57.234251, -25.158198],
            [-57.243847, -25.16678],
            [-57.255491, -25.197592],
            [-57.266827, -25.213439],
            [-57.299978, -25.231472],
            [-57.306974, -25.214991],
            [-57.324171, -25.201092],
            [-57.320735, -25.184803],
            [-57.272796, -25.117082],
            [-57.278465, -25.093516],
            [-57.258432, -25.085441],
            [-57.225015, -25.090607]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "NUEVA COLOMBIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.947143, -25.460725],
            [-56.928506, -25.477141],
            [-56.927, -25.508377],
            [-56.965982, -25.529797],
            [-56.980261, -25.547324],
            [-56.970803, -25.570088],
            [-56.99186, -25.571449],
            [-57.020082, -25.590981],
            [-57.034121, -25.59176],
            [-57.063751, -25.578507],
            [-57.081853, -25.583342],
            [-57.110919, -25.546847],
            [-57.129893, -25.527532],
            [-57.126355, -25.522925],
            [-57.137315, -25.480454],
            [-57.131784, -25.455691],
            [-57.119071, -25.450818],
            [-57.11425, -25.429153],
            [-57.094805, -25.422755],
            [-57.069642, -25.399854],
            [-57.05945, -25.378636],
            [-57.037167, -25.376095],
            [-57.035365, -25.425128],
            [-56.989993, -25.444183],
            [-56.971998, -25.466238],
            [-56.947143, -25.460725]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "PIRIBEBUY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.950905, -25.10419],
            [-56.934867, -25.124322],
            [-56.90864, -25.134064],
            [-56.928164, -25.163114],
            [-56.947905, -25.211755],
            [-56.958432, -25.196852],
            [-56.975814, -25.190009],
            [-56.963666, -25.172318],
            [-56.981572, -25.157556],
            [-56.985192, -25.132464],
            [-57.026603, -25.097273],
            [-57.042431, -25.0711],
            [-57.026115, -25.059871],
            [-57.017805, -25.069743],
            [-56.971995, -25.075856],
            [-56.950905, -25.10419]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "PRIMERO DE MARZO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.299978, -25.231472],
            [-57.263685, -25.286552],
            [-57.247358, -25.317479],
            [-57.219913, -25.329638],
            [-57.212768, -25.355857],
            [-57.233732, -25.366863],
            [-57.249129, -25.36001],
            [-57.268985, -25.363683],
            [-57.296262, -25.353491],
            [-57.307335, -25.338426],
            [-57.33426, -25.311098],
            [-57.343299, -25.294015],
            [-57.341868, -25.276037],
            [-57.32854, -25.24872],
            [-57.337494, -25.232155],
            [-57.349818, -25.227507],
            [-57.373973, -25.206853],
            [-57.353069, -25.207975],
            [-57.324171, -25.201092],
            [-57.306974, -25.214991],
            [-57.299978, -25.231472]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "SAN BERNARDINO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.722019, -25.435117],
            [-56.773974, -25.4649],
            [-56.793364, -25.443516],
            [-56.80705, -25.437921],
            [-56.833505, -25.439068],
            [-56.831585, -25.403433],
            [-56.833997, -25.374896],
            [-56.860264, -25.367381],
            [-56.835826, -25.354698],
            [-56.820418, -25.354766],
            [-56.802284, -25.343549],
            [-56.747107, -25.327157],
            [-56.748466, -25.34604],
            [-56.73445, -25.360994],
            [-56.728181, -25.379726],
            [-56.722019, -25.435117]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "SANTA ELENA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.947905, -25.211755],
            [-56.942515, -25.220557],
            [-56.945256, -25.238892],
            [-56.967236, -25.248946],
            [-57.011921, -25.246623],
            [-57.022849, -25.264358],
            [-57.018776, -25.277499],
            [-57.022988, -25.309782],
            [-57.045162, -25.319231],
            [-57.065115, -25.333867],
            [-57.084703, -25.313544],
            [-57.110894, -25.311381],
            [-57.129629, -25.304682],
            [-57.130636, -25.259891],
            [-57.097746, -25.211854],
            [-57.111367, -25.196605],
            [-57.120731, -25.154212],
            [-57.131001, -25.141248],
            [-57.106956, -25.145227],
            [-57.033295, -25.119491],
            [-57.026603, -25.097273],
            [-56.985192, -25.132464],
            [-56.981572, -25.157556],
            [-56.963666, -25.172318],
            [-56.975814, -25.190009],
            [-56.958432, -25.196852],
            [-56.947905, -25.211755]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "TOBATÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.719684, -25.658716],
            [-56.726762, -25.663172],
            [-56.758342, -25.64924],
            [-56.780875, -25.631974],
            [-56.810808, -25.625527],
            [-56.823447, -25.64317],
            [-56.83725, -25.6493],
            [-56.857589, -25.646702],
            [-56.862565, -25.662256],
            [-56.892445, -25.668163],
            [-56.945308, -25.651621],
            [-56.914166, -25.590966],
            [-56.917328, -25.564044],
            [-56.934632, -25.569024],
            [-56.94635, -25.561904],
            [-56.970803, -25.570088],
            [-56.980261, -25.547324],
            [-56.965982, -25.529797],
            [-56.927, -25.508377],
            [-56.851227, -25.507642],
            [-56.853035, -25.535367],
            [-56.834052, -25.533499],
            [-56.83124, -25.544237],
            [-56.802286, -25.582017],
            [-56.719684, -25.658716]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "VALENZUELA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.750842, -25.109113],
            [-56.808816, -25.121432],
            [-56.828545, -25.144327],
            [-56.849557, -25.134542],
            [-56.862969, -25.135901],
            [-56.874201, -25.176305],
            [-56.894341, -25.204543],
            [-56.893683, -25.218333],
            [-56.90326, -25.241194],
            [-56.942515, -25.220557],
            [-56.947905, -25.211755],
            [-56.928164, -25.163114],
            [-56.90864, -25.134064],
            [-56.934867, -25.124322],
            [-56.950905, -25.10419],
            [-56.910611, -25.029028],
            [-56.876037, -25.033036],
            [-56.858994, -25.045958],
            [-56.837437, -25.050275],
            [-56.776604, -25.098609],
            [-56.750842, -25.109113]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CORDILLERA",
        "dist_desc_": "SAN JOSÉ OBRERO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.456667, -25.731081],
            [-56.426079, -25.75069],
            [-56.398212, -25.758768],
            [-56.35362, -25.776812],
            [-56.335607, -25.79698],
            [-56.313834, -25.779691],
            [-56.279545, -25.80959],
            [-56.276798, -25.844823],
            [-56.289907, -25.874771],
            [-56.339091, -25.878276],
            [-56.353574, -25.8958],
            [-56.363888, -25.893781],
            [-56.389069, -25.898997],
            [-56.429083, -25.919062],
            [-56.454944, -25.897856],
            [-56.454695, -25.885918],
            [-56.489932, -25.879995],
            [-56.49403, -25.888536],
            [-56.488732, -25.914647],
            [-56.520348, -25.914255],
            [-56.536435, -25.895141],
            [-56.50706, -25.868939],
            [-56.513834, -25.84752],
            [-56.495395, -25.817183],
            [-56.50084, -25.796304],
            [-56.49962, -25.773382],
            [-56.477711, -25.754049],
            [-56.478512, -25.722013],
            [-56.456667, -25.731081]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "VILLARRICA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.536435, -25.895141],
            [-56.520348, -25.914255],
            [-56.488732, -25.914647],
            [-56.482626, -25.925743],
            [-56.486807, -25.94632],
            [-56.464526, -25.969578],
            [-56.486314, -26.017519],
            [-56.505011, -26.036038],
            [-56.543319, -26.034095],
            [-56.570012, -26.03846],
            [-56.571444, -26.098256],
            [-56.615798, -26.176472],
            [-56.629165, -26.194631],
            [-56.632747, -26.187327],
            [-56.673423, -26.166968],
            [-56.703753, -26.147234],
            [-56.711758, -26.130117],
            [-56.70579, -26.108989],
            [-56.721934, -26.091607],
            [-56.701791, -26.04464],
            [-56.705464, -26.0275],
            [-56.720967, -25.998364],
            [-56.726172, -25.979917],
            [-56.73702, -25.972646],
            [-56.747588, -25.951921],
            [-56.697863, -25.964883],
            [-56.676833, -25.96265],
            [-56.666061, -25.970483],
            [-56.641556, -25.968454],
            [-56.607639, -25.978275],
            [-56.607719, -25.940555],
            [-56.578641, -25.950614],
            [-56.570295, -25.940105],
            [-56.572526, -25.919452],
            [-56.536435, -25.895141]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "BORJA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.292163, -25.569038],
            [-56.287292, -25.585336],
            [-56.256065, -25.578322],
            [-56.231182, -25.580266],
            [-56.205938, -25.576799],
            [-56.154692, -25.599507],
            [-56.120886, -25.607682],
            [-56.059975, -25.622427],
            [-55.943138, -25.626837],
            [-55.957751, -25.628321],
            [-56.010383, -25.67583],
            [-56.029605, -25.661656],
            [-56.062358, -25.656629],
            [-56.068363, -25.641462],
            [-56.079848, -25.640135],
            [-56.098325, -25.653406],
            [-56.118748, -25.658276],
            [-56.142035, -25.638003],
            [-56.158874, -25.640015],
            [-56.178953, -25.632337],
            [-56.200575, -25.638236],
            [-56.213856, -25.648092],
            [-56.225132, -25.628485],
            [-56.237711, -25.624136],
            [-56.265233, -25.640926],
            [-56.280866, -25.633558],
            [-56.302515, -25.632514],
            [-56.306189, -25.56874],
            [-56.292163, -25.569038]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "CAPITÁN MAURICIO JOSÉ TROCHE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.584448, -25.662496],
            [-56.571677, -25.735996],
            [-56.559047, -25.749938],
            [-56.536828, -25.762015],
            [-56.52517, -25.774625],
            [-56.556929, -25.801721],
            [-56.577453, -25.799518],
            [-56.585894, -25.807954],
            [-56.618632, -25.805067],
            [-56.622671, -25.779971],
            [-56.64279, -25.770525],
            [-56.655783, -25.751806],
            [-56.65676, -25.717481],
            [-56.662314, -25.706708],
            [-56.648903, -25.686064],
            [-56.625624, -25.676376],
            [-56.609438, -25.678555],
            [-56.584448, -25.662496]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "CORONEL MARTÍNEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.010065, -26.788324],
            [-55.053897, -26.798339],
            [-55.068199, -26.807883],
            [-55.084487, -26.829966],
            [-55.119354, -26.847457],
            [-55.1396, -26.864142],
            [-55.146681, -26.878925],
            [-55.171043, -26.873767],
            [-55.189743, -26.837794],
            [-55.184571, -26.813431],
            [-55.206123, -26.818719],
            [-55.224, -26.793969],
            [-55.210708, -26.780954],
            [-55.196382, -26.783576],
            [-55.180552, -26.771673],
            [-55.194361, -26.759874],
            [-55.190799, -26.737008],
            [-55.207571, -26.724731],
            [-55.213617, -26.705202],
            [-55.238647, -26.714602],
            [-55.249169, -26.704834],
            [-55.220572, -26.689343],
            [-55.222948, -26.671699],
            [-55.241679, -26.650337],
            [-55.236842, -26.623143],
            [-55.209707, -26.603667],
            [-55.18849, -26.604555],
            [-55.157684, -26.599204],
            [-55.138916, -26.614611],
            [-55.118764, -26.615411],
            [-55.110888, -26.627596],
            [-55.109849, -26.671963],
            [-55.096929, -26.701599],
            [-55.05556, -26.71413],
            [-55.037185, -26.742706],
            [-55.018965, -26.741468],
            [-54.999281, -26.770688],
            [-55.010065, -26.788324]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "NATALIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.023823, -26.97842],
            [-55.997271, -26.99884],
            [-55.987018, -26.989745],
            [-55.885537, -27.081464],
            [-55.903694, -27.092549],
            [-55.923001, -27.112599],
            [-55.926239, -27.134262],
            [-55.932225, -27.145562],
            [-55.948289, -27.148859],
            [-55.96101, -27.172632],
            [-55.973999, -27.172694],
            [-55.993186, -27.189335],
            [-56.12883, -27.069365],
            [-56.116024, -27.05183],
            [-56.117491, -27.01366],
            [-56.077882, -26.988765],
            [-56.047847, -26.974603],
            [-56.023823, -26.97842]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "FRAM"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.367068, -27.026986],
            [-58.360949, -27.035023],
            [-58.374123, -27.073871],
            [-58.387952, -27.07085],
            [-58.400158, -27.153292],
            [-58.41731, -27.156237],
            [-58.48299, -27.167049],
            [-58.498697, -27.15849],
            [-58.507806, -27.164873],
            [-58.540708, -27.161752],
            [-58.567273, -27.182015],
            [-58.645827, -27.196756],
            [-58.659632, -27.187018],
            [-58.664337, -27.16555],
            [-58.651705, -27.133666],
            [-58.640855, -27.122069],
            [-58.617717, -27.112715],
            [-58.558522, -27.107795],
            [-58.55721, -27.038096],
            [-58.531056, -27.037528],
            [-58.508983, -27.062489],
            [-58.502949, -27.034635],
            [-58.478723, -27.028855],
            [-58.452276, -27.029462],
            [-58.439558, -27.018513],
            [-58.428914, -27.035113],
            [-58.410561, -27.040374],
            [-58.388225, -27.02354],
            [-58.367068, -27.026986]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "HUMAITÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.105601, -27.019521],
            [-58.146167, -27.041413],
            [-58.203843, -27.060879],
            [-58.255656, -27.055887],
            [-58.307461, -27.050896],
            [-58.322418, -27.029313],
            [-58.367068, -27.026986],
            [-58.388225, -27.02354],
            [-58.410561, -27.040374],
            [-58.428914, -27.035113],
            [-58.439558, -27.018513],
            [-58.452276, -27.029462],
            [-58.478723, -27.028855],
            [-58.502949, -27.034635],
            [-58.517762, -27.012628],
            [-58.501764, -26.996602],
            [-58.470904, -26.998444],
            [-58.469315, -26.983032],
            [-58.500826, -26.929698],
            [-58.49435, -26.9228],
            [-58.463634, -26.930338],
            [-58.397771, -26.896372],
            [-58.385315, -26.892457],
            [-58.255319, -26.908945],
            [-58.239261, -26.896946],
            [-58.22283, -26.899752],
            [-58.217385, -26.912534],
            [-58.197001, -26.924869],
            [-58.188191, -26.938877],
            [-58.176731, -26.981479],
            [-58.157452, -26.981445],
            [-58.151102, -27.002445],
            [-58.105601, -27.019521]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "ISLA UMBÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.447622, -24.307897],
            [-54.447858, -24.307814],
            [-54.478352, -24.320633],
            [-54.498803, -24.334191],
            [-54.490005, -24.354397],
            [-54.459086, -24.379668],
            [-54.46433, -24.390279],
            [-54.49758, -24.401217],
            [-54.579236, -24.384045],
            [-54.602587, -24.368068],
            [-54.603027, -24.332665],
            [-54.594873, -24.313296],
            [-54.593997, -24.290972],
            [-54.581753, -24.277613],
            [-54.588979, -24.268115],
            [-54.615599, -24.198306],
            [-54.653665, -24.132093],
            [-54.683915, -24.089513],
            [-54.698781, -24.058164],
            [-54.706105, -24.021181],
            [-54.700788, -23.992191],
            [-54.69093, -23.974471],
            [-54.643093, -23.965104],
            [-54.606441, -23.976371],
            [-54.612294, -24.008076],
            [-54.606048, -24.019601],
            [-54.608105, -24.042657],
            [-54.542864, -24.0931],
            [-54.541234, -24.118723],
            [-54.530147, -24.133402],
            [-54.542937, -24.147094],
            [-54.458165, -24.211783],
            [-54.42686, -24.217072],
            [-54.41281, -24.233663],
            [-54.421572, -24.245396],
            [-54.421087, -24.27725],
            [-54.447622, -24.307897]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "LA PALOMA DEL ESPÍRITU SANTO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.712784, -24.466358],
            [-54.696262, -24.49729],
            [-54.672339, -24.495375],
            [-54.648225, -24.499731],
            [-54.625611, -24.513783],
            [-54.612566, -24.513437],
            [-54.6119, -24.513576],
            [-54.590618, -24.525721],
            [-54.568911, -24.5254],
            [-54.553883, -24.536435],
            [-54.544408, -24.531095],
            [-54.528989, -24.500552],
            [-54.514831, -24.51625],
            [-54.478974, -24.529503],
            [-54.471294, -24.519171],
            [-54.451739, -24.52495],
            [-54.4263, -24.520206],
            [-54.403721, -24.526962],
            [-54.388003, -24.514849],
            [-54.337188, -24.529039],
            [-54.317429, -24.579943],
            [-54.316512, -24.612469],
            [-54.330034, -24.687963],
            [-54.345807, -24.70766],
            [-54.388422, -24.6878],
            [-54.401625, -24.690621],
            [-54.414963, -24.679505],
            [-54.425065, -24.698939],
            [-54.442937, -24.698474],
            [-54.443583, -24.718126],
            [-54.472163, -24.7234],
            [-54.476453, -24.706886],
            [-54.499098, -24.719593],
            [-54.504421, -24.698763],
            [-54.525297, -24.703708],
            [-54.536398, -24.691861],
            [-54.559952, -24.689375],
            [-54.610266, -24.696964],
            [-54.615111, -24.707076],
            [-54.657861, -24.699844],
            [-54.648169, -24.686923],
            [-54.654124, -24.668356],
            [-54.68304, -24.671952],
            [-54.687385, -24.688325],
            [-54.72046, -24.67641],
            [-54.737933, -24.651919],
            [-54.751686, -24.660109],
            [-54.778602, -24.651542],
            [-54.785245, -24.665315],
            [-54.810644, -24.673316],
            [-54.871519, -24.633855],
            [-54.898908, -24.629243],
            [-54.903853, -24.598787],
            [-54.911696, -24.576463],
            [-54.943617, -24.564523],
            [-54.955096, -24.567317],
            [-54.97138, -24.567716],
            [-54.989176, -24.550463],
            [-55.016638, -24.549184],
            [-55.018011, -24.527859],
            [-55.027833, -24.506327],
            [-55.014787, -24.485484],
            [-54.963658, -24.454144],
            [-54.958574, -24.447323],
            [-54.712784, -24.466358]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "NUEVA ESPERANZA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.938791, -24.372457],
            [-55.924184, -24.369996],
            [-55.8976, -24.386528],
            [-55.871485, -24.396627],
            [-55.861381, -24.421495],
            [-55.863683, -24.434938],
            [-55.827921, -24.468732],
            [-55.797316, -24.479787],
            [-55.776825, -24.509175],
            [-55.774658, -24.52585],
            [-55.758221, -24.535527],
            [-55.756564, -24.562266],
            [-55.749205, -24.571361],
            [-55.767042, -24.588372],
            [-55.764637, -24.618531],
            [-55.75262, -24.637621],
            [-55.762171, -24.656149],
            [-55.727095, -24.72135],
            [-55.736106, -24.743189],
            [-55.718269, -24.758095],
            [-55.701991, -24.78397],
            [-55.750717, -24.776921],
            [-55.759969, -24.782908],
            [-55.783129, -24.781929],
            [-55.821896, -24.77385],
            [-55.839619, -24.761879],
            [-55.844395, -24.731452],
            [-55.853028, -24.721531],
            [-55.859494, -24.697307],
            [-55.88023, -24.672427],
            [-55.913896, -24.660447],
            [-55.935421, -24.623431],
            [-55.944019, -24.619265],
            [-55.940481, -24.57057],
            [-55.945353, -24.562912],
            [-55.976541, -24.543285],
            [-55.98744, -24.531236],
            [-55.994696, -24.501697],
            [-56.012788, -24.482667],
            [-56.024048, -24.444144],
            [-56.052429, -24.421554],
            [-56.057731, -24.403086],
            [-56.024464, -24.394777],
            [-56.00945, -24.398716],
            [-55.991671, -24.378726],
            [-55.95659, -24.367014],
            [-55.938791, -24.372457]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "YASY CAÑY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.921589, -24.347711],
            [-54.933543, -24.363009],
            [-54.954066, -24.374045],
            [-54.957234, -24.405099],
            [-54.95393, -24.419589],
            [-54.961605, -24.432792],
            [-54.958574, -24.447323],
            [-54.963658, -24.454144],
            [-55.014787, -24.485484],
            [-55.027833, -24.506327],
            [-55.018011, -24.527859],
            [-55.016638, -24.549184],
            [-55.031299, -24.54437],
            [-55.054886, -24.551203],
            [-55.102954, -24.543704],
            [-55.112865, -24.536628],
            [-55.113647, -24.505702],
            [-55.134036, -24.479881],
            [-55.154635, -24.479057],
            [-55.1803, -24.465456],
            [-55.210568, -24.468604],
            [-55.238953, -24.475998],
            [-55.252526, -24.467507],
            [-55.272355, -24.49292],
            [-55.304158, -24.493571],
            [-55.310341, -24.511868],
            [-55.322406, -24.478439],
            [-55.333374, -24.460944],
            [-55.322082, -24.433312],
            [-55.326016, -24.410683],
            [-55.342097, -24.391424],
            [-55.373024, -24.374238],
            [-55.360012, -24.359492],
            [-55.316531, -24.353547],
            [-55.288388, -24.36366],
            [-55.257607, -24.365008],
            [-55.244879, -24.353588],
            [-55.230193, -24.352034],
            [-55.223375, -24.34058],
            [-55.195278, -24.32512],
            [-55.184395, -24.312591],
            [-55.192451, -24.268784],
            [-55.209532, -24.252207],
            [-55.208658, -24.241852],
            [-55.177824, -24.229017],
            [-55.161325, -24.191926],
            [-55.175846, -24.157831],
            [-55.17744, -24.143133],
            [-55.160378, -24.137049],
            [-55.144614, -24.112129],
            [-55.127058, -24.120383],
            [-55.120535, -24.136099],
            [-55.084661, -24.14],
            [-55.076625, -24.134979],
            [-55.051543, -24.137316],
            [-55.038671, -24.144622],
            [-55.032483, -24.165358],
            [-55.004534, -24.176542],
            [-54.994632, -24.247257],
            [-54.996289, -24.272978],
            [-54.98287, -24.286578],
            [-54.983614, -24.299751],
            [-54.941163, -24.327556],
            [-54.921589, -24.347711]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "YBYRAROBANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.690801, -25.100726],
            [-57.736476, -25.097113],
            [-57.760693, -25.102492],
            [-57.766155, -25.086191],
            [-57.784006, -25.066257],
            [-57.815753, -25.064903],
            [-57.815257, -24.946246],
            [-57.914972, -24.946696],
            [-57.915458, -24.839357],
            [-57.955497, -24.840741],
            [-57.955039, -24.852022],
            [-58.032039, -24.85068],
            [-58.114375, -24.825761],
            [-58.113881, -24.746055],
            [-58.121295, -24.703918],
            [-58.17192, -24.70122],
            [-58.259736, -24.702341],
            [-58.322056, -24.701439],
            [-58.479784, -24.689553],
            [-58.487746, -24.651636],
            [-58.511136, -24.450709],
            [-58.531788, -24.272547],
            [-58.717981, -24.114743],
            [-58.712062, -23.808446],
            [-58.700311, -23.802064],
            [-58.683166, -23.822584],
            [-58.66544, -23.82031],
            [-58.635262, -23.829311],
            [-58.617633, -23.828217],
            [-58.576506, -23.840757],
            [-58.556196, -23.830929],
            [-58.532747, -23.84212],
            [-58.49807, -23.864732],
            [-58.48321, -23.865825],
            [-58.472417, -23.877561],
            [-58.450801, -23.883101],
            [-58.44799, -23.894518],
            [-58.428795, -23.888525],
            [-58.415508, -23.892539],
            [-58.395416, -23.880166],
            [-58.381006, -23.85864],
            [-58.359735, -23.857115],
            [-58.335411, -23.866198],
            [-58.321843, -23.858589],
            [-58.280378, -23.858749],
            [-58.242387, -23.837026],
            [-58.226449, -23.849072],
            [-58.190344, -23.847985],
            [-58.178672, -23.870231],
            [-58.152128, -23.881145],
            [-58.15022, -23.901016],
            [-58.132074, -23.891604],
            [-58.096503, -23.896834],
            [-58.062193, -23.888649],
            [-58.047111, -23.873866],
            [-58.030044, -23.879377],
            [-57.967376, -23.857035],
            [-57.948844, -23.845375],
            [-57.918908, -23.85447],
            [-57.906309, -23.845833],
            [-57.865583, -23.854347],
            [-57.84557, -23.836879],
            [-57.829995, -23.833094],
            [-57.823616, -23.821666],
            [-57.784158, -23.817581],
            [-57.796767, -24.219176],
            [-57.795218, -24.24376],
            [-57.706457, -24.252312],
            [-57.685669, -24.261596],
            [-57.6801, -24.274382],
            [-57.655163, -24.271302],
            [-57.637158, -24.285682],
            [-57.603817, -24.292269],
            [-57.587975, -24.304462],
            [-57.563788, -24.301935],
            [-57.562869, -24.32921],
            [-57.544303, -24.373207],
            [-57.494531, -24.700068],
            [-57.416807, -24.868048],
            [-57.417168, -24.97559],
            [-57.47928, -24.975566],
            [-57.480898, -25.009426],
            [-57.518798, -25.03829],
            [-57.550628, -25.051723],
            [-57.550928, -25.060047],
            [-57.590018, -25.068962],
            [-57.690801, -25.100726]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "BENJAMÍN ACEVAL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.85573, -22.397713],
            [-57.864481, -22.403069],
            [-57.862, -22.423963],
            [-57.840531, -22.443855],
            [-57.844475, -22.487727],
            [-57.830876, -22.513493],
            [-57.827744, -22.570731],
            [-57.804785, -22.592152],
            [-57.779917, -22.622618],
            [-57.772888, -22.639449],
            [-57.776803, -22.661268],
            [-57.789976, -22.663873],
            [-57.829701, -22.652846],
            [-57.848425, -22.651732],
            [-57.909428, -22.659125],
            [-57.937445, -22.688967],
            [-57.940248, -22.708272],
            [-57.925789, -22.743273],
            [-57.890147, -22.755891],
            [-57.877433, -22.773711],
            [-57.882556, -22.793939],
            [-57.875318, -22.80298],
            [-57.840264, -22.807997],
            [-57.811439, -22.817369],
            [-57.789507, -22.877517],
            [-57.798432, -22.892743],
            [-57.818284, -22.90415],
            [-57.821375, -22.914974],
            [-57.789877, -22.941428],
            [-57.767394, -22.965291],
            [-57.765863, -22.976363],
            [-57.784939, -23.006277],
            [-57.786599, -23.032143],
            [-57.767183, -23.035906],
            [-57.731485, -23.059845],
            [-57.725078, -23.078884],
            [-57.70176, -23.097241],
            [-57.667017, -23.094004],
            [-57.676761, -23.1154],
            [-57.704197, -23.121804],
            [-57.719898, -23.106912],
            [-57.744794, -23.100777],
            [-57.746125, -23.089394],
            [-57.766928, -23.076683],
            [-57.767876, -23.096221],
            [-57.786884, -23.107148],
            [-57.790405, -23.123347],
            [-57.83076, -23.131665],
            [-57.839002, -23.162946],
            [-57.827875, -23.183735],
            [-57.837173, -23.208884],
            [-57.856996, -23.200357],
            [-57.881562, -23.19633],
            [-57.905297, -23.219173],
            [-57.9315, -23.219664],
            [-57.954297, -23.240929],
            [-57.970785, -23.240643],
            [-57.987952, -23.229569],
            [-57.997516, -23.239257],
            [-57.986056, -23.251403],
            [-58.023003, -23.259215],
            [-58.060443, -23.251306],
            [-58.071693, -23.262176],
            [-58.090489, -23.260797],
            [-58.102504, -23.267934],
            [-58.114804, -23.291683],
            [-58.151088, -23.297936],
            [-58.15448, -23.312254],
            [-58.195112, -23.345225],
            [-58.219982, -23.35941],
            [-58.236044, -23.335506],
            [-58.264016, -23.329081],
            [-58.291375, -23.332722],
            [-58.295443, -23.340996],
            [-58.327354, -23.358789],
            [-58.34068, -23.354179],
            [-58.349214, -23.337195],
            [-58.381154, -23.342362],
            [-58.413703, -23.360397],
            [-58.483768, -23.326472],
            [-58.498446, -23.330353],
            [-58.516738, -23.311292],
            [-58.55307, -23.313511],
            [-58.561349, -23.321787],
            [-58.606013, -23.301025],
            [-58.605561, -23.290855],
            [-58.628783, -23.271554],
            [-58.63156, -23.245669],
            [-58.652885, -23.244427],
            [-58.679533, -23.250434],
            [-58.703081, -23.2619],
            [-58.722345, -23.262032],
            [-58.754896, -23.245455],
            [-58.770773, -23.245264],
            [-58.778376, -23.226426],
            [-58.795179, -23.220933],
            [-58.80758, -23.226185],
            [-58.83466, -23.213253],
            [-58.847581, -23.21441],
            [-58.897964, -23.232291],
            [-58.926921, -23.223884],
            [-58.938551, -23.20788],
            [-58.966364, -23.189774],
            [-58.97637, -23.171238],
            [-58.997821, -23.17618],
            [-59.018176, -23.171364],
            [-59.026977, -23.182973],
            [-59.064637, -23.2013],
            [-59.096653, -23.204566],
            [-59.102767, -23.217472],
            [-59.139808, -23.206743],
            [-59.157962, -23.197048],
            [-59.173485, -23.216258],
            [-59.186542, -23.217517],
            [-59.196426, -23.193838],
            [-59.235589, -23.075203],
            [-59.246939, -23.062425],
            [-59.168664, -22.986474],
            [-59.15637, -22.986809],
            [-59.137518, -22.925649],
            [-59.142901, -22.883794],
            [-59.149494, -22.878035],
            [-59.147497, -22.838067],
            [-59.154832, -22.787531],
            [-59.143386, -22.750232],
            [-59.121189, -22.740231],
            [-59.12266, -22.694843],
            [-59.083941, -22.663238],
            [-59.063904, -22.669205],
            [-59.052692, -22.646782],
            [-59.053787, -22.633602],
            [-59.019271, -22.62812],
            [-59.001127, -22.620245],
            [-58.963786, -22.614435],
            [-58.941243, -22.605237],
            [-58.90549, -22.620673],
            [-58.895668, -22.619978],
            [-58.887053, -22.601147],
            [-58.852064, -22.605185],
            [-59.011047, -22.426495],
            [-59.00383, -22.414422],
            [-58.985812, -22.410956],
            [-59.093743, -22.261814],
            [-59.09552, -22.250192],
            [-59.113629, -22.229344],
            [-59.128575, -22.224641],
            [-59.128159, -22.211538],
            [-59.149384, -22.215721],
            [-59.162257, -22.203324],
            [-59.192965, -22.203379],
            [-59.20287, -22.188339],
            [-59.223061, -22.185362],
            [-59.235273, -22.2],
            [-59.285183, -22.190854],
            [-59.241225, -22.132108],
            [-59.201595, -22.147866],
            [-59.018355, -22.150072],
            [-58.985425, -22.159613],
            [-58.962615, -22.150356],
            [-58.856872, -22.151179],
            [-58.845213, -22.156471],
            [-58.752591, -22.157357],
            [-58.737136, -22.152462],
            [-58.459693, -22.156769],
            [-58.452149, -22.163699],
            [-58.396747, -22.178969],
            [-58.26688, -22.179487],
            [-58.241671, -22.189903],
            [-58.245549, -22.240463],
            [-58.202731, -22.282506],
            [-58.185565, -22.349438],
            [-57.85573, -22.397713]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "PUERTO PINASCO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.667017, -23.094004],
            [-57.634178, -23.092942],
            [-57.627693, -23.111368],
            [-57.640887, -23.130492],
            [-57.641181, -23.142112],
            [-57.617982, -23.184036],
            [-57.549047, -23.212022],
            [-57.533063, -23.243891],
            [-57.510067, -23.261699],
            [-57.491586, -23.28276],
            [-57.488802, -23.316407],
            [-57.518329, -23.336076],
            [-57.519999, -23.353219],
            [-57.494602, -23.372686],
            [-57.48782, -23.389018],
            [-57.450781, -23.4468],
            [-57.447033, -23.477583],
            [-57.473517, -23.536198],
            [-57.468284, -23.560286],
            [-57.448108, -23.59987],
            [-57.421153, -23.641253],
            [-57.419096, -23.65374],
            [-57.375754, -23.671087],
            [-57.34319, -23.680226],
            [-57.303242, -23.70765],
            [-57.266484, -23.724657],
            [-57.256661, -23.735966],
            [-57.255742, -23.761376],
            [-57.278042, -23.77159],
            [-57.252724, -23.787087],
            [-57.25148, -23.811903],
            [-57.272685, -23.835046],
            [-57.272881, -23.851539],
            [-57.255301, -23.865982],
            [-57.265197, -23.886024],
            [-57.303044, -23.900664],
            [-57.299219, -23.923999],
            [-57.263052, -23.943976],
            [-57.238152, -23.941788],
            [-57.229763, -23.951756],
            [-57.240829, -23.980716],
            [-57.215403, -23.987555],
            [-57.21133, -24.004546],
            [-57.228504, -24.020382],
            [-57.261963, -24.033534],
            [-57.258296, -24.050593],
            [-57.221674, -24.065833],
            [-57.209106, -24.078374],
            [-57.210619, -24.09775],
            [-57.233107, -24.109672],
            [-57.257588, -24.128726],
            [-57.275877, -24.135491],
            [-57.277024, -24.152374],
            [-57.254348, -24.175924],
            [-57.240561, -24.201047],
            [-57.218837, -24.212017],
            [-57.206265, -24.230844],
            [-57.204586, -24.26132],
            [-57.206462, -24.27594],
            [-57.198583, -24.296633],
            [-57.180308, -24.312634],
            [-57.164042, -24.355937],
            [-57.177552, -24.375919],
            [-57.181411, -24.393309],
            [-57.167715, -24.421707],
            [-57.149308, -24.44898],
            [-57.157995, -24.466646],
            [-57.187103, -24.476981],
            [-57.194061, -24.493401],
            [-57.163638, -24.522844],
            [-57.162167, -24.534117],
            [-57.187958, -24.552788],
            [-57.194797, -24.569149],
            [-57.190109, -24.582187],
            [-57.157441, -24.618256],
            [-57.174728, -24.659764],
            [-57.172417, -24.692456],
            [-57.196238, -24.698261],
            [-57.227118, -24.697197],
            [-57.234583, -24.709879],
            [-57.226572, -24.738273],
            [-57.232066, -24.756792],
            [-57.246369, -24.774159],
            [-57.265434, -24.810102],
            [-57.298504, -24.831286],
            [-57.291723, -24.851466],
            [-57.257468, -24.86014],
            [-57.259757, -24.885631],
            [-57.249341, -24.894825],
            [-57.21967, -24.904729],
            [-57.216592, -24.920651],
            [-57.223572, -24.932765],
            [-57.24383, -24.935],
            [-57.269082, -24.924028],
            [-57.28733, -24.919469],
            [-57.304273, -24.9329],
            [-57.311273, -24.963954],
            [-57.332126, -25.005858],
            [-57.367145, -25.042229],
            [-57.385737, -25.066408],
            [-57.399767, -25.061616],
            [-57.440162, -25.096261],
            [-57.456977, -25.104586],
            [-57.478317, -25.103693],
            [-57.496235, -25.096707],
            [-57.515272, -25.100377],
            [-57.533635, -25.120238],
            [-57.539578, -25.142802],
            [-57.536947, -25.166585],
            [-57.54323, -25.180939],
            [-57.559354, -25.197463],
            [-57.575086, -25.224663],
            [-57.593662, -25.241651],
            [-57.622845, -25.252738],
            [-57.665677, -25.277344],
            [-57.67283, -25.287615],
            [-57.673858, -25.315799],
            [-57.663467, -25.353841],
            [-57.681666, -25.342416],
            [-57.698829, -25.317408],
            [-57.705808, -25.296322],
            [-57.689979, -25.284948],
            [-57.705573, -25.270189],
            [-57.703613, -25.258136],
            [-57.679351, -25.247122],
            [-57.671063, -25.229685],
            [-57.652215, -25.211025],
            [-57.646453, -25.19223],
            [-57.666564, -25.188427],
            [-57.680559, -25.169096],
            [-57.7, -25.163308],
            [-57.717873, -25.164895],
            [-57.724241, -25.141943],
            [-57.685548, -25.141943],
            [-57.683835, -25.107786],
            [-57.690801, -25.100726],
            [-57.590018, -25.068962],
            [-57.550928, -25.060047],
            [-57.550628, -25.051723],
            [-57.518798, -25.03829],
            [-57.480898, -25.009426],
            [-57.47928, -24.975566],
            [-57.417168, -24.97559],
            [-57.416807, -24.868048],
            [-57.494531, -24.700068],
            [-57.544303, -24.373207],
            [-57.562869, -24.32921],
            [-57.563788, -24.301935],
            [-57.587975, -24.304462],
            [-57.603817, -24.292269],
            [-57.637158, -24.285682],
            [-57.655163, -24.271302],
            [-57.6801, -24.274382],
            [-57.685669, -24.261596],
            [-57.706457, -24.252312],
            [-57.795218, -24.24376],
            [-57.796767, -24.219176],
            [-57.784158, -23.817581],
            [-57.823616, -23.821666],
            [-57.829995, -23.833094],
            [-57.84557, -23.836879],
            [-57.865583, -23.854347],
            [-57.906309, -23.845833],
            [-57.918908, -23.85447],
            [-57.948844, -23.845375],
            [-57.967376, -23.857035],
            [-58.030044, -23.879377],
            [-58.047111, -23.873866],
            [-58.062193, -23.888649],
            [-58.096503, -23.896834],
            [-58.132074, -23.891604],
            [-58.15022, -23.901016],
            [-58.152128, -23.881145],
            [-58.178672, -23.870231],
            [-58.190344, -23.847985],
            [-58.226449, -23.849072],
            [-58.242387, -23.837026],
            [-58.280378, -23.858749],
            [-58.321843, -23.858589],
            [-58.335411, -23.866198],
            [-58.359735, -23.857115],
            [-58.381006, -23.85864],
            [-58.395416, -23.880166],
            [-58.415508, -23.892539],
            [-58.428795, -23.888525],
            [-58.44799, -23.894518],
            [-58.450801, -23.883101],
            [-58.472417, -23.877561],
            [-58.48321, -23.865825],
            [-58.49807, -23.864732],
            [-58.532747, -23.84212],
            [-58.556196, -23.830929],
            [-58.576506, -23.840757],
            [-58.617633, -23.828217],
            [-58.635262, -23.829311],
            [-58.66544, -23.82031],
            [-58.683166, -23.822584],
            [-58.700311, -23.802064],
            [-58.712062, -23.808446],
            [-58.728679, -23.795782],
            [-58.745968, -23.797219],
            [-58.766423, -23.785912],
            [-58.83283, -23.770495],
            [-58.836085, -23.76249],
            [-58.876161, -23.761945],
            [-58.900644, -23.752149],
            [-58.969889, -23.743017],
            [-58.974011, -23.731998],
            [-59.010762, -23.728586],
            [-59.023775, -23.720743],
            [-59.092331, -23.701562],
            [-59.131977, -23.731879],
            [-59.143186, -23.729509],
            [-59.200613, -23.59419],
            [-59.077755, -23.570071],
            [-59.080985, -23.558866],
            [-59.121469, -23.505123],
            [-59.142093, -23.510835],
            [-59.169859, -23.49972],
            [-59.190558, -23.48591],
            [-59.175383, -23.443132],
            [-59.255353, -23.453874],
            [-59.288182, -23.423372],
            [-59.303716, -23.400598],
            [-59.331309, -23.398813],
            [-59.343109, -23.409688],
            [-59.370274, -23.411153],
            [-59.395309, -23.384682],
            [-59.408154, -23.376875],
            [-59.410086, -23.346973],
            [-59.417212, -23.336495],
            [-59.414323, -23.290684],
            [-59.38713, -23.147936],
            [-59.262477, -23.074327],
            [-59.246939, -23.062425],
            [-59.235589, -23.075203],
            [-59.196426, -23.193838],
            [-59.186542, -23.217517],
            [-59.173485, -23.216258],
            [-59.157962, -23.197048],
            [-59.139808, -23.206743],
            [-59.102767, -23.217472],
            [-59.096653, -23.204566],
            [-59.064637, -23.2013],
            [-59.026977, -23.182973],
            [-59.018176, -23.171364],
            [-58.997821, -23.17618],
            [-58.97637, -23.171238],
            [-58.966364, -23.189774],
            [-58.938551, -23.20788],
            [-58.926921, -23.223884],
            [-58.897964, -23.232291],
            [-58.847581, -23.21441],
            [-58.83466, -23.213253],
            [-58.80758, -23.226185],
            [-58.795179, -23.220933],
            [-58.778376, -23.226426],
            [-58.770773, -23.245264],
            [-58.754896, -23.245455],
            [-58.722345, -23.262032],
            [-58.703081, -23.2619],
            [-58.679533, -23.250434],
            [-58.652885, -23.244427],
            [-58.63156, -23.245669],
            [-58.628783, -23.271554],
            [-58.605561, -23.290855],
            [-58.606013, -23.301025],
            [-58.561349, -23.321787],
            [-58.55307, -23.313511],
            [-58.516738, -23.311292],
            [-58.498446, -23.330353],
            [-58.483768, -23.326472],
            [-58.413703, -23.360397],
            [-58.381154, -23.342362],
            [-58.349214, -23.337195],
            [-58.34068, -23.354179],
            [-58.327354, -23.358789],
            [-58.295443, -23.340996],
            [-58.291375, -23.332722],
            [-58.264016, -23.329081],
            [-58.236044, -23.335506],
            [-58.219982, -23.35941],
            [-58.195112, -23.345225],
            [-58.15448, -23.312254],
            [-58.151088, -23.297936],
            [-58.114804, -23.291683],
            [-58.102504, -23.267934],
            [-58.090489, -23.260797],
            [-58.071693, -23.262176],
            [-58.060443, -23.251306],
            [-58.023003, -23.259215],
            [-57.986056, -23.251403],
            [-57.997516, -23.239257],
            [-57.987952, -23.229569],
            [-57.970785, -23.240643],
            [-57.954297, -23.240929],
            [-57.9315, -23.219664],
            [-57.905297, -23.219173],
            [-57.881562, -23.19633],
            [-57.856996, -23.200357],
            [-57.837173, -23.208884],
            [-57.827875, -23.183735],
            [-57.839002, -23.162946],
            [-57.83076, -23.131665],
            [-57.790405, -23.123347],
            [-57.786884, -23.107148],
            [-57.767876, -23.096221],
            [-57.766928, -23.076683],
            [-57.746125, -23.089394],
            [-57.744794, -23.100777],
            [-57.719898, -23.106912],
            [-57.704197, -23.121804],
            [-57.676761, -23.1154],
            [-57.667017, -23.094004]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "VILLA HAYES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.705573, -25.270189],
            [-57.689979, -25.284948],
            [-57.705808, -25.296322],
            [-57.717865, -25.266663],
            [-57.705573, -25.270189]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "NANAWA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.479784, -24.689553],
            [-58.322056, -24.701439],
            [-58.259736, -24.702341],
            [-58.17192, -24.70122],
            [-58.121295, -24.703918],
            [-58.113881, -24.746055],
            [-58.114375, -24.825761],
            [-58.032039, -24.85068],
            [-57.955039, -24.852022],
            [-57.955497, -24.840741],
            [-57.915458, -24.839357],
            [-57.914972, -24.946696],
            [-57.815257, -24.946246],
            [-57.815753, -25.064903],
            [-57.784006, -25.066257],
            [-57.766155, -25.086191],
            [-57.760693, -25.102492],
            [-57.736476, -25.097113],
            [-57.690801, -25.100726],
            [-57.683835, -25.107786],
            [-57.685548, -25.141943],
            [-57.724241, -25.141943],
            [-57.717873, -25.164895],
            [-57.7, -25.163308],
            [-57.680559, -25.169096],
            [-57.666564, -25.188427],
            [-57.646453, -25.19223],
            [-57.652215, -25.211025],
            [-57.671063, -25.229685],
            [-57.679351, -25.247122],
            [-57.703613, -25.258136],
            [-57.705573, -25.270189],
            [-57.717865, -25.266663],
            [-57.72927, -25.258846],
            [-57.745802, -25.227758],
            [-57.758773, -25.215991],
            [-57.75557, -25.196945],
            [-57.760899, -25.172496],
            [-57.78, -25.152513],
            [-57.801114, -25.149631],
            [-57.836778, -25.131503],
            [-57.850683, -25.109449],
            [-57.849699, -25.097679],
            [-57.884307, -25.075663],
            [-57.906967, -25.073321],
            [-57.931611, -25.077967],
            [-57.965526, -25.075293],
            [-57.989059, -25.081736],
            [-57.996256, -25.060138],
            [-58.011015, -25.040569],
            [-58.028794, -25.03578],
            [-58.044863, -25.042986],
            [-58.077264, -25.037773],
            [-58.085455, -25.012474],
            [-58.117032, -25.019022],
            [-58.136795, -25.011644],
            [-58.137801, -24.989457],
            [-58.149539, -24.975699],
            [-58.168434, -24.968482],
            [-58.188709, -24.96904],
            [-58.201924, -24.949868],
            [-58.217104, -24.950445],
            [-58.224421, -24.927566],
            [-58.237999, -24.92693],
            [-58.257385, -24.93838],
            [-58.288694, -24.964045],
            [-58.31353, -24.989016],
            [-58.331224, -24.999514],
            [-58.341241, -24.996574],
            [-58.353027, -24.968417],
            [-58.393116, -24.95157],
            [-58.413132, -24.920568],
            [-58.430161, -24.921499],
            [-58.430397, -24.892872],
            [-58.475914, -24.86033],
            [-58.502007, -24.850966],
            [-58.477474, -24.827326],
            [-58.475293, -24.775615],
            [-58.479784, -24.689553]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "JOSÉ FALCÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-59.241225, -22.132108],
            [-59.285183, -22.190854],
            [-59.235273, -22.2],
            [-59.223061, -22.185362],
            [-59.20287, -22.188339],
            [-59.192965, -22.203379],
            [-59.162257, -22.203324],
            [-59.149384, -22.215721],
            [-59.128159, -22.211538],
            [-59.128575, -22.224641],
            [-59.113629, -22.229344],
            [-59.09552, -22.250192],
            [-59.093743, -22.261814],
            [-58.985812, -22.410956],
            [-59.00383, -22.414422],
            [-59.011047, -22.426495],
            [-58.852064, -22.605185],
            [-58.887053, -22.601147],
            [-58.895668, -22.619978],
            [-58.90549, -22.620673],
            [-58.941243, -22.605237],
            [-58.963786, -22.614435],
            [-59.001127, -22.620245],
            [-59.019271, -22.62812],
            [-59.053787, -22.633602],
            [-59.052692, -22.646782],
            [-59.063904, -22.669205],
            [-59.083941, -22.663238],
            [-59.12266, -22.694843],
            [-59.121189, -22.740231],
            [-59.143386, -22.750232],
            [-59.154832, -22.787531],
            [-59.147497, -22.838067],
            [-59.149494, -22.878035],
            [-59.142901, -22.883794],
            [-59.137518, -22.925649],
            [-59.15637, -22.986809],
            [-59.168664, -22.986474],
            [-59.246939, -23.062425],
            [-59.262477, -23.074327],
            [-59.38713, -23.147936],
            [-59.414323, -23.290684],
            [-59.417212, -23.336495],
            [-59.410086, -23.346973],
            [-59.408154, -23.376875],
            [-59.395309, -23.384682],
            [-59.370274, -23.411153],
            [-59.343109, -23.409688],
            [-59.331309, -23.398813],
            [-59.303716, -23.400598],
            [-59.288182, -23.423372],
            [-59.255353, -23.453874],
            [-59.276675, -23.463334],
            [-59.37634, -23.465264],
            [-59.391967, -23.46158],
            [-59.46183, -23.456174],
            [-59.461848, -23.633046],
            [-59.43357, -23.66498],
            [-59.446487, -23.68326],
            [-59.529735, -23.720006],
            [-59.522547, -23.777909],
            [-59.546173, -23.784869],
            [-59.659176, -23.782186],
            [-59.674821, -23.769255],
            [-59.717809, -23.804814],
            [-59.91924, -23.776126],
            [-59.945556, -23.823629],
            [-60.293887, -23.811698],
            [-60.372474, -23.78616],
            [-60.407038, -23.716952],
            [-60.373436, -23.609856],
            [-60.371358, -23.55208],
            [-60.202723, -23.532855],
            [-60.186348, -23.524553],
            [-60.136866, -23.512571],
            [-60.092734, -23.492821],
            [-60.076769, -23.458487],
            [-60.059304, -23.38407],
            [-60.02788, -23.304451],
            [-59.978988, -23.172979],
            [-59.992281, -23.157465],
            [-59.958426, -23.067302],
            [-59.969417, -22.970089],
            [-59.976196, -22.830056],
            [-59.966371, -22.802297],
            [-59.944878, -22.796893],
            [-59.948822, -22.782389],
            [-59.928165, -22.756081],
            [-59.86902, -22.672305],
            [-59.843758, -22.634372],
            [-59.787933, -22.566777],
            [-59.75177, -22.525404],
            [-59.747184, -22.500433],
            [-59.747181, -22.466983],
            [-59.712167, -22.467009],
            [-59.7118, -22.427977],
            [-59.626237, -22.427976],
            [-59.639763, -22.388631],
            [-59.639343, -22.368923],
            [-59.614392, -22.335895],
            [-59.336595, -22.170403],
            [-59.367744, -22.076224],
            [-59.241225, -22.132108]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "TTE. 1° MANUEL IRALA FERNÁNDEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-59.143186, -23.729509],
            [-59.121546, -23.781618],
            [-59.122465, -23.803544],
            [-59.100736, -23.905783],
            [-59.083824, -23.935649],
            [-59.08203, -23.956236],
            [-59.080279, -24.062755],
            [-59.152958, -24.062435],
            [-59.159622, -24.110419],
            [-59.18422, -24.119458],
            [-59.191963, -24.134685],
            [-59.18771, -24.177745],
            [-59.256482, -24.180615],
            [-59.261327, -24.178422],
            [-59.342942, -24.176382],
            [-59.342857, -24.221629],
            [-59.335207, -24.232509],
            [-59.30311, -24.254583],
            [-59.298615, -24.273913],
            [-59.303505, -24.284944],
            [-59.26328, -24.302254],
            [-59.245261, -24.315618],
            [-59.213934, -24.366023],
            [-59.260261, -24.427177],
            [-59.283596, -24.480508],
            [-59.315627, -24.49785],
            [-59.351874, -24.481517],
            [-59.358692, -24.454034],
            [-59.365577, -24.4502],
            [-59.373098, -24.422989],
            [-59.400471, -24.411221],
            [-59.420852, -24.409224],
            [-59.427473, -24.394303],
            [-59.440643, -24.390448],
            [-59.457218, -24.372223],
            [-59.459489, -24.35579],
            [-59.471059, -24.335975],
            [-59.531928, -24.299828],
            [-59.773602, -24.158861],
            [-59.885317, -24.098383],
            [-59.998422, -24.031622],
            [-60.037035, -24.015126],
            [-60.067498, -24.009021],
            [-60.096, -24.026425],
            [-60.152964, -24.039343],
            [-60.18965, -24.043313],
            [-60.237361, -24.044188],
            [-60.261442, -24.049313],
            [-60.305856, -24.044558],
            [-60.333538, -24.030493],
            [-60.368769, -24.033639],
            [-60.38447, -24.008113],
            [-60.417036, -23.993728],
            [-60.435728, -23.978842],
            [-60.487907, -23.964752],
            [-60.496139, -23.972915],
            [-60.552522, -23.964609],
            [-60.557811, -23.954473],
            [-60.588338, -23.954591],
            [-60.593329, -23.924818],
            [-60.605273, -23.914595],
            [-60.629738, -23.923377],
            [-60.641693, -23.908162],
            [-60.677451, -23.895692],
            [-60.68874, -23.903315],
            [-60.721356, -23.883682],
            [-60.759891, -23.873604],
            [-60.781131, -23.830757],
            [-60.780909, -23.794414],
            [-60.768308, -23.777527],
            [-60.692926, -23.733395],
            [-60.671569, -23.697829],
            [-60.675205, -23.59219],
            [-60.601665, -23.611015],
            [-60.578945, -23.58208],
            [-60.565409, -23.573936],
            [-60.371358, -23.55208],
            [-60.373436, -23.609856],
            [-60.407038, -23.716952],
            [-60.372474, -23.78616],
            [-60.293887, -23.811698],
            [-59.945556, -23.823629],
            [-59.91924, -23.776126],
            [-59.717809, -23.804814],
            [-59.674821, -23.769255],
            [-59.659176, -23.782186],
            [-59.546173, -23.784869],
            [-59.522547, -23.777909],
            [-59.529735, -23.720006],
            [-59.446487, -23.68326],
            [-59.43357, -23.66498],
            [-59.461848, -23.633046],
            [-59.46183, -23.456174],
            [-59.391967, -23.46158],
            [-59.37634, -23.465264],
            [-59.276675, -23.463334],
            [-59.255353, -23.453874],
            [-59.175383, -23.443132],
            [-59.190558, -23.48591],
            [-59.169859, -23.49972],
            [-59.142093, -23.510835],
            [-59.121469, -23.505123],
            [-59.080985, -23.558866],
            [-59.077755, -23.570071],
            [-59.200613, -23.59419],
            [-59.143186, -23.729509]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "TENIENTE ESTEBAN MARTÍNEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.712062, -23.808446],
            [-58.717981, -24.114743],
            [-58.531788, -24.272547],
            [-58.511136, -24.450709],
            [-58.487746, -24.651636],
            [-58.479784, -24.689553],
            [-58.475293, -24.775615],
            [-58.477474, -24.827326],
            [-58.502007, -24.850966],
            [-58.520918, -24.849059],
            [-58.568479, -24.822538],
            [-58.58368, -24.821659],
            [-58.610848, -24.831152],
            [-58.64866, -24.824476],
            [-58.673542, -24.831446],
            [-58.689049, -24.810074],
            [-58.700216, -24.814533],
            [-58.726546, -24.774428],
            [-58.73992, -24.780788],
            [-58.76421, -24.774757],
            [-58.808127, -24.772038],
            [-58.83693, -24.744917],
            [-58.855436, -24.732417],
            [-58.886702, -24.718882],
            [-58.903164, -24.704942],
            [-58.941531, -24.681718],
            [-58.966764, -24.672288],
            [-58.972684, -24.662317],
            [-58.995541, -24.664034],
            [-59.023708, -24.660163],
            [-59.057537, -24.630986],
            [-59.100344, -24.616888],
            [-59.110987, -24.623783],
            [-59.130718, -24.616002],
            [-59.135847, -24.605964],
            [-59.154063, -24.598689],
            [-59.157208, -24.58751],
            [-59.173587, -24.581018],
            [-59.186072, -24.56337],
            [-59.241087, -24.54629],
            [-59.257605, -24.51957],
            [-59.296782, -24.513223],
            [-59.315627, -24.49785],
            [-59.283596, -24.480508],
            [-59.260261, -24.427177],
            [-59.213934, -24.366023],
            [-59.245261, -24.315618],
            [-59.26328, -24.302254],
            [-59.303505, -24.284944],
            [-59.298615, -24.273913],
            [-59.30311, -24.254583],
            [-59.335207, -24.232509],
            [-59.342857, -24.221629],
            [-59.342942, -24.176382],
            [-59.261327, -24.178422],
            [-59.256482, -24.180615],
            [-59.18771, -24.177745],
            [-59.191963, -24.134685],
            [-59.18422, -24.119458],
            [-59.159622, -24.110419],
            [-59.152958, -24.062435],
            [-59.080279, -24.062755],
            [-59.08203, -23.956236],
            [-59.083824, -23.935649],
            [-59.100736, -23.905783],
            [-59.122465, -23.803544],
            [-59.121546, -23.781618],
            [-59.143186, -23.729509],
            [-59.131977, -23.731879],
            [-59.092331, -23.701562],
            [-59.023775, -23.720743],
            [-59.010762, -23.728586],
            [-58.974011, -23.731998],
            [-58.969889, -23.743017],
            [-58.900644, -23.752149],
            [-58.876161, -23.761945],
            [-58.836085, -23.76249],
            [-58.83283, -23.770495],
            [-58.766423, -23.785912],
            [-58.745968, -23.797219],
            [-58.728679, -23.795782],
            [-58.712062, -23.808446]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PRESIDENTE HAYES",
        "dist_desc_": "GENERAL JOSÉ MARÍA BRUGUEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-60.535834, -20.456691],
            [-60.537717, -20.677446],
            [-60.54178, -20.819171],
            [-60.541836, -20.891984],
            [-60.544415, -20.963788],
            [-60.545691, -21.049968],
            [-60.548584, -21.14489],
            [-60.556401, -21.348593],
            [-60.566876, -21.553906],
            [-60.569343, -21.618064],
            [-60.580217, -21.828382],
            [-60.49315, -21.83566],
            [-60.503483, -22.009059],
            [-60.409478, -22.007795],
            [-60.411432, -22.114677],
            [-60.411613, -22.214723],
            [-60.414827, -22.221657],
            [-60.235643, -22.357273],
            [-60.092925, -22.464336],
            [-60.055265, -22.467076],
            [-59.953142, -22.518525],
            [-59.957886, -22.58949],
            [-59.923047, -22.589398],
            [-59.93292, -22.611542],
            [-59.933295, -22.634872],
            [-59.915582, -22.635369],
            [-59.91616, -22.673429],
            [-59.86902, -22.672305],
            [-59.928165, -22.756081],
            [-59.948822, -22.782389],
            [-59.944878, -22.796893],
            [-59.966371, -22.802297],
            [-59.976196, -22.830056],
            [-59.969417, -22.970089],
            [-59.958426, -23.067302],
            [-59.992281, -23.157465],
            [-59.978988, -23.172979],
            [-60.02788, -23.304451],
            [-60.059304, -23.38407],
            [-60.076769, -23.458487],
            [-60.092734, -23.492821],
            [-60.136866, -23.512571],
            [-60.186348, -23.524553],
            [-60.202723, -23.532855],
            [-60.371358, -23.55208],
            [-60.565409, -23.573936],
            [-60.578945, -23.58208],
            [-60.601665, -23.611015],
            [-60.675205, -23.59219],
            [-60.671569, -23.697829],
            [-60.692926, -23.733395],
            [-60.768308, -23.777527],
            [-60.780909, -23.794414],
            [-60.781131, -23.830757],
            [-60.759891, -23.873604],
            [-60.775114, -23.879427],
            [-60.799866, -23.864548],
            [-60.811228, -23.873276],
            [-60.848386, -23.870578],
            [-60.856027, -23.858034],
            [-60.883634, -23.841079],
            [-60.896561, -23.84071],
            [-60.911226, -23.821247],
            [-60.932827, -23.809883],
            [-60.959407, -23.819746],
            [-60.993094, -23.807381],
            [-60.999945, -23.792744],
            [-61.019894, -23.769719],
            [-61.013902, -23.760643],
            [-61.040386, -23.74058],
            [-61.039806, -23.730185],
            [-61.05922, -23.704146],
            [-61.08252, -23.689578],
            [-61.100602, -23.657282],
            [-61.091101, -23.646299],
            [-61.098829, -23.620664],
            [-61.091776, -23.611313],
            [-61.136462, -23.576803],
            [-61.162371, -23.56758],
            [-61.161187, -23.558962],
            [-61.186173, -23.544438],
            [-61.208164, -23.552946],
            [-61.225139, -23.552653],
            [-61.234478, -23.542338],
            [-61.279344, -23.513448],
            [-61.280473, -23.490127],
            [-61.3057, -23.48747],
            [-61.315073, -23.472648],
            [-61.345384, -23.46831],
            [-61.350963, -23.450968],
            [-61.391442, -23.457443],
            [-61.403812, -23.44569],
            [-61.420871, -23.445975],
            [-61.445582, -23.421124],
            [-61.474744, -23.426602],
            [-61.493466, -23.421497],
            [-61.501131, -23.400386],
            [-61.525091, -23.370273],
            [-61.509982, -23.34789],
            [-61.544321, -23.348192],
            [-61.555968, -23.342091],
            [-61.564364, -23.310829],
            [-61.58351, -23.305923],
            [-61.609682, -23.286921],
            [-61.630652, -23.277498],
            [-61.671055, -23.285139],
            [-61.689774, -23.262017],
            [-61.715793, -23.239605],
            [-61.734829, -23.240436],
            [-61.741525, -23.215036],
            [-61.739493, -23.202973],
            [-61.753211, -23.173329],
            [-61.780101, -23.164378],
            [-61.783452, -23.151941],
            [-61.803842, -23.143742],
            [-61.8166, -23.12538],
            [-61.838389, -23.109344],
            [-61.852891, -23.091634],
            [-61.885846, -23.075743],
            [-61.926715, -23.067755],
            [-61.934066, -23.051857],
            [-61.952726, -23.034455],
            [-61.986647, -23.016117],
            [-61.993336, -22.998998],
            [-62.005889, -22.994781],
            [-61.998164, -22.977895],
            [-62.008772, -22.963065],
            [-62.00128, -22.927834],
            [-62.024901, -22.929825],
            [-62.037521, -22.913779],
            [-62.034412, -22.890082],
            [-62.045861, -22.866149],
            [-62.058156, -22.862086],
            [-62.07754, -22.843721],
            [-62.082763, -22.813544],
            [-62.106702, -22.821303],
            [-62.111355, -22.797361],
            [-62.135419, -22.791276],
            [-62.140887, -22.774354],
            [-62.155198, -22.761461],
            [-62.148782, -22.745242],
            [-62.177024, -22.720118],
            [-62.19134, -22.718741],
            [-62.200251, -22.706812],
            [-62.198072, -22.668504],
            [-62.214032, -22.661833],
            [-62.213847, -22.649763],
            [-62.228222, -22.638471],
            [-62.234443, -22.612879],
            [-62.249596, -22.604845],
            [-62.240489, -22.591844],
            [-62.239978, -22.573466],
            [-62.223574, -22.549243],
            [-62.247315, -22.537951],
            [-62.265901, -22.514095],
            [-62.273807, -22.522851],
            [-62.294505, -22.520357],
            [-62.286889, -22.477569],
            [-62.310406, -22.488043],
            [-62.341313, -22.478616],
            [-62.346247, -22.457203],
            [-62.381479, -22.460251],
            [-62.407495, -22.447781],
            [-62.417756, -22.424544],
            [-62.460234, -22.413497],
            [-62.472781, -22.377612],
            [-62.486408, -22.373393],
            [-62.511556, -22.380104],
            [-62.528438, -22.369005],
            [-62.541317, -22.372856],
            [-62.562356, -22.324405],
            [-62.583565, -22.320496],
            [-62.612456, -22.302563],
            [-62.619604, -22.292288],
            [-62.640238, -22.299752],
            [-62.629382, -22.266187],
            [-62.644617, -22.251467],
            [-62.632525, -22.213475],
            [-62.260919, -21.058628],
            [-62.266342, -20.563156],
            [-61.922536, -20.089211],
            [-61.768661, -20.109639],
            [-61.737006, -20.098228],
            [-61.71859, -20.096644],
            [-61.698262, -20.104244],
            [-61.660203, -20.135611],
            [-61.645544, -20.153219],
            [-61.620052, -20.170064],
            [-61.54988, -20.174715],
            [-61.51439, -20.182631],
            [-61.490832, -20.192296],
            [-60.90463, -20.355282],
            [-60.535834, -20.456691]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "BOQUERÓN",
        "dist_desc_": "MARISCAL JOSÉ FÉLIX ESTIGARRIBIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.889477, -26.219833],
            [-56.8813, -26.241163],
            [-56.861324, -26.252197],
            [-56.857444, -26.262329],
            [-56.883574, -26.283242],
            [-56.889395, -26.297552],
            [-56.909009, -26.32063],
            [-56.9265, -26.32283],
            [-56.927558, -26.348074],
            [-56.941758, -26.363567],
            [-56.983908, -26.36476],
            [-56.995709, -26.386667],
            [-56.993027, -26.399275],
            [-57.007329, -26.412427],
            [-57.014772, -26.41757],
            [-57.043084, -26.411985],
            [-57.0582, -26.402009],
            [-57.071329, -26.379031],
            [-57.087854, -26.376148],
            [-57.078647, -26.370958],
            [-57.09993, -26.341725],
            [-57.113696, -26.308893],
            [-57.125248, -26.301777],
            [-57.09927, -26.261562],
            [-57.09777, -26.245499],
            [-57.11114, -26.243481],
            [-57.121889, -26.219349],
            [-57.114218, -26.20182],
            [-57.144634, -26.182424],
            [-57.146668, -26.168205],
            [-57.135449, -26.145191],
            [-57.119791, -26.126999],
            [-57.1072, -26.122442],
            [-57.078685, -26.143468],
            [-57.042394, -26.14439],
            [-57.029565, -26.134727],
            [-57.008109, -26.136039],
            [-56.970178, -26.114505],
            [-56.944006, -26.125816],
            [-56.921536, -26.162592],
            [-56.919318, -26.175626],
            [-56.903011, -26.194424],
            [-56.889477, -26.219833]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "QUYQUYHÓ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.196668, -25.854078],
            [-57.204233, -25.870039],
            [-57.202088, -25.889312],
            [-57.189861, -25.898598],
            [-57.163354, -25.903501],
            [-57.183876, -25.948022],
            [-57.201297, -25.943027],
            [-57.229873, -25.918098],
            [-57.256051, -25.911124],
            [-57.285074, -25.909377],
            [-57.297104, -25.918514],
            [-57.322523, -25.918861],
            [-57.350218, -25.910268],
            [-57.411902, -25.934175],
            [-57.446799, -25.932162],
            [-57.417286, -25.891638],
            [-57.415749, -25.879598],
            [-57.400869, -25.857792],
            [-57.374926, -25.847324],
            [-57.356545, -25.828293],
            [-57.335029, -25.825481],
            [-57.325859, -25.812187],
            [-57.292557, -25.8155],
            [-57.268552, -25.807045],
            [-57.229301, -25.811994],
            [-57.210641, -25.83128],
            [-57.205605, -25.851183],
            [-57.196668, -25.854078]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "ROQUE GONZALEZ DE SANTA CRUZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.914166, -25.590966],
            [-56.945308, -25.651621],
            [-56.892445, -25.668163],
            [-56.894242, -25.68658],
            [-56.911644, -25.702837],
            [-56.93234, -25.743502],
            [-56.960198, -25.758619],
            [-56.948216, -25.781972],
            [-56.96717, -25.801207],
            [-56.966778, -25.824022],
            [-56.997716, -25.846587],
            [-57.016504, -25.85241],
            [-57.034709, -25.849697],
            [-57.051392, -25.837033],
            [-57.069424, -25.834791],
            [-57.076929, -25.818406],
            [-57.059484, -25.810382],
            [-57.040514, -25.788568],
            [-57.0216, -25.786084],
            [-57.01619, -25.776377],
            [-57.003931, -25.785196],
            [-56.976067, -25.776586],
            [-56.980505, -25.745159],
            [-56.966026, -25.730456],
            [-56.981869, -25.69432],
            [-57.007451, -25.669248],
            [-56.997303, -25.606736],
            [-56.988011, -25.596563],
            [-56.990237, -25.574532],
            [-56.968339, -25.572428],
            [-56.945204, -25.593401],
            [-56.914166, -25.590966]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "SAPUCÁI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.666513, -25.849005],
            [-56.627668, -25.886487],
            [-56.626772, -25.900973],
            [-56.609886, -25.916533],
            [-56.607719, -25.940555],
            [-56.607639, -25.978275],
            [-56.641556, -25.968454],
            [-56.666061, -25.970483],
            [-56.676833, -25.96265],
            [-56.697863, -25.964883],
            [-56.747588, -25.951921],
            [-56.747988, -25.941148],
            [-56.73626, -25.936525],
            [-56.733152, -25.914199],
            [-56.741936, -25.897987],
            [-56.732359, -25.876514],
            [-56.716579, -25.860479],
            [-56.700035, -25.863773],
            [-56.666513, -25.849005]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "TEBICUARY-MÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.218054, -25.551105],
            [-57.207339, -25.572725],
            [-57.183951, -25.591445],
            [-57.18091, -25.605066],
            [-57.184478, -25.635322],
            [-57.19611, -25.660366],
            [-57.231571, -25.65686],
            [-57.270265, -25.677206],
            [-57.279977, -25.66735],
            [-57.342892, -25.668696],
            [-57.363956, -25.660089],
            [-57.388147, -25.639093],
            [-57.368674, -25.622828],
            [-57.346437, -25.613039],
            [-57.343971, -25.589115],
            [-57.33078, -25.578783],
            [-57.317095, -25.497762],
            [-57.253918, -25.50929],
            [-57.230752, -25.52678],
            [-57.218054, -25.551105]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "YAGUARÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.896488, -25.914835],
            [-56.852308, -25.929416],
            [-56.836422, -25.944931],
            [-56.802381, -25.948107],
            [-56.785187, -25.919941],
            [-56.769908, -25.922992],
            [-56.747988, -25.941148],
            [-56.747588, -25.951921],
            [-56.73702, -25.972646],
            [-56.748161, -26.028082],
            [-56.753314, -26.037152],
            [-56.80236, -26.064624],
            [-56.805014, -26.082348],
            [-56.791741, -26.096461],
            [-56.793483, -26.117859],
            [-56.830912, -26.121822],
            [-56.839019, -26.140099],
            [-56.850764, -26.149299],
            [-56.848649, -26.164945],
            [-56.865578, -26.194444],
            [-56.889477, -26.219833],
            [-56.903011, -26.194424],
            [-56.919318, -26.175626],
            [-56.921536, -26.162592],
            [-56.944006, -26.125816],
            [-56.970178, -26.114505],
            [-57.008109, -26.136039],
            [-57.029565, -26.134727],
            [-57.042394, -26.14439],
            [-57.078685, -26.143468],
            [-57.1072, -26.122442],
            [-57.13015, -26.114418],
            [-57.141422, -26.091318],
            [-57.134345, -26.079505],
            [-57.137597, -26.056634],
            [-57.131693, -26.03062],
            [-57.115086, -26.020566],
            [-57.105521, -25.984526],
            [-57.107902, -25.971864],
            [-57.091207, -25.956106],
            [-57.060978, -25.954392],
            [-57.025321, -25.946578],
            [-57.016665, -25.932999],
            [-56.994893, -25.922954],
            [-56.928457, -25.917207],
            [-56.916657, -25.906893],
            [-56.896488, -25.914835]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "YBYCUÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.719684, -25.658716],
            [-56.715617, -25.669915],
            [-56.692916, -25.69975],
            [-56.669835, -25.700155],
            [-56.689541, -25.762165],
            [-56.666513, -25.849005],
            [-56.700035, -25.863773],
            [-56.716579, -25.860479],
            [-56.732359, -25.876514],
            [-56.741936, -25.897987],
            [-56.733152, -25.914199],
            [-56.78765, -25.898812],
            [-56.776441, -25.869925],
            [-56.778077, -25.859827],
            [-56.807362, -25.863779],
            [-56.814975, -25.856199],
            [-56.84508, -25.864673],
            [-56.864713, -25.858593],
            [-56.893082, -25.889973],
            [-56.901329, -25.904169],
            [-56.896488, -25.914835],
            [-56.916657, -25.906893],
            [-56.915865, -25.880949],
            [-56.886939, -25.888759],
            [-56.874464, -25.851725],
            [-56.867457, -25.843885],
            [-56.872746, -25.805495],
            [-56.856758, -25.803985],
            [-56.843558, -25.777802],
            [-56.846262, -25.751134],
            [-56.837513, -25.718296],
            [-56.825166, -25.695796],
            [-56.806296, -25.676791],
            [-56.758342, -25.64924],
            [-56.726762, -25.663172],
            [-56.719684, -25.658716]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "YBYTYMÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.5979, -25.504587],
            [-54.600317, -25.524524],
            [-54.594021, -25.555206],
            [-54.623034, -25.54071],
            [-54.70346, -25.540769],
            [-54.71189, -25.576089],
            [-54.736248, -25.58319],
            [-54.724217, -25.433579],
            [-54.720106, -25.419591],
            [-54.700033, -25.403258],
            [-54.691741, -25.417659],
            [-54.711711, -25.427029],
            [-54.712585, -25.44036],
            [-54.685617, -25.43207],
            [-54.670611, -25.442644],
            [-54.680605, -25.458777],
            [-54.667899, -25.469484],
            [-54.651592, -25.443283],
            [-54.640916, -25.458348],
            [-54.638788, -25.477981],
            [-54.6302, -25.491752],
            [-54.5979, -25.504587]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "CIUDAD DEL ESTE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.594021, -25.555206],
            [-54.596702, -25.624994],
            [-54.583424, -25.651029],
            [-54.586032, -25.66706],
            [-54.609589, -25.667448],
            [-54.645153, -25.661235],
            [-54.71189, -25.576089],
            [-54.70346, -25.540769],
            [-54.623034, -25.54071],
            [-54.594021, -25.555206]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "PRESIDENTE FRANCO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.625082, -25.777775],
            [-54.59533, -25.813318],
            [-54.587293, -25.829439],
            [-54.596325, -25.860942],
            [-54.611925, -25.886723],
            [-54.622518, -25.915543],
            [-54.620804, -25.937811],
            [-54.606567, -25.963826],
            [-54.612571, -25.980387],
            [-54.624111, -25.985364],
            [-54.65871, -25.979525],
            [-54.813148, -25.838412],
            [-54.799343, -25.768136],
            [-54.771582, -25.771839],
            [-54.734802, -25.787517],
            [-54.706368, -25.771452],
            [-54.669852, -25.777542],
            [-54.654606, -25.77004],
            [-54.640799, -25.786943],
            [-54.625082, -25.777775]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "DOMINGO MARTÍNEZ DE IRALA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.081703, -25.559745],
            [-55.105411, -25.55632],
            [-55.131268, -25.563155],
            [-55.144117, -25.54944],
            [-55.160507, -25.516799],
            [-55.169214, -25.523047],
            [-55.194807, -25.519495],
            [-55.217517, -25.526523],
            [-55.239583, -25.52791],
            [-55.249829, -25.553888],
            [-55.27252, -25.567335],
            [-55.303745, -25.565068],
            [-55.327309, -25.582695],
            [-55.347002, -25.588659],
            [-55.322328, -25.456391],
            [-55.30889, -25.389438],
            [-55.30686, -25.349476],
            [-55.296601, -25.349466],
            [-55.211044, -25.442786],
            [-55.081703, -25.559745]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "DOCTOR JUAN LEÓN MALLORQUÍN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.967812, -25.137971],
            [-54.941803, -25.181181],
            [-54.903077, -25.163798],
            [-54.87892, -25.138193],
            [-54.873019, -25.164921],
            [-54.864138, -25.173328],
            [-54.875338, -25.213488],
            [-54.870607, -25.224328],
            [-54.874878, -25.253366],
            [-54.826079, -25.280304],
            [-54.73627, -25.278578],
            [-54.72347, -25.282497],
            [-54.701419, -25.246062],
            [-54.691652, -25.258837],
            [-54.676921, -25.26132],
            [-54.652225, -25.250828],
            [-54.636569, -25.257677],
            [-54.629605, -25.280366],
            [-54.615101, -25.286246],
            [-54.578968, -25.291757],
            [-54.554826, -25.289567],
            [-54.54302, -25.304739],
            [-54.541729, -25.328812],
            [-54.531345, -25.342776],
            [-54.584475, -25.397266],
            [-54.606453, -25.444631],
            [-54.619867, -25.456393],
            [-54.615531, -25.472207],
            [-54.596891, -25.491493],
            [-54.5979, -25.504587],
            [-54.6302, -25.491752],
            [-54.638788, -25.477981],
            [-54.640916, -25.458348],
            [-54.651592, -25.443283],
            [-54.667899, -25.469484],
            [-54.680605, -25.458777],
            [-54.670611, -25.442644],
            [-54.685617, -25.43207],
            [-54.712585, -25.44036],
            [-54.711711, -25.427029],
            [-54.691741, -25.417659],
            [-54.700033, -25.403258],
            [-54.720106, -25.419591],
            [-54.752274, -25.405239],
            [-54.76184, -25.419087],
            [-54.788537, -25.420943],
            [-54.806241, -25.411378],
            [-54.810928, -25.400512],
            [-54.839077, -25.39396],
            [-54.844502, -25.368119],
            [-54.86349, -25.364835],
            [-54.91178, -25.368898],
            [-54.896184, -25.360124],
            [-54.907177, -25.349845],
            [-54.935052, -25.354564],
            [-54.950017, -25.345809],
            [-54.938235, -25.334262],
            [-54.956127, -25.319684],
            [-54.974729, -25.283314],
            [-54.980917, -25.26329],
            [-55.017009, -25.244222],
            [-55.026888, -25.222413],
            [-55.01641, -25.196013],
            [-55.026819, -25.18122],
            [-54.981519, -25.140654],
            [-54.967812, -25.137971]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "HERNANDARIAS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.016638, -24.549184],
            [-54.989176, -24.550463],
            [-54.97138, -24.567716],
            [-54.955096, -24.567317],
            [-54.966245, -24.602499],
            [-54.977275, -24.607265],
            [-54.987968, -24.625365],
            [-54.990265, -24.647848],
            [-55.029041, -24.848298],
            [-55.047329, -24.940143],
            [-55.055298, -24.943746],
            [-55.059104, -24.977821],
            [-55.068402, -24.990355],
            [-55.055251, -25.010239],
            [-55.024143, -25.012786],
            [-55.00162, -25.022794],
            [-54.975655, -25.051019],
            [-54.979715, -25.065545],
            [-54.949596, -25.059183],
            [-54.967812, -25.137971],
            [-54.981519, -25.140654],
            [-55.026819, -25.18122],
            [-55.056213, -25.160806],
            [-55.106961, -25.131952],
            [-55.147529, -25.097319],
            [-55.159835, -25.096041],
            [-55.176294, -25.058814],
            [-55.193267, -25.04297],
            [-55.210648, -25.049148],
            [-55.232697, -25.042762],
            [-55.229126, -25.029408],
            [-55.275727, -25.038248],
            [-55.277307, -25.023885],
            [-55.294287, -25.023168],
            [-55.312739, -25.001805],
            [-55.308838, -24.982178],
            [-55.3311, -24.970963],
            [-55.33469, -24.949664],
            [-55.331563, -24.924489],
            [-55.344111, -24.914792],
            [-55.326876, -24.900817],
            [-55.329277, -24.877442],
            [-55.340843, -24.868244],
            [-55.348866, -24.842709],
            [-55.336609, -24.831797],
            [-55.335092, -24.80473],
            [-55.321423, -24.767983],
            [-55.322848, -24.751616],
            [-55.303417, -24.725729],
            [-55.303439, -24.704624],
            [-55.314855, -24.697177],
            [-55.315383, -24.677053],
            [-55.292578, -24.646202],
            [-55.301445, -24.633549],
            [-55.292657, -24.612836],
            [-55.30545, -24.592002],
            [-55.30208, -24.567184],
            [-55.269593, -24.523168],
            [-55.24723, -24.514509],
            [-55.237797, -24.519098],
            [-55.21456, -24.515227],
            [-55.160848, -24.518731],
            [-55.138767, -24.496782],
            [-55.154635, -24.479057],
            [-55.134036, -24.479881],
            [-55.113647, -24.505702],
            [-55.112865, -24.536628],
            [-55.102954, -24.543704],
            [-55.054886, -24.551203],
            [-55.031299, -24.54437],
            [-55.016638, -24.549184]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "ITAKYRY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.30686, -25.349476],
            [-55.30889, -25.389438],
            [-55.322328, -25.456391],
            [-55.347002, -25.588659],
            [-55.373239, -25.619977],
            [-55.390133, -25.629409],
            [-55.400011, -25.622747],
            [-55.39926, -25.604094],
            [-55.408404, -25.598393],
            [-55.426062, -25.557542],
            [-55.378436, -25.361914],
            [-55.355386, -25.357609],
            [-55.32846, -25.33526],
            [-55.30686, -25.349476]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "JUAN E. O'LEARY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.65871, -25.979525],
            [-54.67612, -25.988624],
            [-54.677528, -26.015109],
            [-54.650192, -26.065334],
            [-54.643179, -26.092294],
            [-54.650714, -26.118779],
            [-54.674339, -26.144902],
            [-54.671004, -26.161157],
            [-54.658353, -26.177156],
            [-54.633339, -26.19162],
            [-54.617422, -26.211252],
            [-54.623316, -26.223348],
            [-54.672423, -26.254019],
            [-54.678613, -26.239576],
            [-54.693862, -26.228169],
            [-54.721954, -26.249752],
            [-54.778498, -26.236395],
            [-54.785802, -26.217834],
            [-54.799772, -26.201016],
            [-54.82739, -26.201213],
            [-54.839885, -26.185601],
            [-54.855418, -26.188875],
            [-54.87467, -26.174255],
            [-54.888942, -26.135902],
            [-54.981832, -26.107086],
            [-54.976183, -26.092686],
            [-54.959013, -26.079171],
            [-54.961826, -26.068659],
            [-54.935248, -26.055239],
            [-54.934531, -26.04335],
            [-54.921135, -26.031693],
            [-54.936559, -25.980394],
            [-54.896697, -25.982322],
            [-54.876814, -25.989956],
            [-54.873086, -26.003389],
            [-54.859746, -26.009305],
            [-54.840586, -25.978066],
            [-54.837824, -25.871702],
            [-54.813148, -25.838412],
            [-54.65871, -25.979525]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "ÑACUNDAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.219968, -25.265591],
            [-55.191369, -25.29759],
            [-55.159652, -25.320395],
            [-55.123678, -25.327808],
            [-55.099059, -25.325457],
            [-55.058655, -25.31361],
            [-55.042375, -25.319506],
            [-55.031534, -25.358517],
            [-55.021251, -25.378072],
            [-55.000168, -25.387518],
            [-54.965461, -25.375289],
            [-54.960914, -25.361279],
            [-54.943998, -25.366907],
            [-54.935052, -25.354564],
            [-54.907177, -25.349845],
            [-54.896184, -25.360124],
            [-54.91178, -25.368898],
            [-54.950767, -25.572144],
            [-54.972657, -25.583139],
            [-55.024459, -25.585594],
            [-55.034315, -25.5763],
            [-55.081703, -25.559745],
            [-55.211044, -25.442786],
            [-55.296601, -25.349466],
            [-55.30686, -25.349476],
            [-55.32846, -25.33526],
            [-55.307153, -25.277279],
            [-55.289862, -25.251734],
            [-55.248298, -25.252297],
            [-55.219968, -25.265591]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "YGUAZÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.736248, -25.58319],
            [-54.71189, -25.576089],
            [-54.645153, -25.661235],
            [-54.657981, -25.679384],
            [-54.641591, -25.717663],
            [-54.633161, -25.757166],
            [-54.625082, -25.777775],
            [-54.640799, -25.786943],
            [-54.654606, -25.77004],
            [-54.669852, -25.777542],
            [-54.706368, -25.771452],
            [-54.734802, -25.787517],
            [-54.771582, -25.771839],
            [-54.799343, -25.768136],
            [-54.822244, -25.756955],
            [-54.835591, -25.756824],
            [-54.85271, -25.739874],
            [-54.857139, -25.694569],
            [-54.866084, -25.690846],
            [-54.859066, -25.644128],
            [-54.843959, -25.628526],
            [-54.85489, -25.597887],
            [-54.817874, -25.579245],
            [-54.805831, -25.605645],
            [-54.7552, -25.586393],
            [-54.736248, -25.58319]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "LOS CEDRALES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.720106, -25.419591],
            [-54.724217, -25.433579],
            [-54.736248, -25.58319],
            [-54.7552, -25.586393],
            [-54.805831, -25.605645],
            [-54.817874, -25.579245],
            [-54.85489, -25.597887],
            [-54.843959, -25.628526],
            [-54.859066, -25.644128],
            [-54.879692, -25.639091],
            [-54.88451, -25.652287],
            [-54.886295, -25.622412],
            [-54.903599, -25.604198],
            [-54.921386, -25.617058],
            [-54.93363, -25.617853],
            [-54.95421, -25.602723],
            [-54.945396, -25.577774],
            [-54.950767, -25.572144],
            [-54.91178, -25.368898],
            [-54.86349, -25.364835],
            [-54.844502, -25.368119],
            [-54.839077, -25.39396],
            [-54.810928, -25.400512],
            [-54.806241, -25.411378],
            [-54.788537, -25.420943],
            [-54.76184, -25.419087],
            [-54.752274, -25.405239],
            [-54.720106, -25.419591]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "MINGA GUAZÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.217517, -25.526523],
            [-55.218311, -25.592765],
            [-55.226693, -25.596013],
            [-55.231887, -25.629862],
            [-55.237377, -25.636356],
            [-55.244114, -25.672137],
            [-55.269271, -25.696659],
            [-55.269051, -25.710961],
            [-55.27833, -25.736691],
            [-55.276007, -25.748801],
            [-55.286637, -25.780893],
            [-55.295849, -25.818719],
            [-55.320012, -25.84644],
            [-55.321632, -25.866842],
            [-55.290541, -25.874623],
            [-55.273879, -25.897707],
            [-55.288594, -25.912741],
            [-55.301286, -25.911839],
            [-55.341922, -25.919644],
            [-55.39014, -25.903979],
            [-55.405402, -25.921815],
            [-55.409833, -25.942898],
            [-55.392241, -25.952747],
            [-55.389527, -25.966299],
            [-55.365049, -25.975237],
            [-55.357259, -25.993078],
            [-55.378425, -26.000864],
            [-55.376636, -26.017328],
            [-55.391728, -26.035087],
            [-55.40175, -26.026031],
            [-55.411279, -25.998593],
            [-55.432133, -26.006918],
            [-55.501749, -25.986196],
            [-55.55064, -25.996946],
            [-55.528221, -25.942823],
            [-55.515895, -25.90193],
            [-55.526787, -25.888793],
            [-55.512066, -25.870352],
            [-55.528283, -25.850023],
            [-55.521961, -25.80619],
            [-55.511496, -25.782718],
            [-55.497341, -25.775743],
            [-55.480194, -25.733308],
            [-55.466178, -25.709268],
            [-55.477607, -25.68364],
            [-55.46278, -25.677548],
            [-55.452592, -25.654134],
            [-55.427199, -25.659704],
            [-55.419411, -25.637492],
            [-55.400011, -25.622747],
            [-55.390133, -25.629409],
            [-55.373239, -25.619977],
            [-55.347002, -25.588659],
            [-55.327309, -25.582695],
            [-55.303745, -25.565068],
            [-55.27252, -25.567335],
            [-55.249829, -25.553888],
            [-55.239583, -25.52791],
            [-55.217517, -25.526523]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "SAN CRISTÓBAL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.998024, -25.716584],
            [-54.996087, -25.729759],
            [-55.011934, -25.762669],
            [-55.005226, -25.775555],
            [-55.010784, -25.818891],
            [-55.025654, -25.8348],
            [-55.028702, -25.863128],
            [-55.062836, -25.904853],
            [-55.072688, -25.916489],
            [-55.097724, -25.907789],
            [-55.158098, -25.892925],
            [-55.168016, -25.871782],
            [-55.193474, -25.868536],
            [-55.220821, -25.840302],
            [-55.246979, -25.829327],
            [-55.258488, -25.833365],
            [-55.277752, -25.815039],
            [-55.273856, -25.798084],
            [-55.286637, -25.780893],
            [-55.276007, -25.748801],
            [-55.27833, -25.736691],
            [-55.269051, -25.710961],
            [-55.269271, -25.696659],
            [-55.244114, -25.672137],
            [-55.161837, -25.668784],
            [-55.140533, -25.654018],
            [-55.073816, -25.674114],
            [-55.06599, -25.682234],
            [-55.014538, -25.68569],
            [-55.022317, -25.703415],
            [-54.998024, -25.716584]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "SANTA RITA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.550514, -25.63915],
            [-56.516603, -25.674891],
            [-56.49732, -25.689576],
            [-56.478512, -25.722013],
            [-56.477711, -25.754049],
            [-56.49962, -25.773382],
            [-56.52517, -25.774625],
            [-56.536828, -25.762015],
            [-56.559047, -25.749938],
            [-56.571677, -25.735996],
            [-56.584448, -25.662496],
            [-56.550514, -25.63915]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "FÉLIX PÉREZ CARDOZO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.125128, -25.864965],
            [-56.135321, -25.874424],
            [-56.139649, -25.899168],
            [-56.117294, -25.920288],
            [-56.114745, -25.945889],
            [-56.130843, -25.960546],
            [-56.137707, -25.97554],
            [-56.151859, -25.985179],
            [-56.128906, -26.007595],
            [-56.120771, -26.027396],
            [-56.136796, -26.030134],
            [-56.161596, -26.054514],
            [-56.180444, -26.063412],
            [-56.27254, -25.977978],
            [-56.280961, -25.976187],
            [-56.274312, -25.94237],
            [-56.253337, -25.921947],
            [-56.249205, -25.898742],
            [-56.276702, -25.885794],
            [-56.276798, -25.844823],
            [-56.248204, -25.836149],
            [-56.22521, -25.841672],
            [-56.204515, -25.838259],
            [-56.192228, -25.858661],
            [-56.125128, -25.864965]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "GRAL. EUGENIO A. GARAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.118748, -25.658276],
            [-56.100914, -25.683829],
            [-56.097131, -25.71131],
            [-56.073867, -25.746356],
            [-56.063607, -25.753428],
            [-56.060452, -25.770316],
            [-56.038711, -25.767988],
            [-56.029186, -25.79546],
            [-56.032941, -25.805788],
            [-56.034183, -25.862157],
            [-56.088729, -25.866377],
            [-56.125128, -25.864965],
            [-56.192228, -25.858661],
            [-56.204515, -25.838259],
            [-56.22521, -25.841672],
            [-56.248204, -25.836149],
            [-56.276798, -25.844823],
            [-56.279545, -25.80959],
            [-56.313834, -25.779691],
            [-56.285569, -25.765748],
            [-56.280551, -25.751253],
            [-56.296827, -25.727891],
            [-56.29165, -25.707671],
            [-56.25944, -25.710253],
            [-56.24931, -25.704249],
            [-56.244591, -25.65392],
            [-56.237711, -25.624136],
            [-56.225132, -25.628485],
            [-56.213856, -25.648092],
            [-56.200575, -25.638236],
            [-56.178953, -25.632337],
            [-56.158874, -25.640015],
            [-56.142035, -25.638003],
            [-56.118748, -25.658276]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "INDEPENDENCIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.536435, -25.895141],
            [-56.572526, -25.919452],
            [-56.570295, -25.940105],
            [-56.578641, -25.950614],
            [-56.607719, -25.940555],
            [-56.609886, -25.916533],
            [-56.626772, -25.900973],
            [-56.627668, -25.886487],
            [-56.619856, -25.86526],
            [-56.633577, -25.822559],
            [-56.618632, -25.805067],
            [-56.585894, -25.807954],
            [-56.577453, -25.799518],
            [-56.556929, -25.801721],
            [-56.52517, -25.774625],
            [-56.49962, -25.773382],
            [-56.50084, -25.796304],
            [-56.495395, -25.817183],
            [-56.513834, -25.84752],
            [-56.50706, -25.868939],
            [-56.536435, -25.895141]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "ITAPÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.274312, -25.94237],
            [-56.280961, -25.976187],
            [-56.301645, -25.983688],
            [-56.323347, -26.002197],
            [-56.335464, -26.002497],
            [-56.352383, -26.026281],
            [-56.37144, -26.017638],
            [-56.392453, -26.016739],
            [-56.410906, -26.023869],
            [-56.402443, -26.137133],
            [-56.410134, -26.139789],
            [-56.437506, -26.119072],
            [-56.48085, -26.116594],
            [-56.532745, -26.121778],
            [-56.546402, -26.128445],
            [-56.538739, -26.14871],
            [-56.561302, -26.188953],
            [-56.586182, -26.185884],
            [-56.603696, -26.173139],
            [-56.615798, -26.176472],
            [-56.571444, -26.098256],
            [-56.570012, -26.03846],
            [-56.543319, -26.034095],
            [-56.505011, -26.036038],
            [-56.486314, -26.017519],
            [-56.451857, -26.026936],
            [-56.439939, -26.039072],
            [-56.414507, -26.022596],
            [-56.38684, -25.999433],
            [-56.365221, -25.993001],
            [-56.349519, -25.971671],
            [-56.317747, -25.962663],
            [-56.316469, -25.951559],
            [-56.299365, -25.942633],
            [-56.274312, -25.94237]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "ITURBE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.009762, -25.877585],
            [-56.02716, -25.892457],
            [-56.048453, -25.89086],
            [-56.099252, -26.019043],
            [-56.120771, -26.027396],
            [-56.128906, -26.007595],
            [-56.151859, -25.985179],
            [-56.137707, -25.97554],
            [-56.130843, -25.960546],
            [-56.114745, -25.945889],
            [-56.117294, -25.920288],
            [-56.139649, -25.899168],
            [-56.135321, -25.874424],
            [-56.125128, -25.864965],
            [-56.088729, -25.866377],
            [-56.034183, -25.862157],
            [-56.030236, -25.870703],
            [-56.009762, -25.877585]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "JOSÉ FASSARDI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.33895, -25.632473],
            [-56.335654, -25.653966],
            [-56.318614, -25.678904],
            [-56.303887, -25.687187],
            [-56.29165, -25.707671],
            [-56.296827, -25.727891],
            [-56.280551, -25.751253],
            [-56.285569, -25.765748],
            [-56.313834, -25.779691],
            [-56.335607, -25.79698],
            [-56.35362, -25.776812],
            [-56.398212, -25.758768],
            [-56.426079, -25.75069],
            [-56.456667, -25.731081],
            [-56.441352, -25.727133],
            [-56.434447, -25.681278],
            [-56.423523, -25.648939],
            [-56.422928, -25.628521],
            [-56.385044, -25.622612],
            [-56.362366, -25.623408],
            [-56.33895, -25.632473]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "MBOCAYATY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.237711, -25.624136],
            [-56.244591, -25.65392],
            [-56.24931, -25.704249],
            [-56.25944, -25.710253],
            [-56.29165, -25.707671],
            [-56.303887, -25.687187],
            [-56.318614, -25.678904],
            [-56.335654, -25.653966],
            [-56.33895, -25.632473],
            [-56.325448, -25.624935],
            [-56.302515, -25.632514],
            [-56.280866, -25.633558],
            [-56.265233, -25.640926],
            [-56.237711, -25.624136]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "NATALICIO TALAVERA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.274312, -25.94237],
            [-56.299365, -25.942633],
            [-56.316469, -25.951559],
            [-56.317747, -25.962663],
            [-56.349519, -25.971671],
            [-56.368896, -25.95387],
            [-56.37167, -25.939737],
            [-56.363888, -25.893781],
            [-56.353574, -25.8958],
            [-56.339091, -25.878276],
            [-56.289907, -25.874771],
            [-56.276798, -25.844823],
            [-56.276702, -25.885794],
            [-56.249205, -25.898742],
            [-56.253337, -25.921947],
            [-56.274312, -25.94237]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "ÑUMÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.363888, -25.893781],
            [-56.37167, -25.939737],
            [-56.368896, -25.95387],
            [-56.349519, -25.971671],
            [-56.365221, -25.993001],
            [-56.38684, -25.999433],
            [-56.414507, -26.022596],
            [-56.439939, -26.039072],
            [-56.451857, -26.026936],
            [-56.486314, -26.017519],
            [-56.464526, -25.969578],
            [-56.486807, -25.94632],
            [-56.482626, -25.925743],
            [-56.488732, -25.914647],
            [-56.49403, -25.888536],
            [-56.489932, -25.879995],
            [-56.454695, -25.885918],
            [-56.454944, -25.897856],
            [-56.429083, -25.919062],
            [-56.389069, -25.898997],
            [-56.363888, -25.893781]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "SAN SALVADOR"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.443962, -25.621711],
            [-56.422928, -25.628521],
            [-56.423523, -25.648939],
            [-56.434447, -25.681278],
            [-56.441352, -25.727133],
            [-56.456667, -25.731081],
            [-56.478512, -25.722013],
            [-56.49732, -25.689576],
            [-56.516603, -25.674891],
            [-56.550514, -25.63915],
            [-56.528384, -25.624785],
            [-56.495153, -25.622927],
            [-56.481575, -25.635729],
            [-56.46769, -25.626744],
            [-56.443962, -25.621711]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "YATAITY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.306189, -25.56874],
            [-56.302515, -25.632514],
            [-56.325448, -25.624935],
            [-56.33895, -25.632473],
            [-56.362366, -25.623408],
            [-56.385044, -25.622612],
            [-56.422928, -25.628521],
            [-56.443962, -25.621711],
            [-56.430005, -25.616172],
            [-56.41695, -25.58112],
            [-56.389795, -25.565875],
            [-56.368971, -25.578189],
            [-56.356234, -25.569623],
            [-56.333285, -25.57385],
            [-56.317261, -25.564827],
            [-56.306189, -25.56874]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "DOCTOR BOTTRELL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.633585, -25.65027],
            [-55.643693, -25.676042],
            [-55.662527, -25.699718],
            [-55.674354, -25.738374],
            [-55.689608, -25.742986],
            [-55.703147, -25.721492],
            [-55.73582, -25.710407],
            [-55.765212, -25.726537],
            [-55.755193, -25.771686],
            [-55.778722, -25.776616],
            [-55.789392, -25.78833],
            [-55.813625, -25.784088],
            [-55.823717, -25.797352],
            [-55.848217, -25.802523],
            [-55.867591, -25.819641],
            [-55.887567, -25.855247],
            [-55.912355, -25.876045],
            [-55.93567, -25.854463],
            [-55.983205, -25.854364],
            [-55.997689, -25.872776],
            [-56.009762, -25.877585],
            [-56.030236, -25.870703],
            [-56.034183, -25.862157],
            [-56.032941, -25.805788],
            [-56.029186, -25.79546],
            [-56.038711, -25.767988],
            [-56.060452, -25.770316],
            [-56.063607, -25.753428],
            [-56.073867, -25.746356],
            [-56.097131, -25.71131],
            [-56.100914, -25.683829],
            [-56.118748, -25.658276],
            [-56.098325, -25.653406],
            [-56.079848, -25.640135],
            [-56.068363, -25.641462],
            [-56.062358, -25.656629],
            [-56.029605, -25.661656],
            [-56.010383, -25.67583],
            [-55.957751, -25.628321],
            [-55.943138, -25.626837],
            [-55.933161, -25.627229],
            [-55.860078, -25.656747],
            [-55.861593, -25.678564],
            [-55.837358, -25.685348],
            [-55.786869, -25.692779],
            [-55.766773, -25.681094],
            [-55.746604, -25.691246],
            [-55.720324, -25.675498],
            [-55.693877, -25.678459],
            [-55.666178, -25.645696],
            [-55.633585, -25.65027]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "PASO YOBAI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.662314, -25.706708],
            [-56.65676, -25.717481],
            [-56.655783, -25.751806],
            [-56.64279, -25.770525],
            [-56.622671, -25.779971],
            [-56.618632, -25.805067],
            [-56.633577, -25.822559],
            [-56.619856, -25.86526],
            [-56.627668, -25.886487],
            [-56.666513, -25.849005],
            [-56.689541, -25.762165],
            [-56.669835, -25.700155],
            [-56.669062, -25.700086],
            [-56.662314, -25.706708]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "GUAIRÁ",
        "dist_desc_": "TEBICUARY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.370806, -25.34257],
            [-56.386287, -25.39376],
            [-56.363079, -25.414558],
            [-56.339482, -25.407238],
            [-56.308491, -25.404758],
            [-56.278962, -25.42348],
            [-56.268913, -25.425176],
            [-56.239027, -25.404455],
            [-56.230099, -25.417274],
            [-56.182073, -25.40677],
            [-56.150344, -25.424973],
            [-56.168375, -25.440393],
            [-56.183323, -25.441558],
            [-56.191055, -25.460575],
            [-56.23624, -25.478653],
            [-56.250643, -25.51555],
            [-56.242215, -25.523963],
            [-56.246779, -25.543528],
            [-56.259733, -25.543535],
            [-56.267376, -25.557746],
            [-56.292163, -25.569038],
            [-56.306189, -25.56874],
            [-56.317261, -25.564827],
            [-56.333285, -25.57385],
            [-56.356234, -25.569623],
            [-56.368971, -25.578189],
            [-56.389795, -25.565875],
            [-56.41695, -25.58112],
            [-56.430005, -25.616172],
            [-56.443962, -25.621711],
            [-56.46769, -25.626744],
            [-56.481575, -25.635729],
            [-56.495153, -25.622927],
            [-56.528384, -25.624785],
            [-56.550514, -25.63915],
            [-56.584448, -25.662496],
            [-56.609438, -25.678555],
            [-56.625624, -25.676376],
            [-56.648903, -25.686064],
            [-56.662314, -25.706708],
            [-56.669062, -25.700086],
            [-56.677162, -25.692839],
            [-56.654898, -25.640219],
            [-56.64369, -25.635013],
            [-56.622871, -25.59621],
            [-56.591675, -25.589825],
            [-56.559335, -25.544098],
            [-56.520852, -25.522523],
            [-56.519143, -25.472289],
            [-56.512627, -25.4673],
            [-56.507665, -25.401529],
            [-56.501654, -25.386027],
            [-56.513244, -25.368474],
            [-56.484928, -25.378885],
            [-56.475695, -25.282985],
            [-56.437901, -25.230817],
            [-56.437865, -25.242561],
            [-56.39192, -25.291516],
            [-56.386275, -25.311528],
            [-56.389203, -25.327673],
            [-56.370806, -25.34257]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "CORONEL OVIEDO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.966372, -25.209312],
            [-55.981391, -25.247044],
            [-55.98185, -25.295691],
            [-55.953816, -25.310462],
            [-55.927532, -25.309623],
            [-55.919004, -25.334798],
            [-55.897206, -25.361102],
            [-55.891992, -25.376274],
            [-55.893435, -25.401974],
            [-55.874994, -25.45089],
            [-55.874767, -25.465372],
            [-55.847548, -25.491102],
            [-55.828134, -25.492949],
            [-55.830522, -25.501292],
            [-55.859248, -25.507027],
            [-55.902975, -25.511166],
            [-55.933752, -25.506937],
            [-55.981347, -25.519407],
            [-55.995156, -25.508929],
            [-56.012412, -25.517069],
            [-56.133726, -25.590065],
            [-56.120886, -25.607682],
            [-56.154692, -25.599507],
            [-56.205938, -25.576799],
            [-56.231182, -25.580266],
            [-56.256065, -25.578322],
            [-56.287292, -25.585336],
            [-56.292163, -25.569038],
            [-56.267376, -25.557746],
            [-56.259733, -25.543535],
            [-56.246779, -25.543528],
            [-56.242215, -25.523963],
            [-56.250643, -25.51555],
            [-56.23624, -25.478653],
            [-56.191055, -25.460575],
            [-56.183323, -25.441558],
            [-56.168375, -25.440393],
            [-56.150344, -25.424973],
            [-56.182073, -25.40677],
            [-56.137014, -25.394547],
            [-56.120579, -25.393152],
            [-56.093165, -25.382012],
            [-56.096712, -25.345621],
            [-56.088182, -25.318176],
            [-56.100552, -25.284123],
            [-56.119011, -25.26668],
            [-56.145993, -25.267606],
            [-56.143372, -25.259229],
            [-56.120634, -25.254431],
            [-56.119224, -25.231604],
            [-56.080798, -25.227248],
            [-56.061078, -25.216121],
            [-56.059229, -25.193452],
            [-56.016327, -25.193236],
            [-55.994697, -25.188052],
            [-55.976591, -25.206557],
            [-55.966372, -25.209312]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "CAAGUAZÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.308038, -25.14076],
            [-56.286047, -25.129824],
            [-56.192786, -25.119543],
            [-56.182363, -25.111322],
            [-56.156324, -25.110932],
            [-56.130938, -25.127569],
            [-56.111317, -25.168035],
            [-56.096022, -25.168772],
            [-56.075435, -25.16096],
            [-56.059229, -25.193452],
            [-56.061078, -25.216121],
            [-56.080798, -25.227248],
            [-56.119224, -25.231604],
            [-56.120634, -25.254431],
            [-56.143372, -25.259229],
            [-56.145993, -25.267606],
            [-56.178907, -25.283159],
            [-56.210866, -25.284272],
            [-56.218952, -25.311475],
            [-56.262689, -25.314026],
            [-56.287849, -25.327903],
            [-56.303026, -25.323417],
            [-56.307653, -25.341118],
            [-56.327853, -25.336906],
            [-56.341995, -25.346765],
            [-56.370806, -25.34257],
            [-56.389203, -25.327673],
            [-56.386275, -25.311528],
            [-56.39192, -25.291516],
            [-56.437865, -25.242561],
            [-56.437901, -25.230817],
            [-56.457644, -25.22428],
            [-56.458665, -25.211053],
            [-56.471792, -25.186509],
            [-56.503466, -25.167223],
            [-56.522349, -25.172182],
            [-56.533894, -25.166864],
            [-56.56168, -25.166074],
            [-56.564242, -25.011932],
            [-56.52174, -25.018325],
            [-56.490413, -25.032452],
            [-56.46683, -25.051877],
            [-56.437315, -25.063716],
            [-56.416027, -25.088098],
            [-56.388133, -25.094068],
            [-56.358865, -25.112159],
            [-56.342811, -25.131567],
            [-56.308038, -25.14076]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "CARAYAÓ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.150852, -25.052502],
            [-56.144659, -25.085137],
            [-56.130938, -25.127569],
            [-56.156324, -25.110932],
            [-56.182363, -25.111322],
            [-56.192786, -25.119543],
            [-56.286047, -25.129824],
            [-56.308038, -25.14076],
            [-56.302789, -25.102794],
            [-56.318141, -25.095167],
            [-56.303656, -25.067972],
            [-56.267466, -25.051515],
            [-56.259011, -25.035503],
            [-56.195676, -25.063552],
            [-56.156706, -25.057493],
            [-56.150852, -25.052502]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "DOCTOR CECILIO BÁEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.176524, -24.894305],
            [-56.161899, -24.928346],
            [-56.151114, -24.937293],
            [-56.128384, -24.935166],
            [-56.11883, -24.918813],
            [-56.102968, -24.922314],
            [-56.103332, -24.942896],
            [-56.093293, -24.953284],
            [-56.119243, -24.968787],
            [-56.133165, -24.988379],
            [-56.156118, -24.992678],
            [-56.184286, -24.98702],
            [-56.198866, -25.000627],
            [-56.209514, -24.999442],
            [-56.255638, -25.017262],
            [-56.275782, -24.999675],
            [-56.334593, -24.98686],
            [-56.347447, -24.995573],
            [-56.359561, -24.987326],
            [-56.382423, -24.98978],
            [-56.395972, -24.975323],
            [-56.413647, -24.96956],
            [-56.427745, -24.944428],
            [-56.420049, -24.933647],
            [-56.400981, -24.928929],
            [-56.392175, -24.913352],
            [-56.369432, -24.912318],
            [-56.353049, -24.920561],
            [-56.32813, -24.917344],
            [-56.298665, -24.939866],
            [-56.278033, -24.941122],
            [-56.262941, -24.927557],
            [-56.24882, -24.925567],
            [-56.197163, -24.940447],
            [-56.277746, -24.809199],
            [-56.254855, -24.766173],
            [-56.222655, -24.800904],
            [-56.215241, -24.838853],
            [-56.200056, -24.855683],
            [-56.176524, -24.894305]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "SANTA ROSA DEL MBUTUY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.940699, -25.214566],
            [-55.900875, -25.233983],
            [-55.884767, -25.238386],
            [-55.864116, -25.252406],
            [-55.847908, -25.251648],
            [-55.827682, -25.262428],
            [-55.803952, -25.260251],
            [-55.776657, -25.276393],
            [-55.736513, -25.281558],
            [-55.7177, -25.275003],
            [-55.703972, -25.275983],
            [-55.716853, -25.307944],
            [-55.716754, -25.327745],
            [-55.72862, -25.335572],
            [-55.732419, -25.389089],
            [-55.715055, -25.400992],
            [-55.69949, -25.441563],
            [-55.677538, -25.459854],
            [-55.675039, -25.479045],
            [-55.663468, -25.503224],
            [-55.681185, -25.516155],
            [-55.709401, -25.512163],
            [-55.737644, -25.482147],
            [-55.771505, -25.479915],
            [-55.786266, -25.498334],
            [-55.828134, -25.492949],
            [-55.847548, -25.491102],
            [-55.874767, -25.465372],
            [-55.874994, -25.45089],
            [-55.893435, -25.401974],
            [-55.891992, -25.376274],
            [-55.897206, -25.361102],
            [-55.919004, -25.334798],
            [-55.927532, -25.309623],
            [-55.953816, -25.310462],
            [-55.98185, -25.295691],
            [-55.981391, -25.247044],
            [-55.966372, -25.209312],
            [-55.966365, -25.209315],
            [-55.940699, -25.214566]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "DOCTOR JUAN MANUEL FRUTOS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.663468, -25.503224],
            [-55.640768, -25.505322],
            [-55.62102, -25.515638],
            [-55.604825, -25.544878],
            [-55.584476, -25.536787],
            [-55.560182, -25.537051],
            [-55.538923, -25.554753],
            [-55.514017, -25.562642],
            [-55.53396, -25.579993],
            [-55.546121, -25.619203],
            [-55.56187, -25.637357],
            [-55.573884, -25.634279],
            [-55.590661, -25.656408],
            [-55.614144, -25.648977],
            [-55.633585, -25.65027],
            [-55.666178, -25.645696],
            [-55.693877, -25.678459],
            [-55.720324, -25.675498],
            [-55.746604, -25.691246],
            [-55.766773, -25.681094],
            [-55.786869, -25.692779],
            [-55.837358, -25.685348],
            [-55.861593, -25.678564],
            [-55.860078, -25.656747],
            [-55.933161, -25.627229],
            [-55.943138, -25.626837],
            [-56.059975, -25.622427],
            [-56.120886, -25.607682],
            [-56.133726, -25.590065],
            [-56.012412, -25.517069],
            [-55.995156, -25.508929],
            [-55.981347, -25.519407],
            [-55.933752, -25.506937],
            [-55.902975, -25.511166],
            [-55.859248, -25.507027],
            [-55.830522, -25.501292],
            [-55.828134, -25.492949],
            [-55.786266, -25.498334],
            [-55.771505, -25.479915],
            [-55.737644, -25.482147],
            [-55.709401, -25.512163],
            [-55.681185, -25.516155],
            [-55.663468, -25.503224]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "REPATRIACIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.513244, -25.368474],
            [-56.501654, -25.386027],
            [-56.507665, -25.401529],
            [-56.512627, -25.4673],
            [-56.519143, -25.472289],
            [-56.520852, -25.522523],
            [-56.559335, -25.544098],
            [-56.575371, -25.539239],
            [-56.576703, -25.515805],
            [-56.571494, -25.496246],
            [-56.590425, -25.4834],
            [-56.614883, -25.47491],
            [-56.622559, -25.459965],
            [-56.625426, -25.431794],
            [-56.649135, -25.408681],
            [-56.651069, -25.397533],
            [-56.561362, -25.306111],
            [-56.551812, -25.30513],
            [-56.532648, -25.323136],
            [-56.513244, -25.368474]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "NUEVA LONDRES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.966365, -25.209315],
            [-55.966372, -25.209312],
            [-55.976591, -25.206557],
            [-55.994697, -25.188052],
            [-56.016327, -25.193236],
            [-56.059229, -25.193452],
            [-56.075435, -25.16096],
            [-56.096022, -25.168772],
            [-56.111317, -25.168035],
            [-56.130938, -25.127569],
            [-56.144659, -25.085137],
            [-56.150852, -25.052502],
            [-56.141954, -25.049132],
            [-56.146249, -25.016745],
            [-56.156118, -24.992678],
            [-56.133165, -24.988379],
            [-56.119243, -24.968787],
            [-56.093293, -24.953284],
            [-56.103332, -24.942896],
            [-56.102968, -24.922314],
            [-56.088941, -24.932729],
            [-56.050659, -24.906208],
            [-56.024258, -24.906038],
            [-56.024134, -24.888207],
            [-55.964057, -24.913259],
            [-55.951041, -24.911064],
            [-55.949566, -24.941756],
            [-55.969151, -24.961127],
            [-55.977082, -25.025048],
            [-55.975732, -25.04244],
            [-55.991806, -25.044238],
            [-55.999149, -25.06605],
            [-56.012857, -25.082961],
            [-55.999094, -25.113219],
            [-55.970071, -25.124095],
            [-55.964279, -25.135379],
            [-55.97456, -25.153659],
            [-55.97498, -25.200342],
            [-55.966365, -25.209315]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "SAN JOAQUÍN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.559335, -25.544098],
            [-56.591675, -25.589825],
            [-56.622871, -25.59621],
            [-56.64369, -25.635013],
            [-56.654898, -25.640219],
            [-56.677162, -25.692839],
            [-56.669062, -25.700086],
            [-56.669835, -25.700155],
            [-56.692916, -25.69975],
            [-56.715617, -25.669915],
            [-56.719684, -25.658716],
            [-56.802286, -25.582017],
            [-56.83124, -25.544237],
            [-56.834052, -25.533499],
            [-56.853035, -25.535367],
            [-56.851227, -25.507642],
            [-56.833765, -25.496335],
            [-56.807155, -25.49019],
            [-56.805761, -25.482386],
            [-56.773974, -25.4649],
            [-56.722019, -25.435117],
            [-56.672973, -25.413865],
            [-56.651069, -25.397533],
            [-56.649135, -25.408681],
            [-56.625426, -25.431794],
            [-56.622559, -25.459965],
            [-56.614883, -25.47491],
            [-56.590425, -25.4834],
            [-56.571494, -25.496246],
            [-56.576703, -25.515805],
            [-56.575371, -25.539239],
            [-56.559335, -25.544098]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "SAN JOSÉ DE LOS ARROYOS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.592494, -24.60245],
            [-55.562509, -24.655536],
            [-55.56582, -24.670688],
            [-55.552429, -24.686294],
            [-55.537552, -24.690912],
            [-55.528042, -24.709768],
            [-55.484293, -24.736285],
            [-55.472723, -24.736407],
            [-55.456066, -24.749933],
            [-55.425584, -24.753167],
            [-55.413519, -24.77611],
            [-55.375881, -24.815686],
            [-55.400618, -24.829385],
            [-55.417914, -24.822026],
            [-55.445923, -24.821918],
            [-55.486123, -24.834944],
            [-55.707863, -24.912186],
            [-55.74141, -24.895477],
            [-55.757163, -24.901316],
            [-55.767496, -24.915787],
            [-55.790146, -24.924501],
            [-55.79517, -24.940777],
            [-55.830982, -24.971105],
            [-55.852744, -24.959639],
            [-55.875921, -24.999647],
            [-55.853249, -25.018121],
            [-55.829001, -25.01465],
            [-55.804646, -25.02424],
            [-55.794562, -25.040582],
            [-55.775471, -25.053136],
            [-55.758139, -25.057584],
            [-55.729111, -25.082479],
            [-55.709578, -25.09941],
            [-55.704394, -25.128181],
            [-55.714573, -25.128486],
            [-55.686789, -25.169423],
            [-55.688051, -25.176289],
            [-55.704237, -25.179275],
            [-55.741724, -25.177743],
            [-55.76483, -25.171152],
            [-55.793955, -25.155752],
            [-55.827126, -25.180308],
            [-55.837463, -25.16286],
            [-55.85422, -25.161415],
            [-55.877922, -25.150589],
            [-55.889519, -25.136458],
            [-55.940699, -25.214566],
            [-55.966365, -25.209315],
            [-55.97498, -25.200342],
            [-55.97456, -25.153659],
            [-55.964279, -25.135379],
            [-55.970071, -25.124095],
            [-55.999094, -25.113219],
            [-56.012857, -25.082961],
            [-55.999149, -25.06605],
            [-55.991806, -25.044238],
            [-55.975732, -25.04244],
            [-55.977082, -25.025048],
            [-55.969151, -24.961127],
            [-55.949566, -24.941756],
            [-55.951041, -24.911064],
            [-55.964057, -24.913259],
            [-56.024134, -24.888207],
            [-55.988705, -24.863221],
            [-55.990516, -24.838419],
            [-55.972534, -24.833745],
            [-55.938318, -24.846133],
            [-55.884079, -24.847499],
            [-55.868537, -24.857954],
            [-55.846136, -24.861453],
            [-55.826973, -24.845741],
            [-55.797103, -24.836629],
            [-55.781163, -24.837822],
            [-55.776427, -24.822422],
            [-55.729978, -24.825008],
            [-55.712114, -24.8199],
            [-55.708015, -24.790957],
            [-55.701991, -24.78397],
            [-55.718269, -24.758095],
            [-55.736106, -24.743189],
            [-55.727095, -24.72135],
            [-55.712726, -24.707917],
            [-55.702707, -24.688919],
            [-55.670795, -24.672122],
            [-55.668465, -24.653189],
            [-55.638464, -24.644827],
            [-55.612427, -24.646075],
            [-55.6018, -24.634745],
            [-55.592494, -24.60245]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "YHÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.557725, -25.267269],
            [-55.545577, -25.274248],
            [-55.513194, -25.31071],
            [-55.507797, -25.345503],
            [-55.481062, -25.355105],
            [-55.477826, -25.412276],
            [-55.476412, -25.523741],
            [-55.495888, -25.561066],
            [-55.514017, -25.562642],
            [-55.538923, -25.554753],
            [-55.560182, -25.537051],
            [-55.584476, -25.536787],
            [-55.604825, -25.544878],
            [-55.62102, -25.515638],
            [-55.640768, -25.505322],
            [-55.663468, -25.503224],
            [-55.675039, -25.479045],
            [-55.677538, -25.459854],
            [-55.69949, -25.441563],
            [-55.715055, -25.400992],
            [-55.732419, -25.389089],
            [-55.72862, -25.335572],
            [-55.716754, -25.327745],
            [-55.716853, -25.307944],
            [-55.703972, -25.275983],
            [-55.665164, -25.26182],
            [-55.644846, -25.270887],
            [-55.626906, -25.271512],
            [-55.602623, -25.263527],
            [-55.58515, -25.26906],
            [-55.557725, -25.267269]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "DOCTOR J. EULOGIO ESTIGARRIBIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.182073, -25.40677],
            [-56.230099, -25.417274],
            [-56.239027, -25.404455],
            [-56.268913, -25.425176],
            [-56.278962, -25.42348],
            [-56.308491, -25.404758],
            [-56.339482, -25.407238],
            [-56.363079, -25.414558],
            [-56.386287, -25.39376],
            [-56.370806, -25.34257],
            [-56.341995, -25.346765],
            [-56.327853, -25.336906],
            [-56.307653, -25.341118],
            [-56.303026, -25.323417],
            [-56.287849, -25.327903],
            [-56.262689, -25.314026],
            [-56.218952, -25.311475],
            [-56.210866, -25.284272],
            [-56.178907, -25.283159],
            [-56.145993, -25.267606],
            [-56.119011, -25.26668],
            [-56.100552, -25.284123],
            [-56.088182, -25.318176],
            [-56.096712, -25.345621],
            [-56.093165, -25.382012],
            [-56.120579, -25.393152],
            [-56.137014, -25.394547],
            [-56.182073, -25.40677]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "R.I. 3 CORRALES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.402366, -25.106807],
            [-55.392452, -25.122285],
            [-55.366968, -25.12493],
            [-55.363075, -25.134097],
            [-55.388691, -25.142119],
            [-55.412968, -25.140638],
            [-55.418148, -25.154697],
            [-55.403844, -25.199962],
            [-55.424101, -25.200288],
            [-55.418211, -25.225008],
            [-55.441192, -25.230638],
            [-55.45367, -25.219371],
            [-55.463912, -25.228834],
            [-55.511065, -25.228502],
            [-55.510804, -25.237546],
            [-55.542382, -25.239612],
            [-55.541818, -25.251375],
            [-55.564704, -25.254208],
            [-55.557725, -25.267269],
            [-55.58515, -25.26906],
            [-55.602623, -25.263527],
            [-55.626906, -25.271512],
            [-55.644846, -25.270887],
            [-55.665164, -25.26182],
            [-55.703972, -25.275983],
            [-55.7177, -25.275003],
            [-55.688051, -25.176289],
            [-55.686789, -25.169423],
            [-55.714573, -25.128486],
            [-55.704394, -25.128181],
            [-55.709578, -25.09941],
            [-55.729111, -25.082479],
            [-55.714891, -25.076056],
            [-55.686369, -25.040925],
            [-55.67946, -25.022358],
            [-55.700167, -25.017125],
            [-55.676851, -25.011667],
            [-55.648726, -25.022999],
            [-55.631199, -25.03999],
            [-55.60709, -25.036077],
            [-55.572749, -25.065042],
            [-55.553831, -25.064159],
            [-55.523404, -25.071214],
            [-55.489112, -25.083523],
            [-55.472955, -25.073697],
            [-55.446607, -25.090014],
            [-55.434485, -25.113142],
            [-55.402366, -25.106807]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "RAÚL ARSENIO OVIEDO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.378436, -25.361914],
            [-55.426062, -25.557542],
            [-55.432483, -25.543784],
            [-55.476412, -25.523741],
            [-55.477826, -25.412276],
            [-55.481062, -25.355105],
            [-55.417028, -25.362798],
            [-55.378436, -25.361914]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "JOSÉ DOMINGO OCAMPOS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.312739, -25.001805],
            [-55.294287, -25.023168],
            [-55.277307, -25.023885],
            [-55.275727, -25.038248],
            [-55.229126, -25.029408],
            [-55.232697, -25.042762],
            [-55.210648, -25.049148],
            [-55.193267, -25.04297],
            [-55.176294, -25.058814],
            [-55.159835, -25.096041],
            [-55.147529, -25.097319],
            [-55.106961, -25.131952],
            [-55.056213, -25.160806],
            [-55.026819, -25.18122],
            [-55.01641, -25.196013],
            [-55.026888, -25.222413],
            [-55.017009, -25.244222],
            [-54.980917, -25.26329],
            [-54.974729, -25.283314],
            [-54.956127, -25.319684],
            [-54.938235, -25.334262],
            [-54.950017, -25.345809],
            [-54.935052, -25.354564],
            [-54.943998, -25.366907],
            [-54.960914, -25.361279],
            [-54.965461, -25.375289],
            [-55.000168, -25.387518],
            [-55.021251, -25.378072],
            [-55.031534, -25.358517],
            [-55.042375, -25.319506],
            [-55.058655, -25.31361],
            [-55.099059, -25.325457],
            [-55.123678, -25.327808],
            [-55.159652, -25.320395],
            [-55.191369, -25.29759],
            [-55.219968, -25.265591],
            [-55.224168, -25.238349],
            [-55.242094, -25.200438],
            [-55.296841, -25.171167],
            [-55.340186, -25.152131],
            [-55.363075, -25.134097],
            [-55.366968, -25.12493],
            [-55.392452, -25.122285],
            [-55.402366, -25.106807],
            [-55.404069, -25.093414],
            [-55.420659, -25.071352],
            [-55.422312, -25.038546],
            [-55.41055, -25.023848],
            [-55.403666, -24.993568],
            [-55.380003, -24.990766],
            [-55.356896, -25.005297],
            [-55.33585, -25.000012],
            [-55.312739, -25.001805]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "MARISCAL FRANCISCO SOLANO LÓPEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.56168, -25.166074],
            [-56.533894, -25.166864],
            [-56.522349, -25.172182],
            [-56.503466, -25.167223],
            [-56.471792, -25.186509],
            [-56.458665, -25.211053],
            [-56.457644, -25.22428],
            [-56.437901, -25.230817],
            [-56.475695, -25.282985],
            [-56.484928, -25.378885],
            [-56.513244, -25.368474],
            [-56.532648, -25.323136],
            [-56.551812, -25.30513],
            [-56.561362, -25.306111],
            [-56.606851, -25.314133],
            [-56.623161, -25.313496],
            [-56.645915, -25.293723],
            [-56.66345, -25.26199],
            [-56.619033, -25.166777],
            [-56.56168, -25.166074]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "LA PASTORA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.688051, -25.176289],
            [-55.7177, -25.275003],
            [-55.736513, -25.281558],
            [-55.776657, -25.276393],
            [-55.803952, -25.260251],
            [-55.827682, -25.262428],
            [-55.847908, -25.251648],
            [-55.864116, -25.252406],
            [-55.884767, -25.238386],
            [-55.900875, -25.233983],
            [-55.940699, -25.214566],
            [-55.889519, -25.136458],
            [-55.877922, -25.150589],
            [-55.85422, -25.161415],
            [-55.837463, -25.16286],
            [-55.827126, -25.180308],
            [-55.793955, -25.155752],
            [-55.76483, -25.171152],
            [-55.741724, -25.177743],
            [-55.704237, -25.179275],
            [-55.688051, -25.176289]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "3 DE FEBRERO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.156118, -24.992678],
            [-56.146249, -25.016745],
            [-56.141954, -25.049132],
            [-56.150852, -25.052502],
            [-56.156706, -25.057493],
            [-56.195676, -25.063552],
            [-56.259011, -25.035503],
            [-56.267466, -25.051515],
            [-56.303656, -25.067972],
            [-56.318141, -25.095167],
            [-56.302789, -25.102794],
            [-56.308038, -25.14076],
            [-56.342811, -25.131567],
            [-56.358865, -25.112159],
            [-56.388133, -25.094068],
            [-56.416027, -25.088098],
            [-56.437315, -25.063716],
            [-56.46683, -25.051877],
            [-56.490413, -25.032452],
            [-56.52174, -25.018325],
            [-56.564242, -25.011932],
            [-56.564484, -24.997337],
            [-56.545367, -25.00315],
            [-56.51948, -25.003886],
            [-56.427745, -24.944428],
            [-56.413647, -24.96956],
            [-56.395972, -24.975323],
            [-56.382423, -24.98978],
            [-56.359561, -24.987326],
            [-56.347447, -24.995573],
            [-56.334593, -24.98686],
            [-56.275782, -24.999675],
            [-56.255638, -25.017262],
            [-56.209514, -24.999442],
            [-56.198866, -25.000627],
            [-56.184286, -24.98702],
            [-56.156118, -24.992678]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "SIMÓN BOLIVAR"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.154635, -24.479057],
            [-55.138767, -24.496782],
            [-55.160848, -24.518731],
            [-55.21456, -24.515227],
            [-55.237797, -24.519098],
            [-55.24723, -24.514509],
            [-55.269593, -24.523168],
            [-55.30208, -24.567184],
            [-55.30545, -24.592002],
            [-55.292657, -24.612836],
            [-55.301445, -24.633549],
            [-55.292578, -24.646202],
            [-55.315383, -24.677053],
            [-55.314855, -24.697177],
            [-55.303439, -24.704624],
            [-55.303417, -24.725729],
            [-55.322848, -24.751616],
            [-55.321423, -24.767983],
            [-55.335092, -24.80473],
            [-55.336609, -24.831797],
            [-55.348866, -24.842709],
            [-55.364012, -24.831314],
            [-55.377267, -24.864319],
            [-55.400576, -24.879478],
            [-55.422299, -24.8751],
            [-55.457276, -24.893636],
            [-55.530079, -24.890899],
            [-55.548747, -24.893222],
            [-55.559482, -24.901976],
            [-55.586, -24.901232],
            [-55.600989, -24.917611],
            [-55.630877, -24.92729],
            [-55.657521, -24.951116],
            [-55.665345, -24.974168],
            [-55.682672, -24.987434],
            [-55.708073, -24.993322],
            [-55.700167, -25.017125],
            [-55.67946, -25.022358],
            [-55.686369, -25.040925],
            [-55.714891, -25.076056],
            [-55.729111, -25.082479],
            [-55.758139, -25.057584],
            [-55.775471, -25.053136],
            [-55.794562, -25.040582],
            [-55.804646, -25.02424],
            [-55.829001, -25.01465],
            [-55.853249, -25.018121],
            [-55.875921, -24.999647],
            [-55.852744, -24.959639],
            [-55.830982, -24.971105],
            [-55.79517, -24.940777],
            [-55.790146, -24.924501],
            [-55.767496, -24.915787],
            [-55.757163, -24.901316],
            [-55.74141, -24.895477],
            [-55.707863, -24.912186],
            [-55.486123, -24.834944],
            [-55.445923, -24.821918],
            [-55.417914, -24.822026],
            [-55.400618, -24.829385],
            [-55.375881, -24.815686],
            [-55.413519, -24.77611],
            [-55.425584, -24.753167],
            [-55.456066, -24.749933],
            [-55.472723, -24.736407],
            [-55.484293, -24.736285],
            [-55.528042, -24.709768],
            [-55.537552, -24.690912],
            [-55.552429, -24.686294],
            [-55.56582, -24.670688],
            [-55.562509, -24.655536],
            [-55.592494, -24.60245],
            [-55.577875, -24.601239],
            [-55.56419, -24.581454],
            [-55.551627, -24.550859],
            [-55.552465, -24.51865],
            [-55.543932, -24.513539],
            [-55.513492, -24.515307],
            [-55.493706, -24.533788],
            [-55.491108, -24.568021],
            [-55.460479, -24.541427],
            [-55.437838, -24.551255],
            [-55.400627, -24.536478],
            [-55.392659, -24.544614],
            [-55.369768, -24.539964],
            [-55.345172, -24.509034],
            [-55.32944, -24.506011],
            [-55.310341, -24.511868],
            [-55.304158, -24.493571],
            [-55.272355, -24.49292],
            [-55.252526, -24.467507],
            [-55.238953, -24.475998],
            [-55.210568, -24.468604],
            [-55.1803, -24.465456],
            [-55.154635, -24.479057]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "VAQUERÍA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.437354, -27.050781],
            [-56.469077, -27.05451],
            [-56.482484, -27.063631],
            [-56.47365, -27.100448],
            [-56.459289, -27.125903],
            [-56.462554, -27.150158],
            [-56.476901, -27.165951],
            [-56.471163, -27.19109],
            [-56.470697, -27.22351],
            [-56.524386, -27.230671],
            [-56.55115, -27.215443],
            [-56.529839, -27.186331],
            [-56.549817, -27.173285],
            [-56.538227, -27.158618],
            [-56.544475, -27.146012],
            [-56.629554, -27.154275],
            [-56.63892, -27.159107],
            [-56.634802, -27.138759],
            [-56.640758, -27.035484],
            [-56.625861, -27.016422],
            [-56.629229, -26.997258],
            [-56.64405, -26.978312],
            [-56.64703, -26.926496],
            [-56.614185, -26.894671],
            [-56.600574, -26.888159],
            [-56.561993, -26.912292],
            [-56.541127, -26.938283],
            [-56.539702, -26.966099],
            [-56.464733, -27.00678],
            [-56.443315, -27.016309],
            [-56.437354, -27.050781]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "GENERAL DELGADO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.564899, -27.125635],
            [-55.562304, -27.159517],
            [-55.57449, -27.16741],
            [-55.588925, -27.16202],
            [-55.611695, -27.167655],
            [-55.620825, -27.142002],
            [-55.674586, -27.092932],
            [-55.668314, -27.076273],
            [-55.691157, -27.064588],
            [-55.701731, -27.048443],
            [-55.70097, -27.029234],
            [-55.727644, -27.007696],
            [-55.767149, -27.009512],
            [-55.786451, -26.992066],
            [-55.811983, -27.018813],
            [-55.822887, -27.011457],
            [-55.800939, -26.988511],
            [-55.791817, -26.968093],
            [-55.875891, -26.891587],
            [-55.888277, -26.880405],
            [-55.858989, -26.860381],
            [-55.814438, -26.899395],
            [-55.675184, -27.028],
            [-55.585731, -27.108799],
            [-55.564899, -27.125635]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "HOHENAU"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.674586, -27.092932],
            [-55.697026, -27.09282],
            [-55.698074, -27.106664],
            [-55.719528, -27.109714],
            [-55.730422, -27.07416],
            [-55.748579, -27.073302],
            [-55.756669, -27.083936],
            [-55.771039, -27.071072],
            [-55.787242, -27.079658],
            [-55.798188, -27.070011],
            [-55.840658, -27.105986],
            [-55.878446, -27.075518],
            [-55.875308, -27.056666],
            [-55.855078, -27.044988],
            [-55.822887, -27.011457],
            [-55.811983, -27.018813],
            [-55.786451, -26.992066],
            [-55.767149, -27.009512],
            [-55.727644, -27.007696],
            [-55.70097, -27.029234],
            [-55.701731, -27.048443],
            [-55.691157, -27.064588],
            [-55.668314, -27.076273],
            [-55.674586, -27.092932]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "JESÚS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.175596, -26.706033],
            [-56.167062, -26.711752],
            [-56.163762, -26.736312],
            [-56.139415, -26.756819],
            [-56.183421, -26.777775],
            [-56.214879, -26.800656],
            [-56.255431, -26.801237],
            [-56.312131, -26.737669],
            [-56.31363, -26.729115],
            [-56.283807, -26.718411],
            [-56.254838, -26.701921],
            [-56.216052, -26.69764],
            [-56.184914, -26.711174],
            [-56.175596, -26.706033]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "JOSÉ LEANDRO OVIEDO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.531918, -27.101683],
            [-55.555194, -27.106019],
            [-55.564899, -27.125635],
            [-55.585731, -27.108799],
            [-55.675184, -27.028],
            [-55.814438, -26.899395],
            [-55.858989, -26.860381],
            [-55.854169, -26.822983],
            [-55.761764, -26.773016],
            [-55.696101, -26.83186],
            [-55.699111, -26.83916],
            [-55.579605, -26.946871],
            [-55.61354, -26.961238],
            [-55.646013, -26.986974],
            [-55.647965, -26.994747],
            [-55.535433, -27.095821],
            [-55.531918, -27.101683]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "OBLIGADO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.672423, -26.254019],
            [-54.67489, -26.278456],
            [-54.652065, -26.298251],
            [-54.651953, -26.320846],
            [-54.674555, -26.344069],
            [-54.696503, -26.37757],
            [-54.696461, -26.404361],
            [-54.762849, -26.347881],
            [-54.908362, -26.220952],
            [-54.916272, -26.211473],
            [-54.91648, -26.189696],
            [-54.883816, -26.195519],
            [-54.870696, -26.190632],
            [-54.87467, -26.174255],
            [-54.855418, -26.188875],
            [-54.839885, -26.185601],
            [-54.82739, -26.201213],
            [-54.799772, -26.201016],
            [-54.785802, -26.217834],
            [-54.778498, -26.236395],
            [-54.721954, -26.249752],
            [-54.693862, -26.228169],
            [-54.678613, -26.239576],
            [-54.672423, -26.254019]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "MAYOR JULIO DIONISIO OTAÑO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.471163, -27.19109],
            [-56.441311, -27.173439],
            [-56.417295, -27.178584],
            [-56.39179, -27.172745],
            [-56.371544, -27.176831],
            [-56.355149, -27.169912],
            [-56.330813, -27.177313],
            [-56.294974, -27.164478],
            [-56.277932, -27.17689],
            [-56.291289, -27.202771],
            [-56.305146, -27.246881],
            [-56.302769, -27.26267],
            [-56.284182, -27.268325],
            [-56.266434, -27.292387],
            [-56.272077, -27.310227],
            [-56.309819, -27.389717],
            [-56.292493, -27.411052],
            [-56.290565, -27.448739],
            [-56.295779, -27.478909],
            [-56.334238, -27.510631],
            [-56.360184, -27.54718],
            [-56.362173, -27.570264],
            [-56.376957, -27.587815],
            [-56.407793, -27.591834],
            [-56.429092, -27.585845],
            [-56.481682, -27.555813],
            [-56.533076, -27.477187],
            [-56.548836, -27.458439],
            [-56.589339, -27.438195],
            [-56.637025, -27.44164],
            [-56.675857, -27.452208],
            [-56.694095, -27.451879],
            [-56.719086, -27.466246],
            [-56.721561, -27.483211],
            [-56.7316, -27.495036],
            [-56.750519, -27.49775],
            [-56.773917, -27.488804],
            [-56.801759, -27.471413],
            [-56.829381, -27.460666],
            [-56.855809, -27.434096],
            [-56.884837, -27.412556],
            [-56.84859, -27.410185],
            [-56.831488, -27.399382],
            [-56.791617, -27.399867],
            [-56.772511, -27.388335],
            [-56.695045, -27.369136],
            [-56.684276, -27.34657],
            [-56.669655, -27.337722],
            [-56.675038, -27.322605],
            [-56.670036, -27.292481],
            [-56.698123, -27.268968],
            [-56.696968, -27.243528],
            [-56.709545, -27.23603],
            [-56.688419, -27.201018],
            [-56.669645, -27.196623],
            [-56.654828, -27.172053],
            [-56.63892, -27.159107],
            [-56.629554, -27.154275],
            [-56.544475, -27.146012],
            [-56.538227, -27.158618],
            [-56.549817, -27.173285],
            [-56.529839, -27.186331],
            [-56.55115, -27.215443],
            [-56.524386, -27.230671],
            [-56.470697, -27.22351],
            [-56.471163, -27.19109]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "SAN COSME Y DAMIÁN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.876135, -26.457655],
            [-55.861723, -26.471309],
            [-55.814848, -26.481762],
            [-55.805336, -26.488273],
            [-55.783429, -26.530218],
            [-55.833573, -26.60867],
            [-55.842765, -26.615217],
            [-55.835991, -26.644508],
            [-55.874699, -26.691897],
            [-55.883422, -26.715737],
            [-55.886579, -26.742424],
            [-55.854169, -26.822983],
            [-55.858989, -26.860381],
            [-55.888277, -26.880405],
            [-55.875891, -26.891587],
            [-55.888119, -26.891639],
            [-55.904001, -26.904488],
            [-55.934721, -26.907277],
            [-55.959733, -26.925831],
            [-55.959289, -26.944299],
            [-56.014605, -26.967487],
            [-56.023823, -26.97842],
            [-56.047847, -26.974603],
            [-56.077882, -26.988765],
            [-56.091408, -26.970291],
            [-56.110719, -26.97302],
            [-56.117997, -26.983299],
            [-56.134475, -26.97214],
            [-56.135904, -26.955828],
            [-56.15574, -26.945589],
            [-56.158599, -26.928759],
            [-56.131313, -26.937844],
            [-56.128586, -26.929809],
            [-56.158691, -26.884933],
            [-56.19664, -26.879261],
            [-56.231859, -26.879568],
            [-56.240098, -26.819857],
            [-56.255431, -26.801237],
            [-56.214879, -26.800656],
            [-56.183421, -26.777775],
            [-56.139415, -26.756819],
            [-56.163762, -26.736312],
            [-56.167062, -26.711752],
            [-56.175596, -26.706033],
            [-56.184779, -26.678919],
            [-56.175564, -26.662529],
            [-56.159533, -26.656305],
            [-56.155789, -26.639919],
            [-56.130645, -26.634806],
            [-56.116496, -26.626097],
            [-56.121747, -26.595897],
            [-56.10615, -26.562982],
            [-56.094861, -26.550894],
            [-56.055874, -26.523506],
            [-56.050702, -26.534125],
            [-56.020374, -26.531216],
            [-56.018722, -26.516326],
            [-55.955553, -26.511295],
            [-55.919502, -26.516751],
            [-55.893158, -26.475005],
            [-55.876135, -26.457655]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "SAN PEDRO DEL PARANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.299558, -26.103186],
            [-55.311719, -26.108235],
            [-55.311409, -26.139457],
            [-55.296577, -26.148828],
            [-55.303891, -26.162672],
            [-55.28445, -26.201394],
            [-55.263084, -26.217752],
            [-55.259845, -26.235964],
            [-55.230368, -26.244793],
            [-55.212023, -26.239977],
            [-55.120147, -26.322791],
            [-55.102743, -26.324683],
            [-55.075179, -26.363513],
            [-55.059126, -26.363404],
            [-55.036971, -26.374421],
            [-55.03936, -26.389839],
            [-55.024941, -26.393422],
            [-55.032113, -26.411122],
            [-55.009913, -26.424932],
            [-54.995901, -26.420895],
            [-54.976547, -26.441057],
            [-54.963299, -26.435946],
            [-54.953734, -26.463369],
            [-54.939318, -26.477404],
            [-54.926084, -26.474843],
            [-54.911623, -26.489051],
            [-54.911591, -26.503496],
            [-54.871656, -26.524477],
            [-54.850656, -26.511855],
            [-54.824528, -26.525561],
            [-54.83349, -26.545409],
            [-54.80343, -26.544182],
            [-54.807345, -26.56241],
            [-54.787704, -26.582419],
            [-54.783728, -26.610439],
            [-54.788284, -26.633443],
            [-54.812702, -26.669297],
            [-54.833143, -26.673729],
            [-54.84966, -26.659752],
            [-54.876497, -26.656411],
            [-54.913814, -26.6667],
            [-54.943503, -26.684451],
            [-54.948091, -26.701741],
            [-54.98081, -26.697858],
            [-54.990785, -26.681831],
            [-55.028607, -26.660688],
            [-55.025147, -26.640833],
            [-55.037772, -26.633465],
            [-55.047669, -26.611193],
            [-55.029156, -26.596817],
            [-55.046299, -26.588274],
            [-55.060653, -26.598331],
            [-55.087585, -26.56912],
            [-55.095481, -26.558298],
            [-55.096506, -26.529247],
            [-55.083688, -26.514293],
            [-55.091113, -26.500442],
            [-55.129775, -26.498093],
            [-55.145276, -26.458805],
            [-55.143683, -26.446021],
            [-55.173342, -26.443722],
            [-55.185375, -26.426075],
            [-55.202274, -26.413263],
            [-55.223841, -26.412644],
            [-55.24369, -26.397318],
            [-55.268316, -26.398269],
            [-55.290407, -26.365764],
            [-55.354347, -26.377482],
            [-55.365747, -26.364445],
            [-55.384761, -26.360854],
            [-55.44622, -26.359345],
            [-55.452063, -26.324578],
            [-55.391636, -26.310047],
            [-55.375114, -26.297436],
            [-55.360003, -26.269488],
            [-55.357302, -26.230951],
            [-55.367148, -26.210066],
            [-55.354241, -26.201153],
            [-55.343039, -26.148815],
            [-55.347285, -26.11813],
            [-55.334594, -26.104511],
            [-55.317148, -26.097023],
            [-55.299558, -26.103186]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "SAN RAFAEL DEL PARANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.674586, -27.092932],
            [-55.620825, -27.142002],
            [-55.626276, -27.153087],
            [-55.653309, -27.162701],
            [-55.672737, -27.17969],
            [-55.69147, -27.188583],
            [-55.716971, -27.216669],
            [-55.840658, -27.105986],
            [-55.798188, -27.070011],
            [-55.787242, -27.079658],
            [-55.771039, -27.071072],
            [-55.756669, -27.083936],
            [-55.748579, -27.073302],
            [-55.730422, -27.07416],
            [-55.719528, -27.109714],
            [-55.698074, -27.106664],
            [-55.697026, -27.09282],
            [-55.674586, -27.092932]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "TRINIDAD"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.236842, -26.623143],
            [-55.241679, -26.650337],
            [-55.222948, -26.671699],
            [-55.220572, -26.689343],
            [-55.249169, -26.704834],
            [-55.238647, -26.714602],
            [-55.213617, -26.705202],
            [-55.207571, -26.724731],
            [-55.190799, -26.737008],
            [-55.194361, -26.759874],
            [-55.266341, -26.76222],
            [-55.292466, -26.782392],
            [-55.303063, -26.763026],
            [-55.368666, -26.732542],
            [-55.374505, -26.700117],
            [-55.397101, -26.670155],
            [-55.389591, -26.645207],
            [-55.391003, -26.624962],
            [-55.440037, -26.598874],
            [-55.470177, -26.594498],
            [-55.510665, -26.57203],
            [-55.524872, -26.525501],
            [-55.523546, -26.507094],
            [-55.534913, -26.431117],
            [-55.535174, -26.395029],
            [-55.539685, -26.384378],
            [-55.532806, -26.355603],
            [-55.498236, -26.350111],
            [-55.459668, -26.401016],
            [-55.441731, -26.429231],
            [-55.41121, -26.444534],
            [-55.377156, -26.503207],
            [-55.365181, -26.500303],
            [-55.338245, -26.527998],
            [-55.309417, -26.544679],
            [-55.308426, -26.568187],
            [-55.297693, -26.586974],
            [-55.286243, -26.591179],
            [-55.259408, -26.618475],
            [-55.236842, -26.623143]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "EDELIRA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.452063, -26.324578],
            [-55.44622, -26.359345],
            [-55.384761, -26.360854],
            [-55.365747, -26.364445],
            [-55.354347, -26.377482],
            [-55.290407, -26.365764],
            [-55.268316, -26.398269],
            [-55.24369, -26.397318],
            [-55.223841, -26.412644],
            [-55.202274, -26.413263],
            [-55.185375, -26.426075],
            [-55.173342, -26.443722],
            [-55.143683, -26.446021],
            [-55.145276, -26.458805],
            [-55.129775, -26.498093],
            [-55.091113, -26.500442],
            [-55.083688, -26.514293],
            [-55.096506, -26.529247],
            [-55.095481, -26.558298],
            [-55.087585, -26.56912],
            [-55.124722, -26.584291],
            [-55.156887, -26.576596],
            [-55.178766, -26.581716],
            [-55.20355, -26.580442],
            [-55.21556, -26.594575],
            [-55.209707, -26.603667],
            [-55.236842, -26.623143],
            [-55.259408, -26.618475],
            [-55.286243, -26.591179],
            [-55.297693, -26.586974],
            [-55.308426, -26.568187],
            [-55.309417, -26.544679],
            [-55.338245, -26.527998],
            [-55.365181, -26.500303],
            [-55.377156, -26.503207],
            [-55.41121, -26.444534],
            [-55.441731, -26.429231],
            [-55.459668, -26.401016],
            [-55.498236, -26.350111],
            [-55.513137, -26.313866],
            [-55.507194, -26.307913],
            [-55.482375, -26.310219],
            [-55.452063, -26.324578]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "TOMÁS ROMERO PEREIRA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.63269, -26.392207],
            [-55.655955, -26.488023],
            [-55.641724, -26.521934],
            [-55.612713, -26.570432],
            [-55.643261, -26.587713],
            [-55.588468, -26.680385],
            [-55.751131, -26.766954],
            [-55.761764, -26.773016],
            [-55.854169, -26.822983],
            [-55.886579, -26.742424],
            [-55.883422, -26.715737],
            [-55.874699, -26.691897],
            [-55.835991, -26.644508],
            [-55.842765, -26.615217],
            [-55.833573, -26.60867],
            [-55.783429, -26.530218],
            [-55.805336, -26.488273],
            [-55.814848, -26.481762],
            [-55.861723, -26.471309],
            [-55.876135, -26.457655],
            [-55.86037, -26.44007],
            [-55.851127, -26.439226],
            [-55.835524, -26.435486],
            [-55.818978, -26.414306],
            [-55.823708, -26.40854],
            [-55.803671, -26.387667],
            [-55.766044, -26.39383],
            [-55.736492, -26.379547],
            [-55.717589, -26.36205],
            [-55.684837, -26.361076],
            [-55.651582, -26.372855],
            [-55.63269, -26.392207]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "ALTO VERÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.948091, -26.701741],
            [-54.943561, -26.737585],
            [-54.949035, -26.770225],
            [-54.959737, -26.785423],
            [-54.974844, -26.79071],
            [-55.010065, -26.788324],
            [-54.999281, -26.770688],
            [-55.018965, -26.741468],
            [-55.037185, -26.742706],
            [-55.05556, -26.71413],
            [-55.096929, -26.701599],
            [-55.109849, -26.671963],
            [-55.110888, -26.627596],
            [-55.118764, -26.615411],
            [-55.138916, -26.614611],
            [-55.157684, -26.599204],
            [-55.18849, -26.604555],
            [-55.209707, -26.603667],
            [-55.21556, -26.594575],
            [-55.20355, -26.580442],
            [-55.178766, -26.581716],
            [-55.156887, -26.576596],
            [-55.124722, -26.584291],
            [-55.087585, -26.56912],
            [-55.060653, -26.598331],
            [-55.046299, -26.588274],
            [-55.029156, -26.596817],
            [-55.047669, -26.611193],
            [-55.037772, -26.633465],
            [-55.025147, -26.640833],
            [-55.028607, -26.660688],
            [-54.990785, -26.681831],
            [-54.98081, -26.697858],
            [-54.948091, -26.701741]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "YATYTAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.911769, -27.344723],
            [-55.959543, -27.348305],
            [-55.985783, -27.342491],
            [-56.024394, -27.3226],
            [-56.046522, -27.306623],
            [-56.046397, -27.291692],
            [-56.032841, -27.275569],
            [-56.019438, -27.225988],
            [-56.020418, -27.21402],
            [-56.011724, -27.228529],
            [-55.985247, -27.255219],
            [-55.965479, -27.260468],
            [-55.930837, -27.293117],
            [-55.916445, -27.291539],
            [-55.901563, -27.300119],
            [-55.918148, -27.312596],
            [-55.911257, -27.323478],
            [-55.911769, -27.344723]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "SAN JUAN DEL PARANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.480756, -26.7206],
            [-55.389218, -26.802685],
            [-55.406991, -26.818288],
            [-55.390051, -26.83376],
            [-55.37215, -26.817987],
            [-55.34912, -26.838874],
            [-55.367165, -26.854776],
            [-55.271731, -26.940938],
            [-55.304141, -26.962829],
            [-55.375939, -26.965227],
            [-55.41205, -26.9876],
            [-55.426571, -26.968618],
            [-55.447202, -26.962032],
            [-55.46083, -26.950338],
            [-55.476033, -26.950079],
            [-55.48631, -26.973412],
            [-55.509422, -26.983646],
            [-55.751131, -26.766954],
            [-55.588468, -26.680385],
            [-55.548919, -26.659161],
            [-55.480756, -26.7206]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "PIRAPÓ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.397101, -26.670155],
            [-55.421573, -26.685239],
            [-55.436634, -26.684575],
            [-55.456461, -26.694808],
            [-55.480756, -26.7206],
            [-55.548919, -26.659161],
            [-55.588468, -26.680385],
            [-55.643261, -26.587713],
            [-55.612713, -26.570432],
            [-55.641724, -26.521934],
            [-55.655955, -26.488023],
            [-55.63269, -26.392207],
            [-55.612579, -26.409338],
            [-55.595002, -26.416836],
            [-55.567476, -26.390021],
            [-55.562965, -26.367225],
            [-55.545852, -26.366186],
            [-55.532806, -26.355603],
            [-55.539685, -26.384378],
            [-55.535174, -26.395029],
            [-55.534913, -26.431117],
            [-55.523546, -26.507094],
            [-55.524872, -26.525501],
            [-55.510665, -26.57203],
            [-55.470177, -26.594498],
            [-55.440037, -26.598874],
            [-55.391003, -26.624962],
            [-55.389591, -26.645207],
            [-55.397101, -26.670155]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "ITAPÚA POTY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.253171, -26.565534],
            [-57.239972, -26.571796],
            [-57.206402, -26.562178],
            [-57.179549, -26.53277],
            [-57.108887, -26.506477],
            [-57.119917, -26.515804],
            [-57.109289, -26.561008],
            [-57.085657, -26.595741],
            [-57.085499, -26.657825],
            [-57.071144, -26.681521],
            [-57.06265, -26.705284],
            [-57.001132, -26.710043],
            [-57.00103, -26.710043],
            [-57.044319, -26.752842],
            [-57.046088, -26.760738],
            [-57.103327, -26.799062],
            [-57.115037, -26.796376],
            [-57.137384, -26.805899],
            [-57.174929, -26.79487],
            [-57.198147, -26.81036],
            [-57.23405, -26.814955],
            [-57.254502, -26.808112],
            [-57.270803, -26.781871],
            [-57.301011, -26.819067],
            [-57.3698, -26.90901],
            [-57.417305, -27.026781],
            [-57.430828, -27.057374],
            [-57.583257, -26.863025],
            [-57.640095, -26.790442],
            [-57.698569, -26.569792],
            [-57.743139, -26.40059],
            [-57.726689, -26.398418],
            [-57.70356, -26.408527],
            [-57.708285, -26.424237],
            [-57.663253, -26.434848],
            [-57.663342, -26.450357],
            [-57.674871, -26.468331],
            [-57.663286, -26.478529],
            [-57.64847, -26.477898],
            [-57.643633, -26.490328],
            [-57.620066, -26.491327],
            [-57.608775, -26.517449],
            [-57.597049, -26.532505],
            [-57.575897, -26.533626],
            [-57.563883, -26.52272],
            [-57.54889, -26.535046],
            [-57.522753, -26.540063],
            [-57.508414, -26.561937],
            [-57.495321, -26.567041],
            [-57.471167, -26.560132],
            [-57.429089, -26.596997],
            [-57.399603, -26.610901],
            [-57.383313, -26.606075],
            [-57.34456, -26.604942],
            [-57.332568, -26.609884],
            [-57.321049, -26.600007],
            [-57.273051, -26.585403],
            [-57.267099, -26.570156],
            [-57.253171, -26.565534]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SAN JUAN BAUTISTA DE LAS MISIONES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.698123, -27.268968],
            [-56.670036, -27.292481],
            [-56.675038, -27.322605],
            [-56.669655, -27.337722],
            [-56.684276, -27.34657],
            [-56.695045, -27.369136],
            [-56.772511, -27.388335],
            [-56.791617, -27.399867],
            [-56.831488, -27.399382],
            [-56.84859, -27.410185],
            [-56.884837, -27.412556],
            [-56.907013, -27.408389],
            [-56.93884, -27.414947],
            [-56.959538, -27.433414],
            [-57.045857, -27.481722],
            [-57.094835, -27.485129],
            [-57.120738, -27.481407],
            [-57.129941, -27.486017],
            [-57.19082, -27.468809],
            [-57.23335, -27.466991],
            [-57.279121, -27.436469],
            [-57.318363, -27.416538],
            [-57.341979, -27.416305],
            [-57.325792, -27.386776],
            [-57.322882, -27.391666],
            [-57.269739, -27.388674],
            [-57.248755, -27.394798],
            [-57.220907, -27.391879],
            [-57.209148, -27.380097],
            [-57.183373, -27.377949],
            [-57.171999, -27.386075],
            [-57.155657, -27.382975],
            [-57.141065, -27.357721],
            [-57.13079, -27.360069],
            [-57.09817, -27.347723],
            [-57.084909, -27.328185],
            [-57.082797, -27.305986],
            [-57.04767, -27.302103],
            [-57.02548, -27.2929],
            [-57.010638, -27.279021],
            [-56.961817, -27.281404],
            [-56.94506, -27.278699],
            [-56.770737, -27.267489],
            [-56.698123, -27.268968]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "AYOLAS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.915739, -26.842047],
            [-56.907285, -26.859815],
            [-56.91612, -26.868335],
            [-56.929241, -26.907856],
            [-56.937301, -26.919078],
            [-56.916252, -26.93405],
            [-56.925052, -26.954311],
            [-56.951003, -26.98019],
            [-56.988277, -27.002096],
            [-56.976966, -27.025894],
            [-56.977706, -27.048127],
            [-56.956887, -27.072653],
            [-56.950347, -27.112453],
            [-56.951933, -27.128095],
            [-56.966137, -27.174257],
            [-57.038354, -27.159996],
            [-57.080401, -27.135588],
            [-57.123977, -27.114086],
            [-57.132438, -27.124497],
            [-57.184311, -27.113239],
            [-57.182094, -27.108967],
            [-57.428681, -27.060106],
            [-57.430828, -27.057374],
            [-57.417305, -27.026781],
            [-57.3698, -26.90901],
            [-57.301011, -26.819067],
            [-57.270803, -26.781871],
            [-57.254502, -26.808112],
            [-57.23405, -26.814955],
            [-57.198147, -26.81036],
            [-57.174929, -26.79487],
            [-57.137384, -26.805899],
            [-57.115037, -26.796376],
            [-57.103327, -26.799062],
            [-57.046088, -26.760738],
            [-57.044319, -26.752842],
            [-57.00103, -26.710043],
            [-56.981112, -26.739169],
            [-56.997471, -26.782008],
            [-56.999456, -26.796565],
            [-56.988802, -26.818894],
            [-56.96545, -26.834672],
            [-56.923437, -26.848557],
            [-56.915739, -26.842047]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SAN IGNACIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.848325, -26.541554],
            [-56.820651, -26.543998],
            [-56.813814, -26.566978],
            [-56.821245, -26.587204],
            [-56.814409, -26.60365],
            [-56.814684, -26.624521],
            [-56.802169, -26.639317],
            [-56.806634, -26.648311],
            [-56.828606, -26.659106],
            [-56.8745, -26.669551],
            [-56.903176, -26.662829],
            [-56.935948, -26.663814],
            [-56.987229, -26.679265],
            [-56.98581, -26.688332],
            [-57.001132, -26.710043],
            [-57.06265, -26.705284],
            [-57.071144, -26.681521],
            [-57.085499, -26.657825],
            [-57.085657, -26.595741],
            [-57.109289, -26.561008],
            [-57.119917, -26.515804],
            [-57.108887, -26.506477],
            [-57.05272, -26.502247],
            [-57.036568, -26.50538],
            [-57.031723, -26.488099],
            [-57.007866, -26.473412],
            [-57.008027, -26.458965],
            [-56.996131, -26.419516],
            [-56.971571, -26.448548],
            [-56.955298, -26.449317],
            [-56.961298, -26.472731],
            [-56.949111, -26.485057],
            [-56.925715, -26.464992],
            [-56.912381, -26.460795],
            [-56.896304, -26.49316],
            [-56.880812, -26.504596],
            [-56.879578, -26.523098],
            [-56.848325, -26.541554]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SAN MIGUEL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.77354, -26.959648],
            [-56.785177, -26.973204],
            [-56.797739, -27.00332],
            [-56.794876, -27.027832],
            [-56.813207, -27.017073],
            [-56.827188, -27.016965],
            [-56.843212, -27.036697],
            [-56.8658, -27.049505],
            [-56.89204, -27.051509],
            [-56.89357, -27.040252],
            [-56.857346, -27.003365],
            [-56.849598, -26.985959],
            [-56.834381, -26.969537],
            [-56.842966, -26.954796],
            [-56.833634, -26.942062],
            [-56.799328, -26.946428],
            [-56.77354, -26.959648]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SAN PATRICIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.766468, -26.635655],
            [-56.785131, -26.715388],
            [-56.807278, -26.748294],
            [-56.826358, -26.790989],
            [-56.837751, -26.826278],
            [-56.856707, -26.834379],
            [-56.889099, -26.841275],
            [-56.915739, -26.842047],
            [-56.923437, -26.848557],
            [-56.96545, -26.834672],
            [-56.988802, -26.818894],
            [-56.999456, -26.796565],
            [-56.997471, -26.782008],
            [-56.981112, -26.739169],
            [-57.00103, -26.710043],
            [-57.001132, -26.710043],
            [-56.98581, -26.688332],
            [-56.987229, -26.679265],
            [-56.935948, -26.663814],
            [-56.903176, -26.662829],
            [-56.8745, -26.669551],
            [-56.828606, -26.659106],
            [-56.806634, -26.648311],
            [-56.802169, -26.639317],
            [-56.814684, -26.624521],
            [-56.814409, -26.60365],
            [-56.79784, -26.62048],
            [-56.777467, -26.619114],
            [-56.766468, -26.635655]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SANTA MARÍA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.635073, -26.681476],
            [-56.652459, -26.687253],
            [-56.649056, -26.706291],
            [-56.658796, -26.726241],
            [-56.647044, -26.924488],
            [-56.678038, -26.944037],
            [-56.708264, -26.958891],
            [-56.747757, -26.967116],
            [-56.77354, -26.959648],
            [-56.799328, -26.946428],
            [-56.833634, -26.942062],
            [-56.842966, -26.954796],
            [-56.834381, -26.969537],
            [-56.849598, -26.985959],
            [-56.857346, -27.003365],
            [-56.89357, -27.040252],
            [-56.89204, -27.051509],
            [-56.90564, -27.089285],
            [-56.90176, -27.108333],
            [-56.914846, -27.128597],
            [-56.92135, -27.161152],
            [-56.914376, -27.172497],
            [-56.966137, -27.174257],
            [-56.951933, -27.128095],
            [-56.950347, -27.112453],
            [-56.956887, -27.072653],
            [-56.977706, -27.048127],
            [-56.976966, -27.025894],
            [-56.988277, -27.002096],
            [-56.951003, -26.98019],
            [-56.925052, -26.954311],
            [-56.916252, -26.93405],
            [-56.937301, -26.919078],
            [-56.929241, -26.907856],
            [-56.91612, -26.868335],
            [-56.907285, -26.859815],
            [-56.915739, -26.842047],
            [-56.889099, -26.841275],
            [-56.856707, -26.834379],
            [-56.837751, -26.826278],
            [-56.826358, -26.790989],
            [-56.807278, -26.748294],
            [-56.785131, -26.715388],
            [-56.766468, -26.635655],
            [-56.753325, -26.635502],
            [-56.74061, -26.622067],
            [-56.716518, -26.648052],
            [-56.703661, -26.653583],
            [-56.666235, -26.657003],
            [-56.63568, -26.668611],
            [-56.635073, -26.681476]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SANTA ROSA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.64703, -26.926496],
            [-56.64405, -26.978312],
            [-56.629229, -26.997258],
            [-56.625861, -27.016422],
            [-56.640758, -27.035484],
            [-56.634802, -27.138759],
            [-56.63892, -27.159107],
            [-56.654828, -27.172053],
            [-56.669645, -27.196623],
            [-56.688419, -27.201018],
            [-56.709545, -27.23603],
            [-56.696968, -27.243528],
            [-56.698123, -27.268968],
            [-56.770737, -27.267489],
            [-56.94506, -27.278699],
            [-56.961817, -27.281404],
            [-56.976095, -27.249009],
            [-56.984003, -27.246798],
            [-56.974368, -27.221211],
            [-56.974247, -27.184515],
            [-56.966137, -27.174257],
            [-56.914376, -27.172497],
            [-56.92135, -27.161152],
            [-56.914846, -27.128597],
            [-56.90176, -27.108333],
            [-56.90564, -27.089285],
            [-56.89204, -27.051509],
            [-56.8658, -27.049505],
            [-56.843212, -27.036697],
            [-56.827188, -27.016965],
            [-56.813207, -27.017073],
            [-56.794876, -27.027832],
            [-56.797739, -27.00332],
            [-56.785177, -26.973204],
            [-56.77354, -26.959648],
            [-56.747757, -26.967116],
            [-56.708264, -26.958891],
            [-56.678038, -26.944037],
            [-56.647044, -26.924488],
            [-56.64703, -26.926496]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "SANTIAGO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.007329, -26.412427],
            [-56.996131, -26.419516],
            [-57.008027, -26.458965],
            [-57.007866, -26.473412],
            [-57.031723, -26.488099],
            [-57.036568, -26.50538],
            [-57.05272, -26.502247],
            [-57.108887, -26.506477],
            [-57.179549, -26.53277],
            [-57.206402, -26.562178],
            [-57.239972, -26.571796],
            [-57.253171, -26.565534],
            [-57.254154, -26.545458],
            [-57.239178, -26.519711],
            [-57.251243, -26.498464],
            [-57.205569, -26.467771],
            [-57.185131, -26.463185],
            [-57.187956, -26.450884],
            [-57.170586, -26.412256],
            [-57.125973, -26.402645],
            [-57.121616, -26.381965],
            [-57.105213, -26.38535],
            [-57.087854, -26.376148],
            [-57.071329, -26.379031],
            [-57.0582, -26.402009],
            [-57.043084, -26.411985],
            [-57.014772, -26.41757],
            [-57.007329, -26.412427]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "VILLA FLORIDA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.966137, -27.174257],
            [-56.974247, -27.184515],
            [-56.974368, -27.221211],
            [-56.984003, -27.246798],
            [-56.976095, -27.249009],
            [-56.961817, -27.281404],
            [-57.010638, -27.279021],
            [-57.02548, -27.2929],
            [-57.04767, -27.302103],
            [-57.082797, -27.305986],
            [-57.084909, -27.328185],
            [-57.09817, -27.347723],
            [-57.13079, -27.360069],
            [-57.141065, -27.357721],
            [-57.155657, -27.382975],
            [-57.171999, -27.386075],
            [-57.183373, -27.377949],
            [-57.209148, -27.380097],
            [-57.220907, -27.391879],
            [-57.248755, -27.394798],
            [-57.269739, -27.388674],
            [-57.322882, -27.391666],
            [-57.325792, -27.386776],
            [-57.249706, -27.239019],
            [-57.218765, -27.179547],
            [-57.184311, -27.113239],
            [-57.132438, -27.124497],
            [-57.123977, -27.114086],
            [-57.080401, -27.135588],
            [-57.038354, -27.159996],
            [-56.966137, -27.174257]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "MISIONES",
        "dist_desc_": "YABEBYRY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.129893, -25.527532],
            [-57.110919, -25.546847],
            [-57.081853, -25.583342],
            [-57.09494, -25.634496],
            [-57.075901, -25.651628],
            [-57.074173, -25.666105],
            [-57.089019, -25.688081],
            [-57.10519, -25.702469],
            [-57.084505, -25.710803],
            [-57.066, -25.725144],
            [-57.044672, -25.753064],
            [-57.021806, -25.758041],
            [-57.01619, -25.776377],
            [-57.0216, -25.786084],
            [-57.040514, -25.788568],
            [-57.059484, -25.810382],
            [-57.076929, -25.818406],
            [-57.093813, -25.804901],
            [-57.120826, -25.799689],
            [-57.138691, -25.791172],
            [-57.162024, -25.772838],
            [-57.193824, -25.776181],
            [-57.215849, -25.762248],
            [-57.218764, -25.745669],
            [-57.233407, -25.737592],
            [-57.233034, -25.72076],
            [-57.240332, -25.695441],
            [-57.260596, -25.693704],
            [-57.270265, -25.677206],
            [-57.231571, -25.65686],
            [-57.19611, -25.660366],
            [-57.184478, -25.635322],
            [-57.18091, -25.605066],
            [-57.183951, -25.591445],
            [-57.207339, -25.572725],
            [-57.218054, -25.551105],
            [-57.195895, -25.544042],
            [-57.187494, -25.531031],
            [-57.129893, -25.527532]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "PARAGUARÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.076929, -25.818406],
            [-57.069424, -25.834791],
            [-57.051392, -25.837033],
            [-57.034709, -25.849697],
            [-57.016504, -25.85241],
            [-56.997716, -25.846587],
            [-56.981811, -25.852239],
            [-56.96425, -25.842729],
            [-56.946981, -25.857241],
            [-56.954027, -25.868762],
            [-56.915865, -25.880949],
            [-56.916657, -25.906893],
            [-56.928457, -25.917207],
            [-56.994893, -25.922954],
            [-57.016665, -25.932999],
            [-57.025321, -25.946578],
            [-57.060978, -25.954392],
            [-57.091207, -25.956106],
            [-57.107902, -25.971864],
            [-57.124195, -25.977807],
            [-57.140931, -25.96087],
            [-57.179782, -25.956421],
            [-57.183876, -25.948022],
            [-57.163354, -25.903501],
            [-57.189861, -25.898598],
            [-57.202088, -25.889312],
            [-57.204233, -25.870039],
            [-57.196668, -25.854078],
            [-57.174525, -25.848004],
            [-57.149504, -25.831606],
            [-57.138691, -25.791172],
            [-57.120826, -25.799689],
            [-57.093813, -25.804901],
            [-57.076929, -25.818406]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "ACAHAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.141422, -26.091318],
            [-57.13015, -26.114418],
            [-57.1072, -26.122442],
            [-57.119791, -26.126999],
            [-57.135449, -26.145191],
            [-57.146668, -26.168205],
            [-57.144634, -26.182424],
            [-57.114218, -26.20182],
            [-57.121889, -26.219349],
            [-57.11114, -26.243481],
            [-57.09777, -26.245499],
            [-57.09927, -26.261562],
            [-57.125248, -26.301777],
            [-57.113696, -26.308893],
            [-57.09993, -26.341725],
            [-57.078647, -26.370958],
            [-57.087854, -26.376148],
            [-57.105213, -26.38535],
            [-57.121616, -26.381965],
            [-57.125973, -26.402645],
            [-57.170586, -26.412256],
            [-57.187956, -26.450884],
            [-57.185131, -26.463185],
            [-57.205569, -26.467771],
            [-57.251243, -26.498464],
            [-57.239178, -26.519711],
            [-57.254154, -26.545458],
            [-57.253171, -26.565534],
            [-57.267099, -26.570156],
            [-57.273051, -26.585403],
            [-57.321049, -26.600007],
            [-57.332568, -26.609884],
            [-57.34456, -26.604942],
            [-57.383313, -26.606075],
            [-57.399603, -26.610901],
            [-57.429089, -26.596997],
            [-57.471167, -26.560132],
            [-57.495321, -26.567041],
            [-57.508414, -26.561937],
            [-57.522753, -26.540063],
            [-57.54889, -26.535046],
            [-57.563883, -26.52272],
            [-57.575897, -26.533626],
            [-57.597049, -26.532505],
            [-57.608775, -26.517449],
            [-57.620066, -26.491327],
            [-57.643633, -26.490328],
            [-57.64847, -26.477898],
            [-57.663286, -26.478529],
            [-57.674871, -26.468331],
            [-57.663342, -26.450357],
            [-57.663253, -26.434848],
            [-57.708285, -26.424237],
            [-57.70356, -26.408527],
            [-57.726689, -26.398418],
            [-57.743139, -26.40059],
            [-57.748991, -26.381935],
            [-57.735852, -26.375533],
            [-57.73429, -26.357441],
            [-57.718938, -26.356921],
            [-57.715073, -26.375906],
            [-57.69897, -26.372309],
            [-57.680778, -26.352158],
            [-57.691623, -26.343221],
            [-57.679545, -26.314145],
            [-57.656972, -26.292759],
            [-57.641842, -26.264731],
            [-57.62032, -26.251566],
            [-57.619689, -26.238104],
            [-57.610527, -26.219735],
            [-57.596607, -26.215748],
            [-57.579656, -26.185393],
            [-57.55174, -26.177528],
            [-57.531195, -26.179282],
            [-57.520244, -26.168071],
            [-57.482368, -26.156885],
            [-57.472422, -26.138434],
            [-57.480641, -26.113197],
            [-57.468136, -26.11337],
            [-57.376347, -26.128672],
            [-57.34658, -26.077368],
            [-57.318823, -26.074087],
            [-57.303202, -26.086798],
            [-57.198335, -26.087919],
            [-57.178413, -26.077471],
            [-57.141422, -26.091318]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "CAAPUCÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.758342, -25.64924],
            [-56.806296, -25.676791],
            [-56.825166, -25.695796],
            [-56.837513, -25.718296],
            [-56.846262, -25.751134],
            [-56.843558, -25.777802],
            [-56.856758, -25.803985],
            [-56.872746, -25.805495],
            [-56.867457, -25.843885],
            [-56.874464, -25.851725],
            [-56.886939, -25.888759],
            [-56.915865, -25.880949],
            [-56.954027, -25.868762],
            [-56.946981, -25.857241],
            [-56.96425, -25.842729],
            [-56.981811, -25.852239],
            [-56.997716, -25.846587],
            [-56.966778, -25.824022],
            [-56.96717, -25.801207],
            [-56.948216, -25.781972],
            [-56.960198, -25.758619],
            [-56.93234, -25.743502],
            [-56.911644, -25.702837],
            [-56.894242, -25.68658],
            [-56.892445, -25.668163],
            [-56.862565, -25.662256],
            [-56.857589, -25.646702],
            [-56.83725, -25.6493],
            [-56.823447, -25.64317],
            [-56.810808, -25.625527],
            [-56.780875, -25.631974],
            [-56.758342, -25.64924]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "GENERAL BERNARDINO CABALLERO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.397124, -25.6283],
            [-57.388147, -25.639093],
            [-57.363956, -25.660089],
            [-57.342892, -25.668696],
            [-57.279977, -25.66735],
            [-57.270265, -25.677206],
            [-57.260596, -25.693704],
            [-57.240332, -25.695441],
            [-57.233034, -25.72076],
            [-57.233407, -25.737592],
            [-57.218764, -25.745669],
            [-57.215849, -25.762248],
            [-57.193824, -25.776181],
            [-57.162024, -25.772838],
            [-57.138691, -25.791172],
            [-57.149504, -25.831606],
            [-57.174525, -25.848004],
            [-57.196668, -25.854078],
            [-57.205605, -25.851183],
            [-57.210641, -25.83128],
            [-57.229301, -25.811994],
            [-57.268552, -25.807045],
            [-57.292557, -25.8155],
            [-57.325859, -25.812187],
            [-57.335029, -25.825481],
            [-57.356545, -25.828293],
            [-57.374926, -25.847324],
            [-57.400869, -25.857792],
            [-57.415749, -25.879598],
            [-57.423004, -25.854065],
            [-57.442906, -25.844625],
            [-57.456491, -25.817523],
            [-57.453799, -25.808391],
            [-57.468209, -25.756149],
            [-57.449227, -25.723163],
            [-57.432726, -25.70154],
            [-57.41937, -25.693386],
            [-57.416483, -25.674113],
            [-57.421513, -25.647052],
            [-57.406309, -25.62839],
            [-57.397124, -25.6283]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "CARAPEGUÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.914166, -25.590966],
            [-56.945204, -25.593401],
            [-56.968339, -25.572428],
            [-56.990237, -25.574532],
            [-56.988011, -25.596563],
            [-56.997303, -25.606736],
            [-57.007451, -25.669248],
            [-56.981869, -25.69432],
            [-56.966026, -25.730456],
            [-56.980505, -25.745159],
            [-56.976067, -25.776586],
            [-57.003931, -25.785196],
            [-57.01619, -25.776377],
            [-57.021806, -25.758041],
            [-57.044672, -25.753064],
            [-57.066, -25.725144],
            [-57.084505, -25.710803],
            [-57.10519, -25.702469],
            [-57.089019, -25.688081],
            [-57.074173, -25.666105],
            [-57.075901, -25.651628],
            [-57.09494, -25.634496],
            [-57.081853, -25.583342],
            [-57.063751, -25.578507],
            [-57.034121, -25.59176],
            [-57.020082, -25.590981],
            [-56.99186, -25.571449],
            [-56.970803, -25.570088],
            [-56.94635, -25.561904],
            [-56.934632, -25.569024],
            [-56.917328, -25.564044],
            [-56.914166, -25.590966]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "ESCOBAR"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.733152, -25.914199],
            [-56.73626, -25.936525],
            [-56.747988, -25.941148],
            [-56.769908, -25.922992],
            [-56.785187, -25.919941],
            [-56.802381, -25.948107],
            [-56.836422, -25.944931],
            [-56.852308, -25.929416],
            [-56.896488, -25.914835],
            [-56.901329, -25.904169],
            [-56.893082, -25.889973],
            [-56.864713, -25.858593],
            [-56.84508, -25.864673],
            [-56.814975, -25.856199],
            [-56.807362, -25.863779],
            [-56.778077, -25.859827],
            [-56.776441, -25.869925],
            [-56.78765, -25.898812],
            [-56.733152, -25.914199]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "LA COLMENA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.629165, -26.194631],
            [-56.638871, -26.221206],
            [-56.673942, -26.227274],
            [-56.684218, -26.253538],
            [-56.694399, -26.260439],
            [-56.693793, -26.287431],
            [-56.699077, -26.300785],
            [-56.725113, -26.312683],
            [-56.72243, -26.326858],
            [-56.736365, -26.334299],
            [-56.738884, -26.365066],
            [-56.755367, -26.366029],
            [-56.763958, -26.391534],
            [-56.759429, -26.415425],
            [-56.850044, -26.385063],
            [-56.828217, -26.359747],
            [-56.845559, -26.350692],
            [-56.832621, -26.333287],
            [-56.889395, -26.297552],
            [-56.883574, -26.283242],
            [-56.857444, -26.262329],
            [-56.861324, -26.252197],
            [-56.8813, -26.241163],
            [-56.889477, -26.219833],
            [-56.865578, -26.194444],
            [-56.848649, -26.164945],
            [-56.850764, -26.149299],
            [-56.839019, -26.140099],
            [-56.830912, -26.121822],
            [-56.793483, -26.117859],
            [-56.791741, -26.096461],
            [-56.805014, -26.082348],
            [-56.80236, -26.064624],
            [-56.753314, -26.037152],
            [-56.748161, -26.028082],
            [-56.73702, -25.972646],
            [-56.726172, -25.979917],
            [-56.720967, -25.998364],
            [-56.705464, -26.0275],
            [-56.701791, -26.04464],
            [-56.721934, -26.091607],
            [-56.70579, -26.108989],
            [-56.711758, -26.130117],
            [-56.703753, -26.147234],
            [-56.673423, -26.166968],
            [-56.632747, -26.187327],
            [-56.629165, -26.194631]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "MBUYAPEY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.131784, -25.455691],
            [-57.137315, -25.480454],
            [-57.126355, -25.522925],
            [-57.129893, -25.527532],
            [-57.187494, -25.531031],
            [-57.195895, -25.544042],
            [-57.218054, -25.551105],
            [-57.230752, -25.52678],
            [-57.253918, -25.50929],
            [-57.317095, -25.497762],
            [-57.312246, -25.461011],
            [-57.299755, -25.448728],
            [-57.247476, -25.433456],
            [-57.22301, -25.418625],
            [-57.21791, -25.40268],
            [-57.195022, -25.401783],
            [-57.170696, -25.429062],
            [-57.131784, -25.455691]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "PIRAYÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.183876, -25.948022],
            [-57.179782, -25.956421],
            [-57.140931, -25.96087],
            [-57.124195, -25.977807],
            [-57.107902, -25.971864],
            [-57.105521, -25.984526],
            [-57.115086, -26.020566],
            [-57.131693, -26.03062],
            [-57.137597, -26.056634],
            [-57.134345, -26.079505],
            [-57.141422, -26.091318],
            [-57.178413, -26.077471],
            [-57.198335, -26.087919],
            [-57.303202, -26.086798],
            [-57.318823, -26.074087],
            [-57.34658, -26.077368],
            [-57.376347, -26.128672],
            [-57.468136, -26.11337],
            [-57.488729, -26.059954],
            [-57.484906, -26.044499],
            [-57.499619, -26.025117],
            [-57.47605, -25.972293],
            [-57.446799, -25.932162],
            [-57.411902, -25.934175],
            [-57.350218, -25.910268],
            [-57.322523, -25.918861],
            [-57.297104, -25.918514],
            [-57.285074, -25.909377],
            [-57.256051, -25.911124],
            [-57.229873, -25.918098],
            [-57.201297, -25.943027],
            [-57.183876, -25.948022]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "QUIINDY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.743139, -26.40059],
            [-57.698569, -26.569792],
            [-57.640095, -26.790442],
            [-57.583257, -26.863025],
            [-57.642945, -26.852718],
            [-57.772965, -26.777087],
            [-57.791167, -26.755376],
            [-57.80168, -26.756302],
            [-57.874527, -26.746049],
            [-57.895729, -26.734369],
            [-57.924041, -26.694559],
            [-57.944944, -26.679666],
            [-57.967153, -26.683705],
            [-58.001771, -26.678356],
            [-58.027746, -26.686566],
            [-58.036947, -26.678006],
            [-58.054084, -26.681939],
            [-58.065802, -26.670263],
            [-58.086105, -26.665007],
            [-58.105284, -26.647976],
            [-58.12674, -26.639743],
            [-58.152875, -26.638664],
            [-58.171297, -26.603134],
            [-58.141404, -26.569416],
            [-58.139947, -26.546902],
            [-58.101115, -26.538301],
            [-58.086842, -26.544084],
            [-58.078104, -26.534313],
            [-58.042393, -26.519962],
            [-58.027158, -26.522774],
            [-58.00756, -26.504935],
            [-57.980008, -26.492309],
            [-57.983291, -26.481604],
            [-57.970199, -26.465352],
            [-57.941485, -26.455003],
            [-57.918352, -26.460019],
            [-57.90076, -26.431209],
            [-57.882948, -26.444474],
            [-57.851427, -26.438629],
            [-57.837587, -26.427808],
            [-57.823676, -26.434737],
            [-57.805826, -26.429613],
            [-57.795474, -26.403372],
            [-57.782039, -26.388298],
            [-57.748991, -26.381935],
            [-57.743139, -26.40059]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "SAN JUAN BAUTISTA DE ÑEEMBUCÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.583257, -26.863025],
            [-57.430828, -27.057374],
            [-57.428681, -27.060106],
            [-57.182094, -27.108967],
            [-57.184311, -27.113239],
            [-57.218765, -27.179547],
            [-57.327969, -27.148349],
            [-57.501853, -27.163521],
            [-57.610891, -27.099167],
            [-57.65347, -27.065323],
            [-57.727807, -27.023058],
            [-57.788765, -27.002259],
            [-57.788084, -26.953086],
            [-57.798971, -26.933696],
            [-57.810651, -26.925748],
            [-57.853944, -26.939897],
            [-57.879003, -26.943882],
            [-57.899584, -26.922532],
            [-57.932042, -26.878314],
            [-57.944176, -26.857302],
            [-57.971279, -26.8441],
            [-57.986543, -26.841643],
            [-58.009935, -26.823327],
            [-58.037758, -26.827581],
            [-58.1133, -26.758395],
            [-58.197844, -26.757494],
            [-58.205547, -26.751615],
            [-58.246119, -26.742258],
            [-58.25522, -26.721844],
            [-58.257059, -26.668477],
            [-58.260589, -26.648852],
            [-58.246196, -26.64179],
            [-58.218686, -26.65414],
            [-58.199153, -26.652758],
            [-58.191373, -26.638361],
            [-58.209049, -26.615337],
            [-58.196172, -26.604783],
            [-58.179792, -26.59648],
            [-58.171297, -26.603134],
            [-58.152875, -26.638664],
            [-58.12674, -26.639743],
            [-58.105284, -26.647976],
            [-58.086105, -26.665007],
            [-58.065802, -26.670263],
            [-58.054084, -26.681939],
            [-58.036947, -26.678006],
            [-58.027746, -26.686566],
            [-58.001771, -26.678356],
            [-57.967153, -26.683705],
            [-57.944944, -26.679666],
            [-57.924041, -26.694559],
            [-57.895729, -26.734369],
            [-57.874527, -26.746049],
            [-57.80168, -26.756302],
            [-57.791167, -26.755376],
            [-57.772965, -26.777087],
            [-57.642945, -26.852718],
            [-57.583257, -26.863025]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "TACUARAS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.619689, -26.238104],
            [-57.62032, -26.251566],
            [-57.641842, -26.264731],
            [-57.656972, -26.292759],
            [-57.679545, -26.314145],
            [-57.691623, -26.343221],
            [-57.680778, -26.352158],
            [-57.69897, -26.372309],
            [-57.715073, -26.375906],
            [-57.718938, -26.356921],
            [-57.73429, -26.357441],
            [-57.735852, -26.375533],
            [-57.748991, -26.381935],
            [-57.782039, -26.388298],
            [-57.795474, -26.403372],
            [-57.805826, -26.429613],
            [-57.823676, -26.434737],
            [-57.837587, -26.427808],
            [-57.851427, -26.438629],
            [-57.882948, -26.444474],
            [-57.90076, -26.431209],
            [-57.918352, -26.460019],
            [-57.941485, -26.455003],
            [-57.970199, -26.465352],
            [-57.983291, -26.481604],
            [-57.980008, -26.492309],
            [-58.00756, -26.504935],
            [-58.027158, -26.522774],
            [-58.042393, -26.519962],
            [-58.078104, -26.534313],
            [-58.086842, -26.544084],
            [-58.101115, -26.538301],
            [-58.139947, -26.546902],
            [-58.141404, -26.569416],
            [-58.171297, -26.603134],
            [-58.179792, -26.59648],
            [-58.196172, -26.604783],
            [-58.192605, -26.593666],
            [-58.202462, -26.557246],
            [-58.223275, -26.539977],
            [-58.224353, -26.527885],
            [-58.207388, -26.50048],
            [-58.230673, -26.474239],
            [-58.222678, -26.463623],
            [-58.18808, -26.463087],
            [-58.183645, -26.44788],
            [-58.20169, -26.435591],
            [-58.221707, -26.40351],
            [-58.216943, -26.385204],
            [-58.206797, -26.375458],
            [-58.166247, -26.355512],
            [-58.159432, -26.345091],
            [-58.154122, -26.317443],
            [-58.165778, -26.29396],
            [-58.167062, -26.276697],
            [-58.158582, -26.26043],
            [-58.134744, -26.252225],
            [-58.106877, -26.236195],
            [-58.105381, -26.222758],
            [-58.088464, -26.223222],
            [-58.072516, -26.238411],
            [-58.025469, -26.25041],
            [-58.018789, -26.219326],
            [-58.027544, -26.202069],
            [-58.000321, -26.176082],
            [-57.974689, -26.188289],
            [-57.958352, -26.164111],
            [-57.940837, -26.176876],
            [-57.917792, -26.164244],
            [-57.898341, -26.144625],
            [-57.814365, -26.18036],
            [-57.813382, -26.190176],
            [-57.718487, -26.238242],
            [-57.69399, -26.194639],
            [-57.65532, -26.213244],
            [-57.644011, -26.232062],
            [-57.619689, -26.238104]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "VILLA FRANCA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.31363, -26.729115],
            [-56.312131, -26.737669],
            [-56.255431, -26.801237],
            [-56.240098, -26.819857],
            [-56.231859, -26.879568],
            [-56.19664, -26.879261],
            [-56.158691, -26.884933],
            [-56.128586, -26.929809],
            [-56.131313, -26.937844],
            [-56.158599, -26.928759],
            [-56.15574, -26.945589],
            [-56.135904, -26.955828],
            [-56.134475, -26.97214],
            [-56.117997, -26.983299],
            [-56.110719, -26.97302],
            [-56.091408, -26.970291],
            [-56.077882, -26.988765],
            [-56.117491, -27.01366],
            [-56.116024, -27.05183],
            [-56.12883, -27.069365],
            [-56.134739, -27.112273],
            [-56.14056, -27.098492],
            [-56.169645, -27.080246],
            [-56.173379, -27.063585],
            [-56.186902, -27.039449],
            [-56.245082, -27.061785],
            [-56.285614, -27.080676],
            [-56.301545, -27.063463],
            [-56.313287, -27.064072],
            [-56.392806, -27.054981],
            [-56.429874, -27.055739],
            [-56.437354, -27.050781],
            [-56.443315, -27.016309],
            [-56.464733, -27.00678],
            [-56.539702, -26.966099],
            [-56.541127, -26.938283],
            [-56.561993, -26.912292],
            [-56.600574, -26.888159],
            [-56.614185, -26.894671],
            [-56.64703, -26.926496],
            [-56.647044, -26.924488],
            [-56.658796, -26.726241],
            [-56.623234, -26.747297],
            [-56.60341, -26.74309],
            [-56.573014, -26.758359],
            [-56.538692, -26.758107],
            [-56.52848, -26.778316],
            [-56.508777, -26.780195],
            [-56.501938, -26.791827],
            [-56.477889, -26.786486],
            [-56.461416, -26.773048],
            [-56.431168, -26.774826],
            [-56.383767, -26.741123],
            [-56.370124, -26.738914],
            [-56.353063, -26.7244],
            [-56.31363, -26.729115]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "GENERAL ARTIGAS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.062836, -25.904853],
            [-55.048594, -25.922174],
            [-55.010951, -25.949049],
            [-55.027282, -25.966455],
            [-55.008442, -25.977926],
            [-54.994399, -26.006796],
            [-55.00713, -26.009689],
            [-55.022056, -26.027768],
            [-55.034078, -26.026508],
            [-55.050271, -26.046932],
            [-55.077821, -26.047342],
            [-55.090452, -26.030513],
            [-55.11978, -26.050656],
            [-55.129551, -26.04723],
            [-55.142754, -26.037449],
            [-55.145105, -26.020184],
            [-55.181676, -26.041989],
            [-55.179125, -26.060918],
            [-55.203941, -26.07239],
            [-55.212472, -26.08735],
            [-55.229899, -26.065733],
            [-55.249222, -26.058675],
            [-55.253528, -26.043205],
            [-55.28759, -26.049178],
            [-55.327943, -26.022099],
            [-55.357259, -25.993078],
            [-55.365049, -25.975237],
            [-55.389527, -25.966299],
            [-55.392241, -25.952747],
            [-55.409833, -25.942898],
            [-55.405402, -25.921815],
            [-55.39014, -25.903979],
            [-55.341922, -25.919644],
            [-55.301286, -25.911839],
            [-55.288594, -25.912741],
            [-55.273879, -25.897707],
            [-55.290541, -25.874623],
            [-55.321632, -25.866842],
            [-55.320012, -25.84644],
            [-55.295849, -25.818719],
            [-55.286637, -25.780893],
            [-55.273856, -25.798084],
            [-55.277752, -25.815039],
            [-55.258488, -25.833365],
            [-55.246979, -25.829327],
            [-55.220821, -25.840302],
            [-55.193474, -25.868536],
            [-55.168016, -25.871782],
            [-55.158098, -25.892925],
            [-55.097724, -25.907789],
            [-55.072688, -25.916489],
            [-55.062836, -25.904853]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "NARANJAL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.859066, -25.644128],
            [-54.866084, -25.690846],
            [-54.857139, -25.694569],
            [-54.85271, -25.739874],
            [-54.835591, -25.756824],
            [-54.822244, -25.756955],
            [-54.799343, -25.768136],
            [-54.813148, -25.838412],
            [-54.837824, -25.871702],
            [-54.840586, -25.978066],
            [-54.859746, -26.009305],
            [-54.873086, -26.003389],
            [-54.876814, -25.989956],
            [-54.896697, -25.982322],
            [-54.936559, -25.980394],
            [-54.96944, -26.002402],
            [-54.975978, -26.013184],
            [-54.994399, -26.006796],
            [-55.008442, -25.977926],
            [-55.027282, -25.966455],
            [-55.010951, -25.949049],
            [-55.048594, -25.922174],
            [-55.062836, -25.904853],
            [-55.028702, -25.863128],
            [-55.025654, -25.8348],
            [-55.010784, -25.818891],
            [-55.005226, -25.775555],
            [-55.011934, -25.762669],
            [-54.996087, -25.729759],
            [-54.998024, -25.716584],
            [-54.988519, -25.709011],
            [-54.917059, -25.720778],
            [-54.908234, -25.659462],
            [-54.88451, -25.652287],
            [-54.879692, -25.639091],
            [-54.859066, -25.644128]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "SANTA ROSA DEL MONDAY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.657861, -24.699844],
            [-54.681481, -24.693381],
            [-54.698044, -24.702713],
            [-54.700846, -24.713718],
            [-54.723884, -24.733768],
            [-54.735839, -24.770036],
            [-54.72288, -24.782277],
            [-54.688573, -24.780069],
            [-54.66826, -24.789638],
            [-54.682098, -24.856067],
            [-54.703907, -24.871262],
            [-54.719233, -24.870901],
            [-54.738072, -24.854926],
            [-54.790773, -24.852632],
            [-54.794998, -24.861207],
            [-54.837844, -24.885706],
            [-54.840519, -24.896248],
            [-54.864504, -24.909411],
            [-54.866354, -24.921096],
            [-54.899018, -24.943808],
            [-54.966925, -24.881658],
            [-54.979449, -24.882519],
            [-54.986496, -24.867736],
            [-55.004772, -24.863264],
            [-55.029041, -24.848298],
            [-54.990265, -24.647848],
            [-54.987968, -24.625365],
            [-54.977275, -24.607265],
            [-54.966245, -24.602499],
            [-54.955096, -24.567317],
            [-54.943617, -24.564523],
            [-54.911696, -24.576463],
            [-54.903853, -24.598787],
            [-54.898908, -24.629243],
            [-54.871519, -24.633855],
            [-54.810644, -24.673316],
            [-54.785245, -24.665315],
            [-54.778602, -24.651542],
            [-54.751686, -24.660109],
            [-54.737933, -24.651919],
            [-54.72046, -24.67641],
            [-54.687385, -24.688325],
            [-54.68304, -24.671952],
            [-54.654124, -24.668356],
            [-54.648169, -24.686923],
            [-54.657861, -24.699844]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "MINGA PORÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.423139, -24.887775],
            [-54.439866, -24.966881],
            [-54.456479, -25.084967],
            [-54.481471, -25.067137],
            [-54.486325, -25.094263],
            [-54.521589, -25.085983],
            [-54.534152, -25.073705],
            [-54.544574, -25.078987],
            [-54.56599, -25.074133],
            [-54.604822, -25.078702],
            [-54.617529, -25.090694],
            [-54.641085, -25.075989],
            [-54.653221, -25.077988],
            [-54.671784, -25.09777],
            [-54.693723, -25.087815],
            [-54.706163, -25.091781],
            [-54.723943, -25.112779],
            [-54.776192, -25.13028],
            [-54.866528, -25.212453],
            [-54.863862, -25.226903],
            [-54.874878, -25.253366],
            [-54.870607, -25.224328],
            [-54.875338, -25.213488],
            [-54.864138, -25.173328],
            [-54.873019, -25.164921],
            [-54.87892, -25.138193],
            [-54.903077, -25.163798],
            [-54.941803, -25.181181],
            [-54.967812, -25.137971],
            [-54.949596, -25.059183],
            [-54.9399, -25.05402],
            [-54.891115, -25.003488],
            [-54.876012, -24.998746],
            [-54.851505, -25.002072],
            [-54.842001, -24.978059],
            [-54.815771, -24.95408],
            [-54.790992, -24.939945],
            [-54.774465, -24.955273],
            [-54.76059, -24.944391],
            [-54.738195, -24.888464],
            [-54.724413, -24.874061],
            [-54.707058, -24.878526],
            [-54.676355, -24.877783],
            [-54.661126, -24.858329],
            [-54.637373, -24.864978],
            [-54.633661, -24.881254],
            [-54.617119, -24.887873],
            [-54.585987, -24.867907],
            [-54.561951, -24.867861],
            [-54.509739, -24.888821],
            [-54.423139, -24.887775]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "MBARACAYÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.345807, -24.70766],
            [-54.372403, -24.739802],
            [-54.398873, -24.805107],
            [-54.403228, -24.841491],
            [-54.423139, -24.887775],
            [-54.509739, -24.888821],
            [-54.561951, -24.867861],
            [-54.585987, -24.867907],
            [-54.617119, -24.887873],
            [-54.633661, -24.881254],
            [-54.637373, -24.864978],
            [-54.661126, -24.858329],
            [-54.676355, -24.877783],
            [-54.707058, -24.878526],
            [-54.724413, -24.874061],
            [-54.738195, -24.888464],
            [-54.76059, -24.944391],
            [-54.774465, -24.955273],
            [-54.790992, -24.939945],
            [-54.815771, -24.95408],
            [-54.842001, -24.978059],
            [-54.851505, -25.002072],
            [-54.876012, -24.998746],
            [-54.891115, -25.003488],
            [-54.9399, -25.05402],
            [-54.949596, -25.059183],
            [-54.979715, -25.065545],
            [-54.975655, -25.051019],
            [-55.00162, -25.022794],
            [-55.024143, -25.012786],
            [-55.055251, -25.010239],
            [-55.068402, -24.990355],
            [-55.059104, -24.977821],
            [-55.055298, -24.943746],
            [-55.047329, -24.940143],
            [-55.029041, -24.848298],
            [-55.004772, -24.863264],
            [-54.986496, -24.867736],
            [-54.979449, -24.882519],
            [-54.966925, -24.881658],
            [-54.899018, -24.943808],
            [-54.866354, -24.921096],
            [-54.864504, -24.909411],
            [-54.840519, -24.896248],
            [-54.837844, -24.885706],
            [-54.794998, -24.861207],
            [-54.790773, -24.852632],
            [-54.738072, -24.854926],
            [-54.719233, -24.870901],
            [-54.703907, -24.871262],
            [-54.682098, -24.856067],
            [-54.66826, -24.789638],
            [-54.688573, -24.780069],
            [-54.72288, -24.782277],
            [-54.735839, -24.770036],
            [-54.723884, -24.733768],
            [-54.700846, -24.713718],
            [-54.698044, -24.702713],
            [-54.681481, -24.693381],
            [-54.657861, -24.699844],
            [-54.615111, -24.707076],
            [-54.610266, -24.696964],
            [-54.559952, -24.689375],
            [-54.536398, -24.691861],
            [-54.525297, -24.703708],
            [-54.504421, -24.698763],
            [-54.499098, -24.719593],
            [-54.476453, -24.706886],
            [-54.472163, -24.7234],
            [-54.443583, -24.718126],
            [-54.442937, -24.698474],
            [-54.425065, -24.698939],
            [-54.414963, -24.679505],
            [-54.401625, -24.690621],
            [-54.388422, -24.6878],
            [-54.345807, -24.70766]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "SAN ALBERTO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.936559, -25.980394],
            [-54.921135, -26.031693],
            [-54.934531, -26.04335],
            [-54.935248, -26.055239],
            [-54.961826, -26.068659],
            [-54.959013, -26.079171],
            [-54.976183, -26.092686],
            [-54.981832, -26.107086],
            [-54.888942, -26.135902],
            [-54.87467, -26.174255],
            [-54.870696, -26.190632],
            [-54.883816, -26.195519],
            [-54.91648, -26.189696],
            [-54.916272, -26.211473],
            [-54.908362, -26.220952],
            [-54.939366, -26.20852],
            [-54.957733, -26.222682],
            [-54.947425, -26.233791],
            [-54.981786, -26.238651],
            [-54.990062, -26.225255],
            [-55.009819, -26.235901],
            [-55.028005, -26.223637],
            [-55.035622, -26.237939],
            [-55.050071, -26.237717],
            [-55.123493, -26.219495],
            [-55.137617, -26.206572],
            [-55.165802, -26.216281],
            [-55.183572, -26.213433],
            [-55.205627, -26.233615],
            [-55.1803, -26.185102],
            [-55.160242, -26.13575],
            [-55.159319, -26.114065],
            [-55.146951, -26.091723],
            [-55.151212, -26.068371],
            [-55.129551, -26.04723],
            [-55.11978, -26.050656],
            [-55.090452, -26.030513],
            [-55.077821, -26.047342],
            [-55.050271, -26.046932],
            [-55.034078, -26.026508],
            [-55.022056, -26.027768],
            [-55.00713, -26.009689],
            [-54.994399, -26.006796],
            [-54.975978, -26.013184],
            [-54.96944, -26.002402],
            [-54.936559, -25.980394]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "IRUÑA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.456479, -25.084967],
            [-54.427024, -25.118643],
            [-54.41753, -25.136632],
            [-54.417017, -25.161004],
            [-54.433116, -25.181514],
            [-54.469491, -25.214302],
            [-54.481741, -25.256266],
            [-54.487286, -25.291636],
            [-54.511641, -25.328358],
            [-54.531345, -25.342776],
            [-54.541729, -25.328812],
            [-54.54302, -25.304739],
            [-54.554826, -25.289567],
            [-54.578968, -25.291757],
            [-54.615101, -25.286246],
            [-54.629605, -25.280366],
            [-54.636569, -25.257677],
            [-54.652225, -25.250828],
            [-54.676921, -25.26132],
            [-54.691652, -25.258837],
            [-54.701419, -25.246062],
            [-54.72347, -25.282497],
            [-54.73627, -25.278578],
            [-54.826079, -25.280304],
            [-54.874878, -25.253366],
            [-54.863862, -25.226903],
            [-54.866528, -25.212453],
            [-54.776192, -25.13028],
            [-54.723943, -25.112779],
            [-54.706163, -25.091781],
            [-54.693723, -25.087815],
            [-54.671784, -25.09777],
            [-54.653221, -25.077988],
            [-54.641085, -25.075989],
            [-54.617529, -25.090694],
            [-54.604822, -25.078702],
            [-54.56599, -25.074133],
            [-54.544574, -25.078987],
            [-54.534152, -25.073705],
            [-54.521589, -25.085983],
            [-54.486325, -25.094263],
            [-54.481471, -25.067137],
            [-54.456479, -25.084967]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "SANTA FE DEL PARANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.081703, -25.559745],
            [-55.034315, -25.5763],
            [-55.024459, -25.585594],
            [-54.972657, -25.583139],
            [-54.950767, -25.572144],
            [-54.945396, -25.577774],
            [-54.95421, -25.602723],
            [-54.93363, -25.617853],
            [-54.921386, -25.617058],
            [-54.903599, -25.604198],
            [-54.886295, -25.622412],
            [-54.88451, -25.652287],
            [-54.908234, -25.659462],
            [-54.917059, -25.720778],
            [-54.988519, -25.709011],
            [-54.998024, -25.716584],
            [-55.022317, -25.703415],
            [-55.014538, -25.68569],
            [-55.06599, -25.682234],
            [-55.073816, -25.674114],
            [-55.140533, -25.654018],
            [-55.161837, -25.668784],
            [-55.244114, -25.672137],
            [-55.237377, -25.636356],
            [-55.231887, -25.629862],
            [-55.226693, -25.596013],
            [-55.218311, -25.592765],
            [-55.217517, -25.526523],
            [-55.194807, -25.519495],
            [-55.169214, -25.523047],
            [-55.160507, -25.516799],
            [-55.144117, -25.54944],
            [-55.131268, -25.563155],
            [-55.105411, -25.55632],
            [-55.081703, -25.559745]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "TAVAPY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.129551, -26.04723],
            [-55.151212, -26.068371],
            [-55.146951, -26.091723],
            [-55.159319, -26.114065],
            [-55.160242, -26.13575],
            [-55.1803, -26.185102],
            [-55.205627, -26.233615],
            [-55.212023, -26.239977],
            [-55.230368, -26.244793],
            [-55.259845, -26.235964],
            [-55.263084, -26.217752],
            [-55.28445, -26.201394],
            [-55.303891, -26.162672],
            [-55.296577, -26.148828],
            [-55.311409, -26.139457],
            [-55.311719, -26.108235],
            [-55.299558, -26.103186],
            [-55.286861, -26.090758],
            [-55.249651, -26.069093],
            [-55.249222, -26.058675],
            [-55.229899, -26.065733],
            [-55.212472, -26.08735],
            [-55.203941, -26.07239],
            [-55.179125, -26.060918],
            [-55.181676, -26.041989],
            [-55.145105, -26.020184],
            [-55.142754, -26.037449],
            [-55.129551, -26.04723]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARANÁ",
        "dist_desc_": "DOCTOR RAÚL PEÑA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.33426, -25.311098],
            [-57.368049, -25.338273],
            [-57.373082, -25.353265],
            [-57.390103, -25.34755],
            [-57.402525, -25.357885],
            [-57.421747, -25.345426],
            [-57.431766, -25.322911],
            [-57.444332, -25.307941],
            [-57.446159, -25.282172],
            [-57.420647, -25.260722],
            [-57.393723, -25.257207],
            [-57.349818, -25.227507],
            [-57.337494, -25.232155],
            [-57.32854, -25.24872],
            [-57.341868, -25.276037],
            [-57.343299, -25.294015],
            [-57.33426, -25.311098]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "AREGUÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.402525, -25.357885],
            [-57.405787, -25.388754],
            [-57.399156, -25.418292],
            [-57.427113, -25.412394],
            [-57.423662, -25.403567],
            [-57.447271, -25.396183],
            [-57.465184, -25.439108],
            [-57.510766, -25.423578],
            [-57.507406, -25.403112],
            [-57.484566, -25.401887],
            [-57.483177, -25.342099],
            [-57.469994, -25.324433],
            [-57.444332, -25.307941],
            [-57.431766, -25.322911],
            [-57.421747, -25.345426],
            [-57.402525, -25.357885]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "CAPIATÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.535964, -25.295812],
            [-57.517974, -25.31878],
            [-57.540099, -25.332433],
            [-57.551821, -25.356953],
            [-57.570284, -25.355547],
            [-57.584936, -25.339359],
            [-57.560422, -25.320256],
            [-57.541826, -25.291726],
            [-57.535964, -25.295812]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "FERNANDO DE LA MORA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.428463, -25.459173],
            [-57.423722, -25.477461],
            [-57.434843, -25.507176],
            [-57.448895, -25.527388],
            [-57.485321, -25.507605],
            [-57.478472, -25.497673],
            [-57.475878, -25.479378],
            [-57.462644, -25.456363],
            [-57.428463, -25.459173]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "GUARAMBARÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.312246, -25.461011],
            [-57.317095, -25.497762],
            [-57.33078, -25.578783],
            [-57.343971, -25.589115],
            [-57.346437, -25.613039],
            [-57.368674, -25.622828],
            [-57.388147, -25.639093],
            [-57.397124, -25.6283],
            [-57.394847, -25.615618],
            [-57.414358, -25.598478],
            [-57.427085, -25.563228],
            [-57.420451, -25.534996],
            [-57.430652, -25.525583],
            [-57.423722, -25.477461],
            [-57.428463, -25.459173],
            [-57.401445, -25.444545],
            [-57.328837, -25.455907],
            [-57.312246, -25.461011]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "ITÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.299755, -25.448728],
            [-57.312246, -25.461011],
            [-57.328837, -25.455907],
            [-57.401445, -25.444545],
            [-57.399156, -25.418292],
            [-57.405787, -25.388754],
            [-57.402525, -25.357885],
            [-57.390103, -25.34755],
            [-57.373082, -25.353265],
            [-57.368049, -25.338273],
            [-57.33426, -25.311098],
            [-57.307335, -25.338426],
            [-57.331391, -25.371976],
            [-57.311299, -25.388758],
            [-57.315888, -25.405342],
            [-57.300079, -25.417648],
            [-57.299755, -25.448728]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "ITAUGUÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.586135, -25.341443],
            [-57.613791, -25.389412],
            [-57.64208, -25.380387],
            [-57.635274, -25.367609],
            [-57.636421, -25.349102],
            [-57.616029, -25.313682],
            [-57.586135, -25.341443]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "LAMBARÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.402491, -25.182251],
            [-57.41664, -25.197468],
            [-57.435994, -25.192501],
            [-57.448774, -25.212785],
            [-57.473873, -25.220948],
            [-57.500115, -25.203941],
            [-57.505922, -25.183357],
            [-57.501143, -25.161412],
            [-57.516522, -25.153876],
            [-57.529219, -25.160606],
            [-57.529939, -25.174392],
            [-57.54323, -25.180939],
            [-57.536947, -25.166585],
            [-57.539578, -25.142802],
            [-57.533635, -25.120238],
            [-57.515272, -25.100377],
            [-57.496235, -25.096707],
            [-57.478317, -25.103693],
            [-57.474415, -25.114231],
            [-57.437008, -25.129088],
            [-57.427015, -25.149884],
            [-57.398983, -25.170773],
            [-57.402491, -25.182251]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "LIMPIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.373973, -25.206853],
            [-57.349818, -25.227507],
            [-57.393723, -25.257207],
            [-57.420647, -25.260722],
            [-57.446159, -25.282172],
            [-57.444332, -25.307941],
            [-57.469994, -25.324433],
            [-57.493767, -25.312162],
            [-57.535964, -25.295812],
            [-57.541826, -25.291726],
            [-57.542529, -25.272124],
            [-57.52503, -25.242664],
            [-57.512601, -25.216839],
            [-57.500115, -25.203941],
            [-57.473873, -25.220948],
            [-57.448774, -25.212785],
            [-57.435994, -25.192501],
            [-57.41664, -25.197468],
            [-57.402491, -25.182251],
            [-57.373973, -25.206853]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "LUQUE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.500115, -25.203941],
            [-57.512601, -25.216839],
            [-57.52503, -25.242664],
            [-57.575086, -25.224663],
            [-57.559354, -25.197463],
            [-57.54323, -25.180939],
            [-57.529939, -25.174392],
            [-57.529219, -25.160606],
            [-57.516522, -25.153876],
            [-57.501143, -25.161412],
            [-57.505922, -25.183357],
            [-57.500115, -25.203941]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "MARIANO ROQUE ALONSO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.414358, -25.598478],
            [-57.394847, -25.615618],
            [-57.397124, -25.6283],
            [-57.406309, -25.62839],
            [-57.421513, -25.647052],
            [-57.416483, -25.674113],
            [-57.41937, -25.693386],
            [-57.432726, -25.70154],
            [-57.449227, -25.723163],
            [-57.468209, -25.756149],
            [-57.453799, -25.808391],
            [-57.456491, -25.817523],
            [-57.442906, -25.844625],
            [-57.423004, -25.854065],
            [-57.415749, -25.879598],
            [-57.417286, -25.891638],
            [-57.446799, -25.932162],
            [-57.47605, -25.972293],
            [-57.499619, -26.025117],
            [-57.497653, -25.977524],
            [-57.518125, -25.987615],
            [-57.522341, -25.95255],
            [-57.521516, -25.840866],
            [-57.527504, -25.816591],
            [-57.523288, -25.754698],
            [-57.516199, -25.693954],
            [-57.508176, -25.592118],
            [-57.497974, -25.563762],
            [-57.472514, -25.573658],
            [-57.444327, -25.591475],
            [-57.414358, -25.598478]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "NUEVA ITALIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.507406, -25.403112],
            [-57.510766, -25.423578],
            [-57.534474, -25.443702],
            [-57.538957, -25.419052],
            [-57.571855, -25.384836],
            [-57.566758, -25.360922],
            [-57.526884, -25.372394],
            [-57.523278, -25.385783],
            [-57.507406, -25.403112]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "ÑEMBY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.52503, -25.242664],
            [-57.542529, -25.272124],
            [-57.541826, -25.291726],
            [-57.560422, -25.320256],
            [-57.584936, -25.339359],
            [-57.586135, -25.341443],
            [-57.616029, -25.313682],
            [-57.636421, -25.349102],
            [-57.635274, -25.367609],
            [-57.64208, -25.380387],
            [-57.663467, -25.353841],
            [-57.673858, -25.315799],
            [-57.67283, -25.287615],
            [-57.665677, -25.277344],
            [-57.622845, -25.252738],
            [-57.593662, -25.241651],
            [-57.575086, -25.224663],
            [-57.52503, -25.242664]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ASUNCIÓN",
        "dist_desc_": "ASUNCIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.385735, -23.064081],
            [-57.364896, -23.07921],
            [-57.338601, -23.081345],
            [-57.328849, -23.092778],
            [-57.290144, -23.083126],
            [-57.280017, -23.092447],
            [-57.255534, -23.082725],
            [-57.254291, -23.109059],
            [-57.280811, -23.147217],
            [-57.294573, -23.176383],
            [-57.319673, -23.170184],
            [-57.331155, -23.213472],
            [-57.352092, -23.224298],
            [-57.357477, -23.258729],
            [-57.375202, -23.266881],
            [-57.340993, -23.30179],
            [-57.327013, -23.305875],
            [-57.309353, -23.323368],
            [-57.259998, -23.335272],
            [-57.22518, -23.350542],
            [-57.203259, -23.354884],
            [-57.203639, -23.329146],
            [-57.182641, -23.325818],
            [-57.177298, -23.339871],
            [-57.144293, -23.329804],
            [-57.140822, -23.354675],
            [-57.224652, -23.374702],
            [-57.275784, -23.37411],
            [-57.323577, -23.408392],
            [-57.311647, -23.436884],
            [-57.329887, -23.438757],
            [-57.340557, -23.459221],
            [-57.293183, -23.4679],
            [-57.29579, -23.491251],
            [-57.326463, -23.499997],
            [-57.334742, -23.496753],
            [-57.362047, -23.509491],
            [-57.376524, -23.497768],
            [-57.402792, -23.498416],
            [-57.410662, -23.483956],
            [-57.447033, -23.477583],
            [-57.450781, -23.4468],
            [-57.48782, -23.389018],
            [-57.494602, -23.372686],
            [-57.519999, -23.353219],
            [-57.518329, -23.336076],
            [-57.488802, -23.316407],
            [-57.491586, -23.28276],
            [-57.510067, -23.261699],
            [-57.533063, -23.243891],
            [-57.549047, -23.212022],
            [-57.617982, -23.184036],
            [-57.641181, -23.142112],
            [-57.640887, -23.130492],
            [-57.627693, -23.111368],
            [-57.612974, -23.100088],
            [-57.59091, -23.105648],
            [-57.579477, -23.097962],
            [-57.537367, -23.10292],
            [-57.519436, -23.083262],
            [-57.493861, -23.077294],
            [-57.468933, -23.054229],
            [-57.457719, -23.068132],
            [-57.446375, -23.069144],
            [-57.424439, -23.055316],
            [-57.413012, -23.061631],
            [-57.385735, -23.064081]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "CONCEPCIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.146124, -23.475622],
            [-57.200465, -23.48257],
            [-57.222787, -23.474262],
            [-57.237016, -23.479292],
            [-57.26236, -23.478485],
            [-57.285995, -23.496612],
            [-57.29579, -23.491251],
            [-57.293183, -23.4679],
            [-57.340557, -23.459221],
            [-57.329887, -23.438757],
            [-57.311647, -23.436884],
            [-57.323577, -23.408392],
            [-57.275784, -23.37411],
            [-57.224652, -23.374702],
            [-57.140822, -23.354675],
            [-57.138474, -23.393588],
            [-57.144362, -23.40327],
            [-57.147587, -23.441549],
            [-57.15699, -23.458254],
            [-57.146124, -23.475622]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "BELÉN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.98375, -22.242528],
            [-57.005233, -22.330435],
            [-57.021881, -22.352792],
            [-57.051724, -22.38124],
            [-57.121445, -22.377726],
            [-57.113032, -22.403632],
            [-57.102388, -22.486622],
            [-57.131097, -22.489315],
            [-57.121083, -22.510518],
            [-57.120603, -22.530272],
            [-57.106981, -22.556532],
            [-57.109255, -22.576042],
            [-57.125901, -22.571819],
            [-57.148817, -22.574809],
            [-57.159139, -22.568635],
            [-57.181583, -22.605839],
            [-57.208375, -22.605958],
            [-57.228333, -22.612474],
            [-57.236699, -22.604962],
            [-57.259999, -22.615435],
            [-57.277484, -22.615878],
            [-57.290222, -22.617137],
            [-57.304005, -22.604329],
            [-57.352563, -22.647835],
            [-57.348001, -22.674142],
            [-57.366432, -22.694779],
            [-57.381953, -22.699048],
            [-57.387007, -22.710824],
            [-57.424714, -22.750201],
            [-57.357322, -22.549376],
            [-57.502216, -22.382377],
            [-57.514353, -22.381431],
            [-57.512283, -22.316637],
            [-57.499419, -22.284561],
            [-57.510713, -22.263147],
            [-57.537739, -22.255119],
            [-57.555092, -22.202822],
            [-57.563802, -22.188053],
            [-57.556105, -22.178862],
            [-57.54029, -22.181154],
            [-57.521619, -22.168305],
            [-57.506149, -22.184913],
            [-57.489246, -22.191135],
            [-57.472915, -22.186946],
            [-57.444758, -22.188331],
            [-57.43059, -22.19622],
            [-57.383163, -22.208015],
            [-57.381552, -22.226467],
            [-57.342351, -22.229101],
            [-57.321232, -22.245776],
            [-57.310919, -22.228948],
            [-57.29584, -22.218699],
            [-57.24071, -22.249371],
            [-57.220978, -22.239109],
            [-57.206161, -22.209243],
            [-57.181621, -22.230205],
            [-57.151065, -22.231076],
            [-57.127754, -22.224569],
            [-57.101414, -22.248542],
            [-57.084821, -22.250286],
            [-57.019309, -22.231403],
            [-57.01053, -22.235894],
            [-56.996415, -22.222424],
            [-56.98375, -22.242528]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "SAN CARLOS DEL APA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.556105, -22.178862],
            [-57.563802, -22.188053],
            [-57.555092, -22.202822],
            [-57.537739, -22.255119],
            [-57.510713, -22.263147],
            [-57.499419, -22.284561],
            [-57.512283, -22.316637],
            [-57.514353, -22.381431],
            [-57.529463, -22.392647],
            [-57.557697, -22.400466],
            [-57.575382, -22.400413],
            [-57.613674, -22.371721],
            [-57.642554, -22.364698],
            [-57.673478, -22.36806],
            [-57.702091, -22.383937],
            [-57.721863, -22.377833],
            [-57.745923, -22.390367],
            [-57.762831, -22.414538],
            [-57.806831, -22.394738],
            [-57.825332, -22.413132],
            [-57.843757, -22.412307],
            [-57.845519, -22.399055],
            [-57.827431, -22.395544],
            [-57.821354, -22.373316],
            [-57.86698, -22.34306],
            [-57.877699, -22.329258],
            [-57.877296, -22.311988],
            [-57.884162, -22.279562],
            [-57.894087, -22.265573],
            [-57.927043, -22.27617],
            [-57.951789, -22.277079],
            [-57.960054, -22.236732],
            [-57.971349, -22.225712],
            [-57.972553, -22.194305],
            [-57.963191, -22.171429],
            [-57.956594, -22.13154],
            [-57.96292, -22.120721],
            [-57.990167, -22.104637],
            [-57.993034, -22.086919],
            [-57.970704, -22.090363],
            [-57.959918, -22.079347],
            [-57.939075, -22.085133],
            [-57.929884, -22.118858],
            [-57.88612, -22.130136],
            [-57.863715, -22.131015],
            [-57.828071, -22.12025],
            [-57.819527, -22.138108],
            [-57.799313, -22.149943],
            [-57.779775, -22.12515],
            [-57.748986, -22.138786],
            [-57.734209, -22.12093],
            [-57.689858, -22.08828],
            [-57.675008, -22.102512],
            [-57.638924, -22.106203],
            [-57.609898, -22.096164],
            [-57.612209, -22.121126],
            [-57.584165, -22.141835],
            [-57.587975, -22.16564],
            [-57.580226, -22.175271],
            [-57.556105, -22.178862]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "SAN LÁZARO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.294387, -22.687641],
            [-56.20878, -22.874392],
            [-56.132473, -23.040365],
            [-56.12905, -23.075018],
            [-56.151362, -23.09974],
            [-56.139751, -23.111248],
            [-56.144168, -23.123154],
            [-56.163978, -23.124294],
            [-56.178838, -23.118217],
            [-56.188172, -23.12919],
            [-56.183326, -23.161046],
            [-56.203973, -23.163658],
            [-56.203066, -23.173662],
            [-56.21759, -23.185992],
            [-56.204974, -23.207105],
            [-56.202929, -23.227301],
            [-56.223724, -23.230937],
            [-56.262449, -23.24637],
            [-56.27346, -23.27146],
            [-56.286595, -23.273099],
            [-56.29235, -23.257754],
            [-56.33003, -23.27243],
            [-56.367515, -23.256318],
            [-56.382674, -23.258058],
            [-56.427333, -23.24055],
            [-56.449406, -23.244206],
            [-56.473906, -23.254118],
            [-56.495807, -23.255348],
            [-56.513259, -23.123623],
            [-56.547022, -23.11619],
            [-56.558866, -23.055489],
            [-56.564692, -23.036391],
            [-56.594045, -23.018786],
            [-56.617587, -23.018854],
            [-56.644147, -23.00719],
            [-56.671859, -23.005846],
            [-56.693818, -22.993669],
            [-56.679403, -22.976234],
            [-56.683841, -22.956829],
            [-56.715704, -22.944564],
            [-56.708895, -22.935691],
            [-56.71967, -22.919438],
            [-56.713041, -22.897017],
            [-56.708694, -22.905949],
            [-56.667314, -22.893474],
            [-56.66528, -22.88403],
            [-56.625794, -22.892862],
            [-56.61488, -22.909133],
            [-56.596767, -22.913451],
            [-56.568775, -22.901485],
            [-56.538011, -22.876611],
            [-56.543662, -22.861049],
            [-56.521924, -22.841396],
            [-56.526012, -22.809764],
            [-56.508678, -22.802377],
            [-56.509667, -22.787253],
            [-56.494067, -22.776301],
            [-56.455246, -22.768328],
            [-56.442059, -22.772239],
            [-56.417486, -22.759744],
            [-56.413066, -22.744556],
            [-56.391341, -22.739502],
            [-56.39249, -22.722465],
            [-56.38442, -22.713256],
            [-56.36413, -22.720169],
            [-56.35782, -22.710184],
            [-56.328049, -22.687636],
            [-56.30828, -22.692805],
            [-56.294387, -22.687641]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "YBY YAU"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.286595, -23.273099],
            [-56.285994, -23.287519],
            [-56.298978, -23.295757],
            [-56.290891, -23.320068],
            [-56.311854, -23.327085],
            [-56.314223, -23.345397],
            [-56.349741, -23.352712],
            [-56.361874, -23.363977],
            [-56.352985, -23.37959],
            [-56.384891, -23.390494],
            [-56.406107, -23.414353],
            [-56.43626, -23.418945],
            [-56.457163, -23.406073],
            [-56.476748, -23.4093],
            [-56.491376, -23.424027],
            [-56.515073, -23.427951],
            [-56.517521, -23.451021],
            [-56.529031, -23.456801],
            [-56.564763, -23.445305],
            [-56.607626, -23.458558],
            [-56.632783, -23.444628],
            [-56.673815, -23.44175],
            [-56.693488, -23.449982],
            [-56.726586, -23.432975],
            [-56.713095, -23.424877],
            [-56.706745, -23.401394],
            [-56.698361, -23.384929],
            [-56.666777, -23.376356],
            [-56.658494, -23.381721],
            [-56.634005, -23.377597],
            [-56.622323, -23.352114],
            [-56.575217, -23.311249],
            [-56.565439, -23.269717],
            [-56.59024, -23.235712],
            [-56.593877, -23.209065],
            [-56.601395, -23.193055],
            [-56.595127, -23.180749],
            [-56.576701, -23.165724],
            [-56.563878, -23.136182],
            [-56.547022, -23.11619],
            [-56.513259, -23.123623],
            [-56.495807, -23.255348],
            [-56.473906, -23.254118],
            [-56.449406, -23.244206],
            [-56.427333, -23.24055],
            [-56.382674, -23.258058],
            [-56.367515, -23.256318],
            [-56.33003, -23.27243],
            [-56.29235, -23.257754],
            [-56.286595, -23.273099]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "AZOTE'Y"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.826067, -22.295926],
            [-56.609426, -22.365286],
            [-56.64365, -22.382773],
            [-56.648658, -22.42215],
            [-56.699045, -22.440523],
            [-56.716417, -22.458229],
            [-56.722629, -22.509426],
            [-56.734788, -22.524551],
            [-56.738518, -22.543249],
            [-56.726167, -22.577304],
            [-56.726906, -22.593223],
            [-56.718255, -22.609541],
            [-56.722316, -22.654157],
            [-56.694325, -22.682097],
            [-56.694564, -22.68871],
            [-56.696381, -22.688202],
            [-57.019995, -22.749295],
            [-57.216401, -22.786026],
            [-57.213231, -22.776956],
            [-57.222802, -22.756044],
            [-57.248035, -22.735374],
            [-57.272349, -22.681529],
            [-57.255386, -22.681788],
            [-57.243041, -22.632293],
            [-57.277484, -22.615878],
            [-57.259999, -22.615435],
            [-57.236699, -22.604962],
            [-57.228333, -22.612474],
            [-57.208375, -22.605958],
            [-57.181583, -22.605839],
            [-57.159139, -22.568635],
            [-57.148817, -22.574809],
            [-57.125901, -22.571819],
            [-57.109255, -22.576042],
            [-57.106981, -22.556532],
            [-57.120603, -22.530272],
            [-57.121083, -22.510518],
            [-57.131097, -22.489315],
            [-57.102388, -22.486622],
            [-57.113032, -22.403632],
            [-57.121445, -22.377726],
            [-57.051724, -22.38124],
            [-57.021881, -22.352792],
            [-57.005233, -22.330435],
            [-56.98375, -22.242528],
            [-56.957757, -22.238287],
            [-56.947506, -22.255852],
            [-56.914936, -22.256713],
            [-56.883334, -22.247482],
            [-56.876113, -22.262157],
            [-56.879748, -22.277919],
            [-56.844373, -22.300825],
            [-56.826067, -22.295926]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "SARGENTO JOSÉ FÉLIX LÓPEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.514353, -22.381431],
            [-57.502216, -22.382377],
            [-57.357322, -22.549376],
            [-57.424714, -22.750201],
            [-57.387007, -22.710824],
            [-57.381953, -22.699048],
            [-57.366432, -22.694779],
            [-57.348001, -22.674142],
            [-57.352563, -22.647835],
            [-57.304005, -22.604329],
            [-57.290222, -22.617137],
            [-57.277484, -22.615878],
            [-57.243041, -22.632293],
            [-57.255386, -22.681788],
            [-57.272349, -22.681529],
            [-57.248035, -22.735374],
            [-57.222802, -22.756044],
            [-57.213231, -22.776956],
            [-57.216401, -22.786026],
            [-57.210722, -22.829698],
            [-57.202275, -22.847117],
            [-57.200102, -22.87506],
            [-57.204005, -22.89422],
            [-57.200619, -22.919044],
            [-57.257697, -22.9708],
            [-57.269668, -22.964362],
            [-57.289083, -22.969436],
            [-57.309671, -22.966583],
            [-57.312754, -22.983546],
            [-57.345522, -23.005226],
            [-57.357579, -23.029377],
            [-57.36477, -23.031989],
            [-57.374046, -23.059023],
            [-57.385735, -23.064081],
            [-57.413012, -23.061631],
            [-57.424439, -23.055316],
            [-57.446375, -23.069144],
            [-57.457719, -23.068132],
            [-57.468933, -23.054229],
            [-57.493861, -23.077294],
            [-57.519436, -23.083262],
            [-57.537367, -23.10292],
            [-57.579477, -23.097962],
            [-57.59091, -23.105648],
            [-57.612974, -23.100088],
            [-57.627693, -23.111368],
            [-57.634178, -23.092942],
            [-57.667017, -23.094004],
            [-57.70176, -23.097241],
            [-57.725078, -23.078884],
            [-57.731485, -23.059845],
            [-57.767183, -23.035906],
            [-57.786599, -23.032143],
            [-57.784939, -23.006277],
            [-57.765863, -22.976363],
            [-57.767394, -22.965291],
            [-57.789877, -22.941428],
            [-57.821375, -22.914974],
            [-57.818284, -22.90415],
            [-57.798432, -22.892743],
            [-57.789507, -22.877517],
            [-57.811439, -22.817369],
            [-57.840264, -22.807997],
            [-57.875318, -22.80298],
            [-57.882556, -22.793939],
            [-57.877433, -22.773711],
            [-57.890147, -22.755891],
            [-57.925789, -22.743273],
            [-57.940248, -22.708272],
            [-57.937445, -22.688967],
            [-57.909428, -22.659125],
            [-57.848425, -22.651732],
            [-57.829701, -22.652846],
            [-57.789976, -22.663873],
            [-57.776803, -22.661268],
            [-57.772888, -22.639449],
            [-57.779917, -22.622618],
            [-57.804785, -22.592152],
            [-57.827744, -22.570731],
            [-57.830876, -22.513493],
            [-57.844475, -22.487727],
            [-57.840531, -22.443855],
            [-57.862, -22.423963],
            [-57.864481, -22.403069],
            [-57.85573, -22.397713],
            [-57.845519, -22.399055],
            [-57.843757, -22.412307],
            [-57.825332, -22.413132],
            [-57.806831, -22.394738],
            [-57.762831, -22.414538],
            [-57.745923, -22.390367],
            [-57.721863, -22.377833],
            [-57.702091, -22.383937],
            [-57.673478, -22.36806],
            [-57.642554, -22.364698],
            [-57.613674, -22.371721],
            [-57.575382, -22.400413],
            [-57.557697, -22.400466],
            [-57.529463, -22.392647],
            [-57.514353, -22.381431]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "SAN ALFREDO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.713041, -22.897017],
            [-56.71967, -22.919438],
            [-56.708895, -22.935691],
            [-56.715704, -22.944564],
            [-56.683841, -22.956829],
            [-56.679403, -22.976234],
            [-56.693818, -22.993669],
            [-56.708876, -22.995162],
            [-56.725377, -23.009107],
            [-56.747314, -23.017754],
            [-56.763191, -23.014187],
            [-56.793578, -23.035041],
            [-56.787466, -23.05205],
            [-56.804394, -23.055785],
            [-56.826412, -23.080009],
            [-56.837121, -23.073298],
            [-56.859051, -23.082451],
            [-56.894186, -23.067118],
            [-56.893358, -23.079823],
            [-56.906347, -23.09302],
            [-56.945306, -23.08613],
            [-56.976425, -23.09236],
            [-57.001856, -23.085989],
            [-57.004279, -23.076593],
            [-57.036076, -23.07067],
            [-57.044354, -23.075579],
            [-57.066178, -23.055798],
            [-57.084286, -23.064782],
            [-57.12152, -23.058083],
            [-57.134253, -23.078728],
            [-57.153299, -23.092539],
            [-57.177893, -23.098206],
            [-57.195463, -23.083878],
            [-57.225138, -23.099582],
            [-57.239461, -23.1148],
            [-57.254291, -23.109059],
            [-57.255534, -23.082725],
            [-57.280017, -23.092447],
            [-57.290144, -23.083126],
            [-57.328849, -23.092778],
            [-57.338601, -23.081345],
            [-57.364896, -23.07921],
            [-57.385735, -23.064081],
            [-57.374046, -23.059023],
            [-57.36477, -23.031989],
            [-57.357579, -23.029377],
            [-57.345522, -23.005226],
            [-57.312754, -22.983546],
            [-57.309671, -22.966583],
            [-57.289083, -22.969436],
            [-57.269668, -22.964362],
            [-57.257697, -22.9708],
            [-57.200619, -22.919044],
            [-57.204005, -22.89422],
            [-57.200102, -22.87506],
            [-57.202275, -22.847117],
            [-57.210722, -22.829698],
            [-57.216401, -22.786026],
            [-57.019995, -22.749295],
            [-56.696381, -22.688202],
            [-56.694564, -22.68871],
            [-56.696299, -22.708651],
            [-56.672317, -22.711783],
            [-56.666954, -22.742396],
            [-56.669689, -22.765853],
            [-56.662268, -22.772017],
            [-56.66093, -22.794178],
            [-56.649583, -22.800865],
            [-56.653458, -22.815906],
            [-56.686957, -22.841142],
            [-56.714482, -22.849658],
            [-56.704913, -22.868155],
            [-56.713041, -22.897017]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "PASO BARRETO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.979582, -23.448158],
            [-56.966998, -23.468224],
            [-56.971677, -23.483441],
            [-56.959314, -23.521915],
            [-56.932975, -23.560066],
            [-56.940008, -23.577294],
            [-56.94624, -23.627715],
            [-56.972184, -23.695064],
            [-56.910449, -23.692645],
            [-56.900946, -23.699084],
            [-56.878602, -23.698976],
            [-56.849939, -23.719816],
            [-56.827053, -23.718289],
            [-56.814168, -23.700381],
            [-56.74868, -23.725769],
            [-56.737998, -23.742448],
            [-56.722858, -23.752014],
            [-56.703603, -23.773575],
            [-56.714672, -23.794122],
            [-56.737528, -23.820199],
            [-56.746344, -23.845554],
            [-56.743453, -23.885495],
            [-56.727832, -23.915677],
            [-56.705818, -23.935995],
            [-56.705161, -23.952771],
            [-56.733056, -23.983871],
            [-56.735004, -23.997626],
            [-56.754197, -24.015221],
            [-56.774288, -24.024817],
            [-56.789809, -24.061162],
            [-56.818263, -24.07233],
            [-56.839284, -24.090923],
            [-56.859365, -24.085254],
            [-56.869619, -24.073228],
            [-56.891684, -24.0876],
            [-56.904325, -24.074131],
            [-56.923023, -24.08787],
            [-56.943437, -24.090386],
            [-56.960987, -24.085001],
            [-56.974026, -24.096286],
            [-56.984064, -24.089455],
            [-57.011514, -24.105377],
            [-57.03823, -24.107692],
            [-57.043497, -24.120208],
            [-57.062976, -24.119001],
            [-57.075416, -24.133101],
            [-57.089784, -24.132353],
            [-57.103272, -24.134566],
            [-57.141948, -24.1577],
            [-57.151931, -24.152397],
            [-57.146136, -24.129443],
            [-57.16171, -24.096435],
            [-57.135861, -24.091142],
            [-57.129341, -24.036632],
            [-57.133174, -24.011669],
            [-57.104085, -24.004687],
            [-57.086649, -23.995708],
            [-57.07662, -23.981838],
            [-57.087258, -23.967648],
            [-57.088834, -23.947311],
            [-57.103593, -23.908621],
            [-57.150455, -23.905233],
            [-57.17398, -23.911228],
            [-57.192478, -23.931378],
            [-57.229763, -23.951756],
            [-57.238152, -23.941788],
            [-57.263052, -23.943976],
            [-57.299219, -23.923999],
            [-57.303044, -23.900664],
            [-57.265197, -23.886024],
            [-57.255301, -23.865982],
            [-57.272881, -23.851539],
            [-57.272685, -23.835046],
            [-57.25148, -23.811903],
            [-57.252724, -23.787087],
            [-57.278042, -23.77159],
            [-57.255742, -23.761376],
            [-57.256661, -23.735966],
            [-57.266484, -23.724657],
            [-57.303242, -23.70765],
            [-57.34319, -23.680226],
            [-57.375754, -23.671087],
            [-57.419096, -23.65374],
            [-57.421153, -23.641253],
            [-57.448108, -23.59987],
            [-57.468284, -23.560286],
            [-57.473517, -23.536198],
            [-57.447033, -23.477583],
            [-57.410662, -23.483956],
            [-57.402792, -23.498416],
            [-57.376524, -23.497768],
            [-57.362047, -23.509491],
            [-57.334742, -23.496753],
            [-57.326463, -23.499997],
            [-57.29579, -23.491251],
            [-57.285995, -23.496612],
            [-57.26236, -23.478485],
            [-57.237016, -23.479292],
            [-57.222787, -23.474262],
            [-57.200465, -23.48257],
            [-57.146124, -23.475622],
            [-57.135394, -23.46857],
            [-57.059101, -23.45751],
            [-57.032925, -23.442126],
            [-57.005781, -23.45173],
            [-56.979582, -23.448158]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "SAN PEDRO DEL YCUAMANDYYÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.089784, -24.132353],
            [-57.08186, -24.187982],
            [-57.089094, -24.196215],
            [-57.09925, -24.203308],
            [-57.08326, -24.224723],
            [-57.077692, -24.243426],
            [-57.103675, -24.242284],
            [-57.108529, -24.251135],
            [-57.134941, -24.26013],
            [-57.179011, -24.266654],
            [-57.204586, -24.26132],
            [-57.206265, -24.230844],
            [-57.218837, -24.212017],
            [-57.240561, -24.201047],
            [-57.254348, -24.175924],
            [-57.277024, -24.152374],
            [-57.275877, -24.135491],
            [-57.257588, -24.128726],
            [-57.233107, -24.109672],
            [-57.210619, -24.09775],
            [-57.209106, -24.078374],
            [-57.221674, -24.065833],
            [-57.258296, -24.050593],
            [-57.261963, -24.033534],
            [-57.228504, -24.020382],
            [-57.21133, -24.004546],
            [-57.215403, -23.987555],
            [-57.240829, -23.980716],
            [-57.229763, -23.951756],
            [-57.192478, -23.931378],
            [-57.17398, -23.911228],
            [-57.150455, -23.905233],
            [-57.103593, -23.908621],
            [-57.088834, -23.947311],
            [-57.087258, -23.967648],
            [-57.07662, -23.981838],
            [-57.086649, -23.995708],
            [-57.104085, -24.004687],
            [-57.133174, -24.011669],
            [-57.129341, -24.036632],
            [-57.135861, -24.091142],
            [-57.16171, -24.096435],
            [-57.146136, -24.129443],
            [-57.151931, -24.152397],
            [-57.141948, -24.1577],
            [-57.103272, -24.134566],
            [-57.089784, -24.132353]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "ANTEQUERA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.534471, -24.054137],
            [-56.531031, -24.065429],
            [-56.536099, -24.097702],
            [-56.534672, -24.12804],
            [-56.51831, -24.1535],
            [-56.511664, -24.178583],
            [-56.500451, -24.197324],
            [-56.500288, -24.214001],
            [-56.484376, -24.265736],
            [-56.493878, -24.301153],
            [-56.546522, -24.299135],
            [-56.545546, -24.343532],
            [-56.556044, -24.355462],
            [-56.5794, -24.346221],
            [-56.601091, -24.355732],
            [-56.607209, -24.347755],
            [-56.602086, -24.31567],
            [-56.613168, -24.299969],
            [-56.627677, -24.294614],
            [-56.651277, -24.296905],
            [-56.68577, -24.273877],
            [-56.688934, -24.26757],
            [-56.72333, -24.259182],
            [-56.750866, -24.223777],
            [-56.811618, -24.194675],
            [-56.806096, -24.165845],
            [-56.798111, -24.15244],
            [-56.797205, -24.130219],
            [-56.769101, -24.125427],
            [-56.780758, -24.112112],
            [-56.769552, -24.098516],
            [-56.766356, -24.075947],
            [-56.744233, -24.073779],
            [-56.73621, -24.079668],
            [-56.720211, -24.068288],
            [-56.702746, -24.064865],
            [-56.682092, -24.071422],
            [-56.654587, -24.062645],
            [-56.61874, -24.05593],
            [-56.591207, -24.05822],
            [-56.58702, -24.047947],
            [-56.550011, -24.036552],
            [-56.534471, -24.054137]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "CHORÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.601091, -24.355732],
            [-56.607753, -24.376852],
            [-56.605925, -24.424104],
            [-56.611154, -24.437158],
            [-56.628748, -24.452676],
            [-56.653485, -24.464909],
            [-56.693502, -24.455381],
            [-56.725178, -24.453862],
            [-56.757795, -24.45787],
            [-56.776926, -24.472432],
            [-56.800054, -24.481427],
            [-56.807907, -24.500272],
            [-56.833319, -24.500415],
            [-56.841171, -24.49242],
            [-56.867155, -24.49756],
            [-56.916696, -24.48471],
            [-56.913697, -24.520688],
            [-56.982458, -24.535926],
            [-56.997211, -24.525427],
            [-56.997639, -24.481455],
            [-56.989787, -24.449475],
            [-57.007918, -24.41778],
            [-56.97965, -24.404217],
            [-56.96209, -24.379947],
            [-56.945386, -24.396651],
            [-56.907838, -24.360388],
            [-56.884139, -24.341542],
            [-56.853703, -24.311252],
            [-56.850303, -24.302786],
            [-56.819768, -24.276691],
            [-56.819757, -24.226506],
            [-56.811618, -24.194675],
            [-56.750866, -24.223777],
            [-56.72333, -24.259182],
            [-56.688934, -24.26757],
            [-56.68577, -24.273877],
            [-56.651277, -24.296905],
            [-56.627677, -24.294614],
            [-56.613168, -24.299969],
            [-56.602086, -24.31567],
            [-56.607209, -24.347755],
            [-56.601091, -24.355732]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "GENERAL ELIZARDO AQUINO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.704115, -24.643025],
            [-56.727621, -24.670219],
            [-56.742969, -24.651413],
            [-56.753991, -24.670903],
            [-56.767985, -24.671777],
            [-56.78092, -24.643728],
            [-56.809212, -24.643518],
            [-56.83131, -24.648172],
            [-56.861314, -24.640233],
            [-56.872572, -24.656109],
            [-56.889719, -24.663497],
            [-56.873974, -24.678898],
            [-56.853927, -24.678462],
            [-56.860582, -24.698604],
            [-56.894275, -24.681329],
            [-56.907124, -24.690324],
            [-56.904983, -24.7056],
            [-56.890849, -24.728014],
            [-56.901557, -24.736438],
            [-56.963375, -24.728157],
            [-57.004635, -24.719734],
            [-57.033474, -24.714594],
            [-57.024479, -24.684613],
            [-57.0152, -24.672906],
            [-57.025193, -24.658201],
            [-56.968229, -24.557122],
            [-56.982458, -24.535926],
            [-56.913697, -24.520688],
            [-56.916696, -24.48471],
            [-56.867155, -24.49756],
            [-56.841171, -24.49242],
            [-56.833319, -24.500415],
            [-56.807907, -24.500272],
            [-56.800054, -24.481427],
            [-56.776926, -24.472432],
            [-56.757795, -24.45787],
            [-56.725178, -24.453862],
            [-56.693502, -24.455381],
            [-56.653485, -24.464909],
            [-56.628748, -24.452676],
            [-56.611154, -24.437158],
            [-56.63338, -24.499778],
            [-56.640023, -24.511851],
            [-56.579515, -24.533328],
            [-56.602789, -24.561489],
            [-56.619724, -24.567309],
            [-56.629521, -24.586977],
            [-56.673851, -24.602119],
            [-56.704115, -24.643025]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "ITACURUBÍ DEL ROSARIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.369717, -23.915129],
            [-56.370375, -23.947518],
            [-56.429338, -24.019386],
            [-56.448687, -24.046314],
            [-56.458105, -24.073718],
            [-56.464863, -24.078319],
            [-56.486246, -24.063242],
            [-56.527217, -24.048718],
            [-56.534471, -24.054137],
            [-56.550011, -24.036552],
            [-56.58702, -24.047947],
            [-56.591207, -24.05822],
            [-56.61874, -24.05593],
            [-56.654587, -24.062645],
            [-56.682092, -24.071422],
            [-56.702746, -24.064865],
            [-56.720211, -24.068288],
            [-56.73621, -24.079668],
            [-56.744233, -24.073779],
            [-56.766356, -24.075947],
            [-56.776273, -24.067989],
            [-56.796562, -24.077155],
            [-56.818263, -24.07233],
            [-56.789809, -24.061162],
            [-56.774288, -24.024817],
            [-56.754197, -24.015221],
            [-56.735004, -23.997626],
            [-56.733056, -23.983871],
            [-56.705161, -23.952771],
            [-56.705818, -23.935995],
            [-56.687107, -23.919551],
            [-56.661914, -23.906139],
            [-56.635419, -23.901318],
            [-56.616382, -23.906502],
            [-56.587128, -23.889181],
            [-56.564832, -23.886411],
            [-56.555269, -23.887104],
            [-56.534861, -23.872547],
            [-56.514077, -23.867091],
            [-56.483397, -23.876859],
            [-56.469995, -23.868566],
            [-56.45609, -23.873425],
            [-56.446281, -23.890915],
            [-56.423543, -23.891756],
            [-56.389658, -23.903743],
            [-56.369717, -23.915129]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "LIMA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.114045, -23.605876],
            [-56.338146, -23.650822],
            [-56.472088, -23.651115],
            [-56.593214, -23.785021],
            [-56.577885, -23.834806],
            [-56.588091, -23.861836],
            [-56.564832, -23.886411],
            [-56.587128, -23.889181],
            [-56.616382, -23.906502],
            [-56.635419, -23.901318],
            [-56.661914, -23.906139],
            [-56.687107, -23.919551],
            [-56.705818, -23.935995],
            [-56.727832, -23.915677],
            [-56.743453, -23.885495],
            [-56.746344, -23.845554],
            [-56.737528, -23.820199],
            [-56.714672, -23.794122],
            [-56.67962, -23.794961],
            [-56.650258, -23.777794],
            [-56.636293, -23.777649],
            [-56.610633, -23.760358],
            [-56.60907, -23.745541],
            [-56.590174, -23.734539],
            [-56.575903, -23.739067],
            [-56.552555, -23.723792],
            [-56.556021, -23.698633],
            [-56.531221, -23.666498],
            [-56.510979, -23.631116],
            [-56.492886, -23.627736],
            [-56.46151, -23.61461],
            [-56.448349, -23.603409],
            [-56.421067, -23.592425],
            [-56.39737, -23.589224],
            [-56.377349, -23.580225],
            [-56.358484, -23.563533],
            [-56.333753, -23.565809],
            [-56.321518, -23.561159],
            [-56.309839, -23.543973],
            [-56.282016, -23.530416],
            [-56.265397, -23.528361],
            [-56.226352, -23.494395],
            [-56.147186, -23.492972],
            [-56.135212, -23.513132],
            [-56.143783, -23.533633],
            [-56.135744, -23.565286],
            [-56.110924, -23.592839],
            [-56.114045, -23.605876]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "NUEVA GERMANIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.556044, -24.355462],
            [-56.538021, -24.380056],
            [-56.531514, -24.398975],
            [-56.5397, -24.428109],
            [-56.540039, -24.462218],
            [-56.524735, -24.47153],
            [-56.526194, -24.531722],
            [-56.519679, -24.53185],
            [-56.519532, -24.567994],
            [-56.479833, -24.567934],
            [-56.479171, -24.589137],
            [-56.449813, -24.58601],
            [-56.309038, -24.583888],
            [-56.257301, -24.559862],
            [-56.224784, -24.578822],
            [-56.204196, -24.584102],
            [-56.20397, -24.606213],
            [-56.172393, -24.626732],
            [-56.149587, -24.654208],
            [-56.141926, -24.669973],
            [-56.136656, -24.713128],
            [-56.124245, -24.726878],
            [-56.125925, -24.738171],
            [-56.102449, -24.776296],
            [-56.131489, -24.825661],
            [-56.126998, -24.86196],
            [-56.141319, -24.866401],
            [-56.167925, -24.892289],
            [-56.176524, -24.894305],
            [-56.200056, -24.855683],
            [-56.215241, -24.838853],
            [-56.222655, -24.800904],
            [-56.254855, -24.766173],
            [-56.275064, -24.745758],
            [-56.302356, -24.735362],
            [-56.317287, -24.738429],
            [-56.418195, -24.745574],
            [-56.429037, -24.71053],
            [-56.439204, -24.707113],
            [-56.474817, -24.719728],
            [-56.498112, -24.748978],
            [-56.502607, -24.760219],
            [-56.523623, -24.775424],
            [-56.538868, -24.770441],
            [-56.552849, -24.744365],
            [-56.568268, -24.705683],
            [-56.562544, -24.678307],
            [-56.539387, -24.646881],
            [-56.553135, -24.632157],
            [-56.573363, -24.632804],
            [-56.629563, -24.653275],
            [-56.668654, -24.660227],
            [-56.685778, -24.675031],
            [-56.710401, -24.664757],
            [-56.704115, -24.643025],
            [-56.673851, -24.602119],
            [-56.629521, -24.586977],
            [-56.619724, -24.567309],
            [-56.602789, -24.561489],
            [-56.579515, -24.533328],
            [-56.640023, -24.511851],
            [-56.63338, -24.499778],
            [-56.611154, -24.437158],
            [-56.605925, -24.424104],
            [-56.607753, -24.376852],
            [-56.601091, -24.355732],
            [-56.5794, -24.346221],
            [-56.556044, -24.355462]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "SAN ESTANISLAO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.017797, -20.501686],
            [-58.01648, -20.52725],
            [-57.995245, -20.56349],
            [-58.007966, -20.591163],
            [-58.012243, -20.614403],
            [-57.999489, -20.629304],
            [-57.970133, -20.644661],
            [-57.988757, -20.688125],
            [-57.979325, -20.706239],
            [-57.951782, -20.701327],
            [-57.93182, -20.665085],
            [-57.914102, -20.670873],
            [-57.904663, -20.689125],
            [-57.870004, -20.725962],
            [-57.870406, -20.750213],
            [-57.926033, -20.743952],
            [-57.947466, -20.760235],
            [-57.961751, -20.795012],
            [-57.948271, -20.800993],
            [-57.909283, -20.788793],
            [-57.89309, -20.791098],
            [-57.860549, -20.822408],
            [-57.854663, -20.835083],
            [-57.860027, -20.852785],
            [-57.871323, -20.853687],
            [-57.927032, -20.89303],
            [-57.922905, -20.904391],
            [-57.898742, -20.902524],
            [-57.880341, -20.917394],
            [-57.872598, -20.942581],
            [-57.858079, -20.949866],
            [-57.842379, -20.94646],
            [-57.829594, -20.934016],
            [-57.818771, -20.948818],
            [-57.824884, -20.967252],
            [-57.817327, -20.9791],
            [-57.839583, -21.004155],
            [-57.844858, -21.015998],
            [-57.867549, -21.040833],
            [-57.867589, -21.062963],
            [-57.84793, -21.093964],
            [-57.8902, -21.095712],
            [-57.933242, -21.086437],
            [-57.958251, -21.064438],
            [-57.992264, -21.060663],
            [-58.029467, -21.081705],
            [-58.05364, -21.076303],
            [-58.071456, -21.077895],
            [-58.095846, -21.058689],
            [-58.162638, -21.061723],
            [-58.181801, -21.050153],
            [-58.250135, -21.051108],
            [-58.273831, -21.069223],
            [-58.282885, -21.084091],
            [-58.304509, -21.088124],
            [-58.306044, -21.074852],
            [-58.327329, -21.072752],
            [-58.342882, -21.087756],
            [-58.365232, -21.08648],
            [-58.395275, -21.094862],
            [-58.400095, -21.110545],
            [-58.45725, -21.085205],
            [-58.488875, -21.08405],
            [-58.514889, -21.110145],
            [-58.543726, -21.130444],
            [-58.575247, -21.102156],
            [-58.60715, -21.090389],
            [-58.668705, -21.099609],
            [-58.683409, -21.105845],
            [-58.722284, -21.107244],
            [-58.732217, -21.098731],
            [-58.746341, -21.118027],
            [-58.749867, -21.136161],
            [-58.773908, -21.129691],
            [-58.785145, -21.14029],
            [-58.840926, -21.161126],
            [-58.857097, -21.152625],
            [-58.893141, -21.17997],
            [-58.903008, -21.181478],
            [-58.909042, -21.200918],
            [-58.918907, -21.203291],
            [-58.927098, -21.222576],
            [-58.942191, -21.215301],
            [-58.941417, -21.202464],
            [-58.958011, -21.20132],
            [-58.974298, -21.217154],
            [-58.99455, -21.20335],
            [-59.017145, -21.205828],
            [-59.059567, -21.229461],
            [-59.07993, -21.223366],
            [-59.088932, -21.204272],
            [-59.100682, -21.1981],
            [-59.145212, -21.21326],
            [-59.186464, -21.202517],
            [-59.207845, -21.210373],
            [-59.23932, -21.213558],
            [-59.257972, -21.230688],
            [-59.2732, -21.227525],
            [-59.329275, -21.23514],
            [-59.359002, -21.24484],
            [-59.395038, -21.266848],
            [-59.424329, -21.271126],
            [-59.445631, -21.279108],
            [-59.458644, -21.299326],
            [-59.497302, -21.197883],
            [-59.714117, -21.200965],
            [-59.76635, -21.200573],
            [-59.75087, -21.182933],
            [-59.755849, -21.096831],
            [-59.768323, -21.037456],
            [-59.785691, -21.022105],
            [-59.814891, -20.976694],
            [-59.817786, -20.936654],
            [-59.839607, -20.903143],
            [-59.83831, -20.8807],
            [-59.863118, -20.820841],
            [-59.886896, -20.791957],
            [-59.886381, -20.711153],
            [-59.879513, -20.630417],
            [-59.759325, -20.397361],
            [-59.759282, -20.281663],
            [-59.578477, -20.281219],
            [-59.580264, -20.138252],
            [-59.439085, -20.136918],
            [-59.28514, -20.136834],
            [-59.278849, -20.130463],
            [-59.032319, -20.13244],
            [-58.89834, -20.132585],
            [-58.803087, -20.134299],
            [-58.468038, -20.285636],
            [-58.46407, -20.41442],
            [-58.464676, -20.467303],
            [-58.511416, -20.481214],
            [-58.48526, -20.522925],
            [-58.456596, -20.49493],
            [-58.408251, -20.485654],
            [-58.385209, -20.476407],
            [-58.377995, -20.458144],
            [-58.364667, -20.448933],
            [-58.332627, -20.451867],
            [-58.319745, -20.435186],
            [-58.28015, -20.421533],
            [-58.263462, -20.386075],
            [-58.253969, -20.391019],
            [-58.259613, -20.414555],
            [-58.241838, -20.425704],
            [-58.229828, -20.422814],
            [-58.19214, -20.438185],
            [-58.178805, -20.447424],
            [-58.167581, -20.434214],
            [-58.142766, -20.442699],
            [-58.127445, -20.435858],
            [-58.080161, -20.47437],
            [-58.08605, -20.48827],
            [-58.078011, -20.514823],
            [-58.057612, -20.51532],
            [-58.060702, -20.490236],
            [-58.051375, -20.47571],
            [-58.036347, -20.475191],
            [-58.017797, -20.501686]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARAGUAY",
        "dist_desc_": "FUERTE OLIMPO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.84793, -21.093964],
            [-57.846296, -21.098401],
            [-57.864222, -21.137799],
            [-57.84826, -21.197477],
            [-57.856582, -21.232997],
            [-57.92087, -21.278237],
            [-57.977002, -21.299952],
            [-58.037701, -21.306574],
            [-58.080803, -21.374623],
            [-58.117433, -21.350517],
            [-58.139638, -21.354894],
            [-58.149805, -21.363984],
            [-58.176211, -21.356729],
            [-58.190855, -21.369939],
            [-58.249007, -21.381015],
            [-58.260938, -21.367575],
            [-58.273599, -21.341862],
            [-58.308136, -21.350212],
            [-58.318586, -21.347205],
            [-58.350814, -21.352701],
            [-58.377341, -21.348026],
            [-58.389024, -21.338662],
            [-58.457284, -21.353022],
            [-58.468628, -21.347147],
            [-58.494432, -21.364954],
            [-58.494879, -21.385191],
            [-58.518245, -21.38501],
            [-58.561317, -21.39504],
            [-58.577906, -21.388982],
            [-58.583678, -21.400747],
            [-58.599784, -21.404998],
            [-58.638442, -21.399884],
            [-58.656693, -21.424839],
            [-58.681469, -21.432393],
            [-58.70121, -21.445851],
            [-58.699583, -21.465956],
            [-58.714492, -21.468606],
            [-58.72602, -21.481506],
            [-58.752276, -21.490483],
            [-58.76476, -21.508073],
            [-58.758101, -21.529707],
            [-58.756763, -21.574003],
            [-58.720178, -21.575226],
            [-58.720316, -21.690031],
            [-58.708733, -21.692442],
            [-58.708875, -21.807812],
            [-58.683801, -21.808069],
            [-58.668688, -21.876193],
            [-58.685874, -21.880587],
            [-58.675656, -21.948661],
            [-58.659237, -21.945152],
            [-58.563144, -21.807016],
            [-58.53523, -21.80796],
            [-58.384705, -21.80818],
            [-58.384894, -21.951137],
            [-58.334228, -21.949784],
            [-58.236575, -22.033363],
            [-58.176484, -22.020541],
            [-58.157444, -22.043259],
            [-58.104763, -22.043623],
            [-58.096951, -22.027904],
            [-58.063702, -22.029555],
            [-58.009501, -22.043386],
            [-57.983976, -22.065347],
            [-57.993034, -22.086919],
            [-57.990167, -22.104637],
            [-57.96292, -22.120721],
            [-57.956594, -22.13154],
            [-57.963191, -22.171429],
            [-57.972553, -22.194305],
            [-57.971349, -22.225712],
            [-57.960054, -22.236732],
            [-57.951789, -22.277079],
            [-57.927043, -22.27617],
            [-57.894087, -22.265573],
            [-57.884162, -22.279562],
            [-57.877296, -22.311988],
            [-57.877699, -22.329258],
            [-57.86698, -22.34306],
            [-57.821354, -22.373316],
            [-57.827431, -22.395544],
            [-57.845519, -22.399055],
            [-57.85573, -22.397713],
            [-58.185565, -22.349438],
            [-58.202731, -22.282506],
            [-58.245549, -22.240463],
            [-58.241671, -22.189903],
            [-58.26688, -22.179487],
            [-58.396747, -22.178969],
            [-58.452149, -22.163699],
            [-58.459693, -22.156769],
            [-58.737136, -22.152462],
            [-58.752591, -22.157357],
            [-58.845213, -22.156471],
            [-58.856872, -22.151179],
            [-58.962615, -22.150356],
            [-58.985425, -22.159613],
            [-59.018355, -22.150072],
            [-59.201595, -22.147866],
            [-59.241225, -22.132108],
            [-59.367744, -22.076224],
            [-59.412897, -22.05682],
            [-59.740028, -22.055499],
            [-59.860806, -22.054194],
            [-59.953068, -22.054504],
            [-59.951841, -21.98222],
            [-59.947422, -21.926573],
            [-59.932733, -21.834242],
            [-59.926285, -21.776837],
            [-59.904947, -21.646972],
            [-59.887532, -21.554004],
            [-59.872402, -21.447163],
            [-59.845566, -21.432452],
            [-59.769895, -21.383322],
            [-59.715013, -21.345861],
            [-59.76635, -21.200573],
            [-59.714117, -21.200965],
            [-59.497302, -21.197883],
            [-59.458644, -21.299326],
            [-59.445631, -21.279108],
            [-59.424329, -21.271126],
            [-59.395038, -21.266848],
            [-59.359002, -21.24484],
            [-59.329275, -21.23514],
            [-59.2732, -21.227525],
            [-59.257972, -21.230688],
            [-59.23932, -21.213558],
            [-59.207845, -21.210373],
            [-59.186464, -21.202517],
            [-59.145212, -21.21326],
            [-59.100682, -21.1981],
            [-59.088932, -21.204272],
            [-59.07993, -21.223366],
            [-59.059567, -21.229461],
            [-59.017145, -21.205828],
            [-58.99455, -21.20335],
            [-58.974298, -21.217154],
            [-58.958011, -21.20132],
            [-58.941417, -21.202464],
            [-58.942191, -21.215301],
            [-58.927098, -21.222576],
            [-58.918907, -21.203291],
            [-58.909042, -21.200918],
            [-58.903008, -21.181478],
            [-58.893141, -21.17997],
            [-58.857097, -21.152625],
            [-58.840926, -21.161126],
            [-58.785145, -21.14029],
            [-58.773908, -21.129691],
            [-58.749867, -21.136161],
            [-58.746341, -21.118027],
            [-58.732217, -21.098731],
            [-58.722284, -21.107244],
            [-58.683409, -21.105845],
            [-58.668705, -21.099609],
            [-58.60715, -21.090389],
            [-58.575247, -21.102156],
            [-58.543726, -21.130444],
            [-58.514889, -21.110145],
            [-58.488875, -21.08405],
            [-58.45725, -21.085205],
            [-58.400095, -21.110545],
            [-58.395275, -21.094862],
            [-58.365232, -21.08648],
            [-58.342882, -21.087756],
            [-58.327329, -21.072752],
            [-58.306044, -21.074852],
            [-58.304509, -21.088124],
            [-58.282885, -21.084091],
            [-58.273831, -21.069223],
            [-58.250135, -21.051108],
            [-58.181801, -21.050153],
            [-58.162638, -21.061723],
            [-58.095846, -21.058689],
            [-58.071456, -21.077895],
            [-58.05364, -21.076303],
            [-58.029467, -21.081705],
            [-57.992264, -21.060663],
            [-57.958251, -21.064438],
            [-57.933242, -21.086437],
            [-57.8902, -21.095712],
            [-57.84793, -21.093964]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARAGUAY",
        "dist_desc_": "PUERTO CASADO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.017797, -20.501686],
            [-58.036347, -20.475191],
            [-58.051375, -20.47571],
            [-58.060702, -20.490236],
            [-58.057612, -20.51532],
            [-58.078011, -20.514823],
            [-58.08605, -20.48827],
            [-58.080161, -20.47437],
            [-58.127445, -20.435858],
            [-58.142766, -20.442699],
            [-58.167581, -20.434214],
            [-58.178805, -20.447424],
            [-58.19214, -20.438185],
            [-58.229828, -20.422814],
            [-58.241838, -20.425704],
            [-58.259613, -20.414555],
            [-58.253969, -20.391019],
            [-58.263462, -20.386075],
            [-58.28015, -20.421533],
            [-58.319745, -20.435186],
            [-58.332627, -20.451867],
            [-58.364667, -20.448933],
            [-58.377995, -20.458144],
            [-58.385209, -20.476407],
            [-58.408251, -20.485654],
            [-58.456596, -20.49493],
            [-58.48526, -20.522925],
            [-58.511416, -20.481214],
            [-58.464676, -20.467303],
            [-58.46407, -20.41442],
            [-58.468038, -20.285636],
            [-58.803087, -20.134299],
            [-58.89834, -20.132585],
            [-59.032319, -20.13244],
            [-59.278849, -20.130463],
            [-59.28514, -20.136834],
            [-59.439085, -20.136918],
            [-59.580264, -20.138252],
            [-59.578477, -20.281219],
            [-59.759282, -20.281663],
            [-59.759325, -20.397361],
            [-59.879513, -20.630417],
            [-59.9273, -20.632887],
            [-60.111019, -20.58095],
            [-60.535834, -20.456691],
            [-60.90463, -20.355282],
            [-61.490832, -20.192296],
            [-61.51439, -20.182631],
            [-61.54988, -20.174715],
            [-61.620052, -20.170064],
            [-61.645544, -20.153219],
            [-61.660203, -20.135611],
            [-61.698262, -20.104244],
            [-61.71859, -20.096644],
            [-61.737006, -20.098228],
            [-61.768661, -20.109639],
            [-61.922536, -20.089211],
            [-61.735211, -19.634406],
            [-60.604325, -19.456639],
            [-60.124039, -19.332723],
            [-59.977778, -19.294686],
            [-59.068928, -19.287647],
            [-58.266901, -19.757015],
            [-58.235967, -19.774997],
            [-58.164069, -19.827083],
            [-58.179379, -19.845808],
            [-58.202076, -19.863508],
            [-58.206051, -19.883391],
            [-58.196587, -19.925901],
            [-58.213174, -19.954717],
            [-58.186537, -19.970363],
            [-58.177427, -20.001428],
            [-58.175893, -20.029958],
            [-58.158098, -20.042822],
            [-58.168289, -20.050645],
            [-58.165339, -20.06645],
            [-58.143971, -20.102744],
            [-58.138544, -20.122988],
            [-58.1514, -20.152522],
            [-58.169035, -20.166578],
            [-58.159045, -20.181847],
            [-58.126777, -20.185952],
            [-58.122928, -20.199562],
            [-58.154622, -20.215632],
            [-58.16512, -20.229932],
            [-58.161301, -20.260309],
            [-58.141276, -20.271842],
            [-58.128193, -20.254811],
            [-58.100802, -20.251193],
            [-58.089776, -20.27024],
            [-58.101566, -20.32798],
            [-58.088897, -20.362619],
            [-58.073418, -20.387793],
            [-58.02172, -20.402377],
            [-58.000726, -20.431956],
            [-57.998009, -20.454624],
            [-58.012992, -20.478508],
            [-58.017797, -20.501686]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARAGUAY",
        "dist_desc_": "BAHÍA NEGRA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.522341, -25.95255],
            [-57.518125, -25.987615],
            [-57.497653, -25.977524],
            [-57.499619, -26.025117],
            [-57.484906, -26.044499],
            [-57.488729, -26.059954],
            [-57.468136, -26.11337],
            [-57.480641, -26.113197],
            [-57.472422, -26.138434],
            [-57.482368, -26.156885],
            [-57.520244, -26.168071],
            [-57.531195, -26.179282],
            [-57.55174, -26.177528],
            [-57.579656, -26.185393],
            [-57.596607, -26.215748],
            [-57.610527, -26.219735],
            [-57.619689, -26.238104],
            [-57.644011, -26.232062],
            [-57.65532, -26.213244],
            [-57.69399, -26.194639],
            [-57.718487, -26.238242],
            [-57.813382, -26.190176],
            [-57.814365, -26.18036],
            [-57.898341, -26.144625],
            [-57.917792, -26.164244],
            [-57.940837, -26.176876],
            [-57.958352, -26.164111],
            [-57.974689, -26.188289],
            [-58.000321, -26.176082],
            [-58.022942, -26.159287],
            [-58.035254, -26.162517],
            [-58.094209, -26.125613],
            [-58.089509, -26.115076],
            [-58.064138, -26.107652],
            [-58.050035, -26.111725],
            [-58.017052, -26.103863],
            [-57.947926, -26.065879],
            [-57.923533, -26.035515],
            [-57.888785, -26.017303],
            [-57.860397, -26.009329],
            [-57.852375, -25.991235],
            [-57.893095, -25.962323],
            [-57.887641, -25.940176],
            [-57.871751, -25.928411],
            [-57.84951, -25.923037],
            [-57.84037, -25.910654],
            [-57.84502, -25.89635],
            [-57.861075, -25.886231],
            [-57.8646, -25.86716],
            [-57.854749, -25.85437],
            [-57.816215, -25.845927],
            [-57.808329, -25.839976],
            [-57.789693, -25.83384],
            [-57.791435, -25.809386],
            [-57.751574, -25.797269],
            [-57.727558, -25.844566],
            [-57.712155, -25.850379],
            [-57.689625, -25.849549],
            [-57.687826, -25.858457],
            [-57.657292, -25.865031],
            [-57.637735, -25.858457],
            [-57.630568, -25.874267],
            [-57.603685, -25.882995],
            [-57.60363, -25.898778],
            [-57.586606, -25.894925],
            [-57.576725, -25.912167],
            [-57.557591, -25.924531],
            [-57.54179, -25.948243],
            [-57.522341, -25.95255]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "VILLA OLIVA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.571855, -25.384836],
            [-57.572362, -25.392606],
            [-57.597797, -25.40176],
            [-57.613791, -25.389412],
            [-57.586135, -25.341443],
            [-57.584936, -25.339359],
            [-57.570284, -25.355547],
            [-57.566758, -25.360922],
            [-57.571855, -25.384836]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "VILLA ELISA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.423722, -25.477461],
            [-57.430652, -25.525583],
            [-57.420451, -25.534996],
            [-57.427085, -25.563228],
            [-57.414358, -25.598478],
            [-57.444327, -25.591475],
            [-57.472514, -25.573658],
            [-57.497974, -25.563762],
            [-57.508176, -25.592118],
            [-57.516199, -25.693954],
            [-57.523288, -25.754698],
            [-57.527504, -25.816591],
            [-57.521516, -25.840866],
            [-57.522341, -25.95255],
            [-57.54179, -25.948243],
            [-57.557591, -25.924531],
            [-57.576725, -25.912167],
            [-57.586606, -25.894925],
            [-57.60363, -25.898778],
            [-57.603685, -25.882995],
            [-57.630568, -25.874267],
            [-57.637735, -25.858457],
            [-57.657292, -25.865031],
            [-57.687826, -25.858457],
            [-57.689625, -25.849549],
            [-57.712155, -25.850379],
            [-57.727558, -25.844566],
            [-57.751574, -25.797269],
            [-57.791435, -25.809386],
            [-57.789693, -25.83384],
            [-57.808329, -25.839976],
            [-57.796167, -25.814743],
            [-57.818054, -25.783379],
            [-57.826122, -25.756845],
            [-57.808966, -25.7523],
            [-57.779394, -25.760272],
            [-57.733799, -25.724738],
            [-57.731071, -25.707884],
            [-57.759689, -25.708533],
            [-57.76711, -25.696606],
            [-57.750398, -25.66149],
            [-57.729942, -25.645629],
            [-57.716088, -25.647057],
            [-57.692063, -25.660587],
            [-57.670662, -25.652989],
            [-57.677128, -25.603606],
            [-57.657242, -25.597132],
            [-57.629633, -25.61706],
            [-57.608597, -25.605266],
            [-57.603037, -25.567137],
            [-57.576943, -25.565093],
            [-57.569965, -25.541064],
            [-57.579162, -25.507522],
            [-57.567442, -25.482093],
            [-57.527801, -25.482779],
            [-57.512643, -25.488819],
            [-57.488436, -25.489668],
            [-57.478472, -25.497673],
            [-57.485321, -25.507605],
            [-57.448895, -25.527388],
            [-57.434843, -25.507176],
            [-57.423722, -25.477461]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "VILLETA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.212768, -25.355857],
            [-57.200046, -25.360514],
            [-57.195022, -25.401783],
            [-57.21791, -25.40268],
            [-57.22301, -25.418625],
            [-57.247476, -25.433456],
            [-57.299755, -25.448728],
            [-57.300079, -25.417648],
            [-57.315888, -25.405342],
            [-57.311299, -25.388758],
            [-57.331391, -25.371976],
            [-57.307335, -25.338426],
            [-57.296262, -25.353491],
            [-57.268985, -25.363683],
            [-57.249129, -25.36001],
            [-57.233732, -25.366863],
            [-57.212768, -25.355857]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "YPACARAÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.465184, -25.439108],
            [-57.462644, -25.456363],
            [-57.475878, -25.479378],
            [-57.478472, -25.497673],
            [-57.488436, -25.489668],
            [-57.512643, -25.488819],
            [-57.527801, -25.482779],
            [-57.567442, -25.482093],
            [-57.560908, -25.471707],
            [-57.559407, -25.44375],
            [-57.544613, -25.455432],
            [-57.534474, -25.443702],
            [-57.510766, -25.423578],
            [-57.465184, -25.439108]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "YPANÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.399156, -25.418292],
            [-57.401445, -25.444545],
            [-57.428463, -25.459173],
            [-57.462644, -25.456363],
            [-57.465184, -25.439108],
            [-57.447271, -25.396183],
            [-57.423662, -25.403567],
            [-57.427113, -25.412394],
            [-57.399156, -25.418292]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "J. AUGUSTO SALDIVAR"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.009561, -27.018194],
            [-58.011342, -27.035812],
            [-58.040313, -27.030094],
            [-58.083213, -27.026425],
            [-58.105601, -27.019521],
            [-58.151102, -27.002445],
            [-58.157452, -26.981445],
            [-58.176731, -26.981479],
            [-58.188191, -26.938877],
            [-58.197001, -26.924869],
            [-58.217385, -26.912534],
            [-58.22283, -26.899752],
            [-58.239261, -26.896946],
            [-58.255319, -26.908945],
            [-58.385315, -26.892457],
            [-58.379207, -26.870719],
            [-58.366563, -26.863139],
            [-58.344344, -26.870705],
            [-58.319801, -26.864357],
            [-58.32191, -26.847697],
            [-58.354452, -26.828462],
            [-58.357661, -26.816158],
            [-58.346754, -26.80486],
            [-58.30638, -26.807981],
            [-58.281103, -26.792719],
            [-58.262626, -26.791241],
            [-58.231969, -26.810166],
            [-58.231847, -26.821529],
            [-58.212986, -26.834524],
            [-58.196646, -26.856715],
            [-58.150764, -26.935858],
            [-58.068285, -26.989042],
            [-58.060155, -26.987696],
            [-58.009561, -27.018194]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "PILAR"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.011342, -27.035812],
            [-57.987119, -27.054777],
            [-58.001939, -27.132182],
            [-58.030706, -27.133068],
            [-58.064378, -27.126587],
            [-58.109592, -27.137877],
            [-58.125526, -27.150805],
            [-58.161869, -27.150612],
            [-58.158843, -27.134971],
            [-58.202099, -27.143016],
            [-58.22402, -27.132581],
            [-58.282411, -27.129864],
            [-58.255656, -27.055887],
            [-58.203843, -27.060879],
            [-58.146167, -27.041413],
            [-58.105601, -27.019521],
            [-58.083213, -27.026425],
            [-58.040313, -27.030094],
            [-58.011342, -27.035812]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "DESMOCHADOS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.610891, -27.099167],
            [-57.627753, -27.097526],
            [-57.894506, -27.05811],
            [-57.918368, -27.048364],
            [-57.972466, -27.034233],
            [-58.009561, -27.018194],
            [-58.060155, -26.987696],
            [-58.068285, -26.989042],
            [-58.150764, -26.935858],
            [-58.196646, -26.856715],
            [-58.212986, -26.834524],
            [-58.231847, -26.821529],
            [-58.231969, -26.810166],
            [-58.262626, -26.791241],
            [-58.281103, -26.792719],
            [-58.293121, -26.774175],
            [-58.294182, -26.759911],
            [-58.281409, -26.75577],
            [-58.254377, -26.759152],
            [-58.246119, -26.742258],
            [-58.205547, -26.751615],
            [-58.197844, -26.757494],
            [-58.1133, -26.758395],
            [-58.037758, -26.827581],
            [-58.009935, -26.823327],
            [-57.986543, -26.841643],
            [-57.971279, -26.8441],
            [-57.944176, -26.857302],
            [-57.932042, -26.878314],
            [-57.899584, -26.922532],
            [-57.879003, -26.943882],
            [-57.853944, -26.939897],
            [-57.810651, -26.925748],
            [-57.798971, -26.933696],
            [-57.788084, -26.953086],
            [-57.788765, -27.002259],
            [-57.727807, -27.023058],
            [-57.65347, -27.065323],
            [-57.610891, -27.099167]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "GUAZÚ-CUÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.001939, -27.132182],
            [-58.010584, -27.164573],
            [-58.01101, -27.202519],
            [-58.017551, -27.2395],
            [-57.995984, -27.266778],
            [-58.025843, -27.258094],
            [-58.073729, -27.261327],
            [-58.092911, -27.273429],
            [-58.1722, -27.277113],
            [-58.225959, -27.266857],
            [-58.249105, -27.256239],
            [-58.266092, -27.256066],
            [-58.276301, -27.265032],
            [-58.281147, -27.18518],
            [-58.285652, -27.171102],
            [-58.282411, -27.129864],
            [-58.22402, -27.132581],
            [-58.202099, -27.143016],
            [-58.158843, -27.134971],
            [-58.161869, -27.150612],
            [-58.125526, -27.150805],
            [-58.109592, -27.137877],
            [-58.064378, -27.126587],
            [-58.030706, -27.133068],
            [-58.001939, -27.132182]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "MAYOR JOSÉ DEJESÚS MARTÍNEZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.655748, -22.605428],
            [-55.713496, -22.652766],
            [-55.735198, -22.629942],
            [-55.74203, -22.646182],
            [-55.767949, -22.653537],
            [-55.774816, -22.668461],
            [-55.787688, -22.676846],
            [-55.799163, -22.696525],
            [-55.807065, -22.7269],
            [-55.828835, -22.73016],
            [-55.843801, -22.739738],
            [-55.857736, -22.762671],
            [-55.854307, -22.773904],
            [-55.814271, -22.783614],
            [-55.815244, -22.800137],
            [-55.793548, -22.810782],
            [-55.767544, -22.811599],
            [-55.748374, -22.832923],
            [-55.752178, -22.852128],
            [-55.764974, -22.871308],
            [-55.768669, -22.88876],
            [-55.759323, -22.899666],
            [-55.719885, -22.908827],
            [-55.688412, -22.92257],
            [-55.661185, -22.964045],
            [-55.673023, -22.988261],
            [-55.676108, -23.006139],
            [-55.699566, -23.018558],
            [-55.719052, -23.038699],
            [-55.759494, -23.050628],
            [-55.762562, -23.060092],
            [-55.797459, -23.084127],
            [-55.824688, -23.123997],
            [-55.824764, -23.147425],
            [-55.851559, -23.15936],
            [-55.869904, -23.186606],
            [-55.905348, -23.228347],
            [-55.934464, -23.248649],
            [-55.955678, -23.242918],
            [-55.983586, -23.25373],
            [-55.989549, -23.268556],
            [-56.027267, -23.277745],
            [-56.033606, -23.288843],
            [-56.0666, -23.313129],
            [-56.090216, -23.320659],
            [-56.106598, -23.334907],
            [-56.136607, -23.312903],
            [-56.162519, -23.322706],
            [-56.174569, -23.301681],
            [-56.192149, -23.302885],
            [-56.221815, -23.317796],
            [-56.238682, -23.313947],
            [-56.250228, -23.321923],
            [-56.293294, -23.329823],
            [-56.314223, -23.345397],
            [-56.311854, -23.327085],
            [-56.290891, -23.320068],
            [-56.298978, -23.295757],
            [-56.285994, -23.287519],
            [-56.286595, -23.273099],
            [-56.27346, -23.27146],
            [-56.262449, -23.24637],
            [-56.223724, -23.230937],
            [-56.202929, -23.227301],
            [-56.204974, -23.207105],
            [-56.21759, -23.185992],
            [-56.203066, -23.173662],
            [-56.203973, -23.163658],
            [-56.183326, -23.161046],
            [-56.188172, -23.12919],
            [-56.178838, -23.118217],
            [-56.163978, -23.124294],
            [-56.144168, -23.123154],
            [-56.139751, -23.111248],
            [-56.151362, -23.09974],
            [-56.12905, -23.075018],
            [-56.132473, -23.040365],
            [-56.20878, -22.874392],
            [-56.294387, -22.687641],
            [-56.281537, -22.667837],
            [-56.269788, -22.668547],
            [-56.263436, -22.641386],
            [-56.249838, -22.623103],
            [-56.225342, -22.575788],
            [-56.202635, -22.579687],
            [-56.193952, -22.555584],
            [-56.198505, -22.548023],
            [-56.160511, -22.511899],
            [-56.144458, -22.514674],
            [-56.107423, -22.488719],
            [-56.081032, -22.481543],
            [-56.071647, -22.465406],
            [-56.093143, -22.402298],
            [-56.086331, -22.350758],
            [-56.098956, -22.31941],
            [-56.133661, -22.294622],
            [-56.1395, -22.285731],
            [-56.123606, -22.271591],
            [-56.068608, -22.286122],
            [-56.059845, -22.276198],
            [-56.006564, -22.292561],
            [-55.980954, -22.278604],
            [-55.969265, -22.292021],
            [-55.929037, -22.278505],
            [-55.888937, -22.282788],
            [-55.851187, -22.281823],
            [-55.843135, -22.287096],
            [-55.8324, -22.325656],
            [-55.821007, -22.345148],
            [-55.800853, -22.355343],
            [-55.803711, -22.372303],
            [-55.779819, -22.384371],
            [-55.748685, -22.383451],
            [-55.737219, -22.41122],
            [-55.733909, -22.441544],
            [-55.751078, -22.474732],
            [-55.747266, -22.505485],
            [-55.723604, -22.551771],
            [-55.698421, -22.563258],
            [-55.694779, -22.57754],
            [-55.655748, -22.605428]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "AMAMBAY",
        "dist_desc_": "PEDRO JUAN CABALLERO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.1395, -22.285731],
            [-56.133661, -22.294622],
            [-56.098956, -22.31941],
            [-56.086331, -22.350758],
            [-56.093143, -22.402298],
            [-56.071647, -22.465406],
            [-56.081032, -22.481543],
            [-56.107423, -22.488719],
            [-56.144458, -22.514674],
            [-56.160511, -22.511899],
            [-56.198505, -22.548023],
            [-56.193952, -22.555584],
            [-56.202635, -22.579687],
            [-56.225342, -22.575788],
            [-56.249838, -22.623103],
            [-56.263436, -22.641386],
            [-56.269788, -22.668547],
            [-56.281537, -22.667837],
            [-56.294387, -22.687641],
            [-56.30828, -22.692805],
            [-56.328049, -22.687636],
            [-56.35782, -22.710184],
            [-56.36413, -22.720169],
            [-56.38442, -22.713256],
            [-56.39249, -22.722465],
            [-56.391341, -22.739502],
            [-56.413066, -22.744556],
            [-56.417486, -22.759744],
            [-56.442059, -22.772239],
            [-56.455246, -22.768328],
            [-56.494067, -22.776301],
            [-56.509667, -22.787253],
            [-56.508678, -22.802377],
            [-56.526012, -22.809764],
            [-56.521924, -22.841396],
            [-56.543662, -22.861049],
            [-56.538011, -22.876611],
            [-56.568775, -22.901485],
            [-56.596767, -22.913451],
            [-56.61488, -22.909133],
            [-56.625794, -22.892862],
            [-56.66528, -22.88403],
            [-56.667314, -22.893474],
            [-56.708694, -22.905949],
            [-56.713041, -22.897017],
            [-56.704913, -22.868155],
            [-56.714482, -22.849658],
            [-56.686957, -22.841142],
            [-56.653458, -22.815906],
            [-56.649583, -22.800865],
            [-56.66093, -22.794178],
            [-56.662268, -22.772017],
            [-56.669689, -22.765853],
            [-56.666954, -22.742396],
            [-56.672317, -22.711783],
            [-56.696299, -22.708651],
            [-56.694564, -22.68871],
            [-56.694325, -22.682097],
            [-56.722316, -22.654157],
            [-56.718255, -22.609541],
            [-56.726906, -22.593223],
            [-56.726167, -22.577304],
            [-56.738518, -22.543249],
            [-56.734788, -22.524551],
            [-56.722629, -22.509426],
            [-56.716417, -22.458229],
            [-56.699045, -22.440523],
            [-56.648658, -22.42215],
            [-56.64365, -22.382773],
            [-56.609426, -22.365286],
            [-56.826067, -22.295926],
            [-56.802827, -22.283502],
            [-56.804151, -22.25197],
            [-56.784854, -22.257371],
            [-56.76238, -22.249597],
            [-56.748534, -22.236368],
            [-56.726844, -22.259994],
            [-56.709286, -22.247514],
            [-56.701217, -22.226644],
            [-56.683163, -22.234921],
            [-56.673206, -22.249108],
            [-56.637922, -22.257787],
            [-56.64338, -22.245549],
            [-56.605994, -22.23165],
            [-56.58219, -22.205287],
            [-56.570459, -22.207479],
            [-56.556378, -22.195304],
            [-56.556725, -22.168925],
            [-56.533024, -22.158646],
            [-56.522988, -22.137545],
            [-56.518973, -22.10847],
            [-56.497126, -22.094211],
            [-56.479817, -22.093841],
            [-56.47156, -22.080222],
            [-56.432378, -22.085859],
            [-56.402658, -22.079741],
            [-56.390008, -22.086082],
            [-56.3925, -22.100948],
            [-56.37828, -22.11534],
            [-56.367814, -22.136868],
            [-56.373845, -22.149937],
            [-56.363578, -22.170539],
            [-56.34963, -22.173588],
            [-56.317905, -22.214634],
            [-56.29931, -22.217803],
            [-56.284928, -22.23172],
            [-56.262683, -22.239471],
            [-56.238337, -22.236459],
            [-56.234522, -22.255814],
            [-56.210235, -22.277799],
            [-56.193848, -22.271246],
            [-56.174656, -22.285549],
            [-56.150816, -22.281781],
            [-56.1395, -22.285731]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "AMAMBAY",
        "dist_desc_": "BELLA VISTA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.636647, -23.018262],
            [-55.613918, -23.041077],
            [-55.610969, -23.077018],
            [-55.617027, -23.08173],
            [-55.599783, -23.104176],
            [-55.595833, -23.119457],
            [-55.596811, -23.152603],
            [-55.573477, -23.143295],
            [-55.541903, -23.15612],
            [-55.543098, -23.180811],
            [-55.523292, -23.197788],
            [-55.54032, -23.220929],
            [-55.537306, -23.251264],
            [-55.522676, -23.259717],
            [-55.553183, -23.279475],
            [-55.549275, -23.303647],
            [-55.556013, -23.316298],
            [-55.534643, -23.333314],
            [-55.520707, -23.352235],
            [-55.519498, -23.365119],
            [-55.504478, -23.378475],
            [-55.515641, -23.409535],
            [-55.544794, -23.449316],
            [-55.540578, -23.455517],
            [-55.551784, -23.489397],
            [-55.543421, -23.523665],
            [-55.544369, -23.539317],
            [-55.571773, -23.579081],
            [-55.586656, -23.637399],
            [-55.600351, -23.652925],
            [-55.630333, -23.656923],
            [-55.641461, -23.668499],
            [-55.662524, -23.675578],
            [-55.707476, -23.660665],
            [-55.753374, -23.691553],
            [-55.769927, -23.736119],
            [-55.800041, -23.751397],
            [-55.839276, -23.763523],
            [-55.857309, -23.784195],
            [-55.859315, -23.799012],
            [-55.886037, -23.807051],
            [-55.899763, -23.821139],
            [-55.917527, -23.817657],
            [-55.930942, -23.830927],
            [-55.951692, -23.812831],
            [-55.991649, -23.82771],
            [-56.027214, -23.822321],
            [-56.02729, -23.822219],
            [-56.020672, -23.800269],
            [-55.985046, -23.779069],
            [-55.97552, -23.744603],
            [-55.980663, -23.667947],
            [-55.953791, -23.65475],
            [-55.952101, -23.642751],
            [-55.93194, -23.621285],
            [-55.92952, -23.599941],
            [-55.932788, -23.575685],
            [-55.930221, -23.547909],
            [-55.921335, -23.539403],
            [-55.903889, -23.499117],
            [-55.916926, -23.475576],
            [-55.895537, -23.41858],
            [-55.89919, -23.392179],
            [-56.030524, -23.38142],
            [-56.038695, -23.391636],
            [-56.054136, -23.381894],
            [-56.069079, -23.347449],
            [-56.0666, -23.313129],
            [-56.033606, -23.288843],
            [-56.027267, -23.277745],
            [-55.989549, -23.268556],
            [-55.983586, -23.25373],
            [-55.955678, -23.242918],
            [-55.934464, -23.248649],
            [-55.905348, -23.228347],
            [-55.869904, -23.186606],
            [-55.851559, -23.15936],
            [-55.824764, -23.147425],
            [-55.824688, -23.123997],
            [-55.797459, -23.084127],
            [-55.762562, -23.060092],
            [-55.759494, -23.050628],
            [-55.719052, -23.038699],
            [-55.699566, -23.018558],
            [-55.676108, -23.006139],
            [-55.662847, -23.002062],
            [-55.636647, -23.018262]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "AMAMBAY",
        "dist_desc_": "CAPITÁN BADO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.636647, -23.018262],
            [-55.662847, -23.002062],
            [-55.676108, -23.006139],
            [-55.673023, -22.988261],
            [-55.661185, -22.964045],
            [-55.688412, -22.92257],
            [-55.719885, -22.908827],
            [-55.759323, -22.899666],
            [-55.768669, -22.88876],
            [-55.764974, -22.871308],
            [-55.752178, -22.852128],
            [-55.748374, -22.832923],
            [-55.767544, -22.811599],
            [-55.793548, -22.810782],
            [-55.815244, -22.800137],
            [-55.814271, -22.783614],
            [-55.854307, -22.773904],
            [-55.857736, -22.762671],
            [-55.843801, -22.739738],
            [-55.828835, -22.73016],
            [-55.807065, -22.7269],
            [-55.799163, -22.696525],
            [-55.787688, -22.676846],
            [-55.774816, -22.668461],
            [-55.767949, -22.653537],
            [-55.74203, -22.646182],
            [-55.735198, -22.629942],
            [-55.713496, -22.652766],
            [-55.655748, -22.605428],
            [-55.625163, -22.628248],
            [-55.622873, -22.650469],
            [-55.614424, -22.655087],
            [-55.617308, -22.677623],
            [-55.61342, -22.717043],
            [-55.620181, -22.753352],
            [-55.63657, -22.778869],
            [-55.650426, -22.791042],
            [-55.65338, -22.816641],
            [-55.660875, -22.827413],
            [-55.665857, -22.852473],
            [-55.661224, -22.882224],
            [-55.650979, -22.887307],
            [-55.645516, -22.924494],
            [-55.651648, -22.931081],
            [-55.638408, -22.950596],
            [-55.636836, -22.964769],
            [-55.621977, -22.984552],
            [-55.633931, -22.991824],
            [-55.636647, -23.018262]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "AMAMBAY",
        "dist_desc_": "ZANJA PYTÃ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.0666, -23.313129],
            [-56.069079, -23.347449],
            [-56.054136, -23.381894],
            [-56.038695, -23.391636],
            [-56.030524, -23.38142],
            [-55.89919, -23.392179],
            [-55.895537, -23.41858],
            [-55.916926, -23.475576],
            [-55.903889, -23.499117],
            [-55.921335, -23.539403],
            [-55.930221, -23.547909],
            [-55.932788, -23.575685],
            [-55.92952, -23.599941],
            [-55.93194, -23.621285],
            [-55.952101, -23.642751],
            [-55.953791, -23.65475],
            [-55.980663, -23.667947],
            [-56.000919, -23.623406],
            [-56.021576, -23.599062],
            [-56.047371, -23.587458],
            [-56.069867, -23.607776],
            [-56.09405, -23.602035],
            [-56.114045, -23.605876],
            [-56.110924, -23.592839],
            [-56.135744, -23.565286],
            [-56.143783, -23.533633],
            [-56.135212, -23.513132],
            [-56.147186, -23.492972],
            [-56.165695, -23.471384],
            [-56.166538, -23.451861],
            [-56.154287, -23.423068],
            [-56.15573, -23.390808],
            [-56.164556, -23.352693],
            [-56.162519, -23.322706],
            [-56.136607, -23.312903],
            [-56.106598, -23.334907],
            [-56.090216, -23.320659],
            [-56.0666, -23.313129]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "AMAMBAY",
        "dist_desc_": "KARAPAÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.309458, -24.439749],
            [-54.322073, -24.411449],
            [-54.340951, -24.396511],
            [-54.339665, -24.383397],
            [-54.377209, -24.390649],
            [-54.375194, -24.381066],
            [-54.39264, -24.366014],
            [-54.412638, -24.37657],
            [-54.41822, -24.364543],
            [-54.412957, -24.342413],
            [-54.430938, -24.327871],
            [-54.445345, -24.324269],
            [-54.447445, -24.307959],
            [-54.447622, -24.307897],
            [-54.421087, -24.27725],
            [-54.421572, -24.245396],
            [-54.41281, -24.233663],
            [-54.42686, -24.217072],
            [-54.458165, -24.211783],
            [-54.542937, -24.147094],
            [-54.530147, -24.133402],
            [-54.541234, -24.118723],
            [-54.542864, -24.0931],
            [-54.608105, -24.042657],
            [-54.606048, -24.019601],
            [-54.612294, -24.008076],
            [-54.606441, -23.976371],
            [-54.643093, -23.965104],
            [-54.69093, -23.974471],
            [-54.715328, -23.964369],
            [-54.719125, -23.936571],
            [-54.738671, -23.866629],
            [-54.705236, -23.864651],
            [-54.698701, -23.842004],
            [-54.668717, -23.817248],
            [-54.652679, -23.821618],
            [-54.646452, -23.833809],
            [-54.616615, -23.835086],
            [-54.609754, -23.851449],
            [-54.581539, -23.845868],
            [-54.564449, -23.854265],
            [-54.568596, -23.874523],
            [-54.543744, -23.868393],
            [-54.523234, -23.873628],
            [-54.51492, -23.885223],
            [-54.492972, -23.885177],
            [-54.486755, -23.894093],
            [-54.439934, -23.904416],
            [-54.426197, -23.915697],
            [-54.426776, -23.931134],
            [-54.414785, -23.95814],
            [-54.394113, -23.965234],
            [-54.383597, -23.986776],
            [-54.351636, -24.007797],
            [-54.315988, -24.004069],
            [-54.287655, -24.032434],
            [-54.292486, -24.052294],
            [-54.280185, -24.067297],
            [-54.319159, -24.106709],
            [-54.33523, -24.1144],
            [-54.346117, -24.152534],
            [-54.327904, -24.197497],
            [-54.330428, -24.229978],
            [-54.315428, -24.258266],
            [-54.291094, -24.277135],
            [-54.273946, -24.304053],
            [-54.259745, -24.346291],
            [-54.259648, -24.365662],
            [-54.283898, -24.411747],
            [-54.309458, -24.439749]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "SALTO DEL GUAIRÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.82326, -23.889803],
            [-54.820723, -24.045085],
            [-54.818272, -24.061086],
            [-54.815856, -24.17864],
            [-54.820884, -24.188724],
            [-54.81999, -24.259339],
            [-54.824359, -24.260102],
            [-54.822493, -24.318451],
            [-54.845916, -24.303055],
            [-54.872774, -24.333451],
            [-54.879522, -24.347945],
            [-54.893184, -24.354703],
            [-54.912043, -24.341612],
            [-54.921589, -24.347711],
            [-54.941163, -24.327556],
            [-54.983614, -24.299751],
            [-54.98287, -24.286578],
            [-54.996289, -24.272978],
            [-54.994632, -24.247257],
            [-55.004534, -24.176542],
            [-55.032483, -24.165358],
            [-55.038671, -24.144622],
            [-55.051543, -24.137316],
            [-55.076625, -24.134979],
            [-55.084661, -24.14],
            [-55.120535, -24.136099],
            [-55.127058, -24.120383],
            [-55.144614, -24.112129],
            [-55.160378, -24.137049],
            [-55.17744, -24.143133],
            [-55.175846, -24.157831],
            [-55.214436, -24.129643],
            [-55.228132, -24.139197],
            [-55.238958, -24.131779],
            [-55.268066, -24.135222],
            [-55.307545, -24.13134],
            [-55.315047, -24.136227],
            [-55.314604, -24.113792],
            [-55.324553, -24.087666],
            [-55.299419, -24.085633],
            [-55.221515, -24.060111],
            [-55.231217, -24.052751],
            [-55.23807, -24.022793],
            [-55.228737, -24.013829],
            [-55.206878, -24.003624],
            [-55.19842, -23.986693],
            [-55.178746, -23.993818],
            [-55.128834, -23.983765],
            [-55.107055, -23.965292],
            [-55.090453, -23.982641],
            [-55.062445, -23.993344],
            [-55.033386, -23.973959],
            [-55.020205, -23.972684],
            [-54.998684, -23.957639],
            [-54.976526, -23.957757],
            [-54.966773, -23.966209],
            [-54.925358, -23.960353],
            [-54.930422, -23.944391],
            [-54.926968, -23.92486],
            [-54.908764, -23.91143],
            [-54.860207, -23.905276],
            [-54.836371, -23.884021],
            [-54.82326, -23.889803]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "CORPUS CHRISTI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.844013, -24.066661],
            [-55.823974, -24.083541],
            [-55.809844, -24.083223],
            [-55.765327, -24.100731],
            [-55.744213, -24.103265],
            [-55.741071, -24.113799],
            [-55.723134, -24.118938],
            [-55.717579, -24.140817],
            [-55.705469, -24.163057],
            [-55.685817, -24.18419],
            [-55.687557, -24.209253],
            [-55.67833, -24.219331],
            [-55.67743, -24.239028],
            [-55.652096, -24.239042],
            [-55.628604, -24.245174],
            [-55.622946, -24.266007],
            [-55.60703, -24.269456],
            [-55.598261, -24.291966],
            [-55.577658, -24.308111],
            [-55.566208, -24.329924],
            [-55.548877, -24.334342],
            [-55.521774, -24.363034],
            [-55.509314, -24.360833],
            [-55.494082, -24.390931],
            [-55.526808, -24.42087],
            [-55.508001, -24.424528],
            [-55.489375, -24.43978],
            [-55.464874, -24.435384],
            [-55.447143, -24.426769],
            [-55.422858, -24.432721],
            [-55.394941, -24.427646],
            [-55.363972, -24.436407],
            [-55.322082, -24.433312],
            [-55.333374, -24.460944],
            [-55.322406, -24.478439],
            [-55.310341, -24.511868],
            [-55.32944, -24.506011],
            [-55.345172, -24.509034],
            [-55.369768, -24.539964],
            [-55.392659, -24.544614],
            [-55.400627, -24.536478],
            [-55.437838, -24.551255],
            [-55.460479, -24.541427],
            [-55.491108, -24.568021],
            [-55.493706, -24.533788],
            [-55.513492, -24.515307],
            [-55.543932, -24.513539],
            [-55.552465, -24.51865],
            [-55.551627, -24.550859],
            [-55.56419, -24.581454],
            [-55.577875, -24.601239],
            [-55.592494, -24.60245],
            [-55.6018, -24.634745],
            [-55.612427, -24.646075],
            [-55.638464, -24.644827],
            [-55.668465, -24.653189],
            [-55.670795, -24.672122],
            [-55.702707, -24.688919],
            [-55.712726, -24.707917],
            [-55.727095, -24.72135],
            [-55.762171, -24.656149],
            [-55.75262, -24.637621],
            [-55.764637, -24.618531],
            [-55.767042, -24.588372],
            [-55.749205, -24.571361],
            [-55.756564, -24.562266],
            [-55.758221, -24.535527],
            [-55.774658, -24.52585],
            [-55.776825, -24.509175],
            [-55.797316, -24.479787],
            [-55.827921, -24.468732],
            [-55.863683, -24.434938],
            [-55.861381, -24.421495],
            [-55.871485, -24.396627],
            [-55.8976, -24.386528],
            [-55.924184, -24.369996],
            [-55.938791, -24.372457],
            [-55.922346, -24.352549],
            [-55.913695, -24.334024],
            [-55.882226, -24.288628],
            [-55.860115, -24.274854],
            [-55.857529, -24.29006],
            [-55.833878, -24.299203],
            [-55.801719, -24.298041],
            [-55.805633, -24.286608],
            [-55.775785, -24.282713],
            [-55.793868, -24.239769],
            [-55.804074, -24.195476],
            [-55.835332, -24.203947],
            [-55.830325, -24.172585],
            [-55.836826, -24.160732],
            [-55.829909, -24.135655],
            [-55.835908, -24.10989],
            [-55.848579, -24.092421],
            [-55.845777, -24.067284],
            [-55.844013, -24.066661]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "VILLA CURUGUATY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.4141, -23.964813],
            [-55.394334, -23.973515],
            [-55.387616, -23.967492],
            [-55.349329, -23.993549],
            [-55.336099, -23.992949],
            [-55.317725, -23.962891],
            [-55.304178, -23.965023],
            [-55.277802, -23.984555],
            [-55.235377, -24.006624],
            [-55.228737, -24.013829],
            [-55.23807, -24.022793],
            [-55.231217, -24.052751],
            [-55.221515, -24.060111],
            [-55.299419, -24.085633],
            [-55.324553, -24.087666],
            [-55.314604, -24.113792],
            [-55.315047, -24.136227],
            [-55.319694, -24.158608],
            [-55.359683, -24.190231],
            [-55.375537, -24.207658],
            [-55.393115, -24.205735],
            [-55.396772, -24.192122],
            [-55.4238, -24.180695],
            [-55.446891, -24.187612],
            [-55.434712, -24.198172],
            [-55.432065, -24.214995],
            [-55.44328, -24.244569],
            [-55.431841, -24.261085],
            [-55.442863, -24.28393],
            [-55.46539, -24.282123],
            [-55.475663, -24.260316],
            [-55.500562, -24.257809],
            [-55.502032, -24.268736],
            [-55.518113, -24.273571],
            [-55.539749, -24.297819],
            [-55.577658, -24.308111],
            [-55.598261, -24.291966],
            [-55.60703, -24.269456],
            [-55.622946, -24.266007],
            [-55.628604, -24.245174],
            [-55.652096, -24.239042],
            [-55.67743, -24.239028],
            [-55.67833, -24.219331],
            [-55.687557, -24.209253],
            [-55.685817, -24.18419],
            [-55.705469, -24.163057],
            [-55.717579, -24.140817],
            [-55.723134, -24.118938],
            [-55.741071, -24.113799],
            [-55.744213, -24.103265],
            [-55.765327, -24.100731],
            [-55.809844, -24.083223],
            [-55.823974, -24.083541],
            [-55.844013, -24.066661],
            [-55.823698, -24.044287],
            [-55.801582, -24.036895],
            [-55.794636, -24.02561],
            [-55.779108, -24.024648],
            [-55.770342, -24.034295],
            [-55.755119, -24.025204],
            [-55.725149, -24.025838],
            [-55.707131, -24.009387],
            [-55.702849, -23.99352],
            [-55.682172, -23.980976],
            [-55.675476, -23.968221],
            [-55.676667, -23.946503],
            [-55.646683, -23.930267],
            [-55.637661, -23.931903],
            [-55.618037, -23.916348],
            [-55.603412, -23.919251],
            [-55.578017, -23.883912],
            [-55.544864, -23.882811],
            [-55.535781, -23.87323],
            [-55.50695, -23.884823],
            [-55.502869, -23.894658],
            [-55.471609, -23.918999],
            [-55.427431, -23.971693],
            [-55.4141, -23.964813]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "VILLA YGATIMÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.453793, -23.81914],
            [-55.511727, -23.797116],
            [-55.528162, -23.802422],
            [-55.540629, -23.796765],
            [-55.598367, -23.820116],
            [-55.62489, -23.837401],
            [-55.640565, -23.852797],
            [-55.688163, -23.868251],
            [-55.707479, -23.902014],
            [-55.727751, -23.903221],
            [-56.0257, -23.828573],
            [-56.027214, -23.822321],
            [-55.991649, -23.82771],
            [-55.951692, -23.812831],
            [-55.930942, -23.830927],
            [-55.917527, -23.817657],
            [-55.899763, -23.821139],
            [-55.886037, -23.807051],
            [-55.859315, -23.799012],
            [-55.857309, -23.784195],
            [-55.839276, -23.763523],
            [-55.800041, -23.751397],
            [-55.769927, -23.736119],
            [-55.753374, -23.691553],
            [-55.707476, -23.660665],
            [-55.662524, -23.675578],
            [-55.641461, -23.668499],
            [-55.630333, -23.656923],
            [-55.600351, -23.652925],
            [-55.586656, -23.637399],
            [-55.571773, -23.579081],
            [-55.544369, -23.539317],
            [-55.543421, -23.523665],
            [-55.536226, -23.554944],
            [-55.52659, -23.567341],
            [-55.538274, -23.591854],
            [-55.530508, -23.627821],
            [-55.510424, -23.632556],
            [-55.474763, -23.650422],
            [-55.475337, -23.673729],
            [-55.462246, -23.683898],
            [-55.466584, -23.703439],
            [-55.442129, -23.727941],
            [-55.448677, -23.742265],
            [-55.443276, -23.765659],
            [-55.433864, -23.77103],
            [-55.430187, -23.790131],
            [-55.453793, -23.81914]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "ITANARÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.453793, -23.81914],
            [-55.441561, -23.829217],
            [-55.435679, -23.872306],
            [-55.439481, -23.904891],
            [-55.44638, -23.916834],
            [-55.42789, -23.926306],
            [-55.4141, -23.964813],
            [-55.427431, -23.971693],
            [-55.471609, -23.918999],
            [-55.502869, -23.894658],
            [-55.50695, -23.884823],
            [-55.535781, -23.87323],
            [-55.544864, -23.882811],
            [-55.578017, -23.883912],
            [-55.603412, -23.919251],
            [-55.618037, -23.916348],
            [-55.637661, -23.931903],
            [-55.646683, -23.930267],
            [-55.676667, -23.946503],
            [-55.675476, -23.968221],
            [-55.682172, -23.980976],
            [-55.702849, -23.99352],
            [-55.707131, -24.009387],
            [-55.725149, -24.025838],
            [-55.755119, -24.025204],
            [-55.770342, -24.034295],
            [-55.779108, -24.024648],
            [-55.794636, -24.02561],
            [-55.801582, -24.036895],
            [-55.823698, -24.044287],
            [-55.844013, -24.066661],
            [-55.845777, -24.067284],
            [-55.86868, -24.068876],
            [-55.887589, -24.05121],
            [-55.922912, -24.061552],
            [-55.960326, -24.049306],
            [-55.977107, -24.028614],
            [-56.004341, -23.91669],
            [-56.0257, -23.828573],
            [-55.727751, -23.903221],
            [-55.707479, -23.902014],
            [-55.688163, -23.868251],
            [-55.640565, -23.852797],
            [-55.62489, -23.837401],
            [-55.598367, -23.820116],
            [-55.540629, -23.796765],
            [-55.528162, -23.802422],
            [-55.511727, -23.797116],
            [-55.453793, -23.81914]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "YPEJHÚ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.738671, -23.866629],
            [-54.719125, -23.936571],
            [-54.715328, -23.964369],
            [-54.69093, -23.974471],
            [-54.700788, -23.992191],
            [-54.706105, -24.021181],
            [-54.698781, -24.058164],
            [-54.683915, -24.089513],
            [-54.653665, -24.132093],
            [-54.615599, -24.198306],
            [-54.588979, -24.268115],
            [-54.581753, -24.277613],
            [-54.593997, -24.290972],
            [-54.594873, -24.313296],
            [-54.603027, -24.332665],
            [-54.602587, -24.368068],
            [-54.579236, -24.384045],
            [-54.603881, -24.418864],
            [-54.620971, -24.425588],
            [-54.637158, -24.441454],
            [-54.603578, -24.472279],
            [-54.611941, -24.513567],
            [-54.612566, -24.513437],
            [-54.625611, -24.513783],
            [-54.648225, -24.499731],
            [-54.672339, -24.495375],
            [-54.696262, -24.49729],
            [-54.712784, -24.466358],
            [-54.70344, -24.410185],
            [-54.692385, -24.382323],
            [-54.662716, -24.367799],
            [-54.677271, -24.289994],
            [-54.677462, -24.274179],
            [-54.687948, -24.245369],
            [-54.712973, -24.213678],
            [-54.717242, -24.190794],
            [-54.741953, -24.199162],
            [-54.770834, -24.193938],
            [-54.751882, -24.179374],
            [-54.763493, -24.16201],
            [-54.781976, -24.154767],
            [-54.797462, -24.168225],
            [-54.785067, -24.180669],
            [-54.804868, -24.190072],
            [-54.815856, -24.17864],
            [-54.818272, -24.061086],
            [-54.820723, -24.045085],
            [-54.82326, -23.889803],
            [-54.792895, -23.868137],
            [-54.764121, -23.866273],
            [-54.759219, -23.856778],
            [-54.738671, -23.866629]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "FRANCISCO CABALLERO ALVAREZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.712784, -24.466358],
            [-54.958574, -24.447323],
            [-54.961605, -24.432792],
            [-54.95393, -24.419589],
            [-54.957234, -24.405099],
            [-54.954066, -24.374045],
            [-54.933543, -24.363009],
            [-54.921589, -24.347711],
            [-54.912043, -24.341612],
            [-54.893184, -24.354703],
            [-54.879522, -24.347945],
            [-54.872774, -24.333451],
            [-54.845916, -24.303055],
            [-54.822493, -24.318451],
            [-54.824359, -24.260102],
            [-54.81999, -24.259339],
            [-54.820884, -24.188724],
            [-54.815856, -24.17864],
            [-54.804868, -24.190072],
            [-54.785067, -24.180669],
            [-54.797462, -24.168225],
            [-54.781976, -24.154767],
            [-54.763493, -24.16201],
            [-54.751882, -24.179374],
            [-54.770834, -24.193938],
            [-54.741953, -24.199162],
            [-54.717242, -24.190794],
            [-54.712973, -24.213678],
            [-54.687948, -24.245369],
            [-54.677462, -24.274179],
            [-54.677271, -24.289994],
            [-54.662716, -24.367799],
            [-54.692385, -24.382323],
            [-54.70344, -24.410185],
            [-54.712784, -24.466358]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "KATUETÉ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.000321, -26.176082],
            [-58.027544, -26.202069],
            [-58.018789, -26.219326],
            [-58.025469, -26.25041],
            [-58.072516, -26.238411],
            [-58.088464, -26.223222],
            [-58.105381, -26.222758],
            [-58.121177, -26.208122],
            [-58.142941, -26.197944],
            [-58.143359, -26.178431],
            [-58.120511, -26.186224],
            [-58.115063, -26.148155],
            [-58.094209, -26.125613],
            [-58.035254, -26.162517],
            [-58.022942, -26.159287],
            [-58.000321, -26.176082]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "ALBERDI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.840658, -27.105986],
            [-55.716971, -27.216669],
            [-55.745813, -27.242581],
            [-55.68832, -27.293815],
            [-55.717075, -27.319519],
            [-55.7967, -27.2487],
            [-55.803112, -27.268111],
            [-55.818366, -27.267267],
            [-55.82219, -27.226416],
            [-55.926239, -27.134262],
            [-55.923001, -27.112599],
            [-55.903694, -27.092549],
            [-55.885537, -27.081464],
            [-55.878446, -27.075518],
            [-55.840658, -27.105986]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CAPITÁN MIRANDA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.611695, -27.167655],
            [-55.620033, -27.18235],
            [-55.620231, -27.2048],
            [-55.580036, -27.236588],
            [-55.577538, -27.265363],
            [-55.601213, -27.286144],
            [-55.590751, -27.326275],
            [-55.628783, -27.357149],
            [-55.662177, -27.370152],
            [-55.717075, -27.319519],
            [-55.68832, -27.293815],
            [-55.745813, -27.242581],
            [-55.716971, -27.216669],
            [-55.69147, -27.188583],
            [-55.672737, -27.17969],
            [-55.653309, -27.162701],
            [-55.626276, -27.153087],
            [-55.620825, -27.142002],
            [-55.611695, -27.167655]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "NUEVA ALBORADA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.993186, -27.189335],
            [-56.020418, -27.21402],
            [-56.019438, -27.225988],
            [-56.032841, -27.275569],
            [-56.046397, -27.291692],
            [-56.046522, -27.306623],
            [-56.098127, -27.308322],
            [-56.124613, -27.306457],
            [-56.168231, -27.297061],
            [-56.168952, -27.266893],
            [-56.181851, -27.239675],
            [-56.181177, -27.227234],
            [-56.167893, -27.20465],
            [-56.169738, -27.1515],
            [-56.147174, -27.136496],
            [-56.146439, -27.121438],
            [-56.134739, -27.112273],
            [-56.12883, -27.069365],
            [-55.993186, -27.189335]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CARMEN DEL PARANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.766356, -24.075947],
            [-56.769552, -24.098516],
            [-56.780758, -24.112112],
            [-56.769101, -24.125427],
            [-56.797205, -24.130219],
            [-56.798111, -24.15244],
            [-56.806096, -24.165845],
            [-56.811618, -24.194675],
            [-56.849061, -24.200776],
            [-56.9441, -24.197053],
            [-56.949734, -24.187484],
            [-56.986365, -24.176337],
            [-56.999125, -24.167662],
            [-57.036353, -24.178399],
            [-57.048744, -24.188076],
            [-57.089094, -24.196215],
            [-57.08186, -24.187982],
            [-57.089784, -24.132353],
            [-57.075416, -24.133101],
            [-57.062976, -24.119001],
            [-57.043497, -24.120208],
            [-57.03823, -24.107692],
            [-57.011514, -24.105377],
            [-56.984064, -24.089455],
            [-56.974026, -24.096286],
            [-56.960987, -24.085001],
            [-56.943437, -24.090386],
            [-56.923023, -24.08787],
            [-56.904325, -24.074131],
            [-56.891684, -24.0876],
            [-56.869619, -24.073228],
            [-56.859365, -24.085254],
            [-56.839284, -24.090923],
            [-56.818263, -24.07233],
            [-56.796562, -24.077155],
            [-56.776273, -24.067989],
            [-56.766356, -24.075947]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "SAN PABLO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.538868, -24.770441],
            [-56.550679, -24.771389],
            [-56.564483, -24.789161],
            [-56.594692, -24.80111],
            [-56.615011, -24.803457],
            [-56.637784, -24.813914],
            [-56.654655, -24.802509],
            [-56.687431, -24.81002],
            [-56.680974, -24.856678],
            [-56.684737, -24.868785],
            [-56.689171, -24.878729],
            [-56.708214, -24.876302],
            [-56.720094, -24.888079],
            [-56.735332, -24.889018],
            [-56.749103, -24.873426],
            [-56.767447, -24.866964],
            [-56.812222, -24.868367],
            [-56.842861, -24.877233],
            [-56.860323, -24.875747],
            [-56.949319, -24.843279],
            [-56.954112, -24.863688],
            [-56.983023, -24.878519],
            [-56.980249, -24.896666],
            [-56.989293, -24.922646],
            [-57.004552, -24.942307],
            [-57.015346, -24.965914],
            [-57.030568, -24.977489],
            [-57.053443, -24.921408],
            [-57.054076, -24.90801],
            [-57.037692, -24.882633],
            [-57.055711, -24.865224],
            [-57.048331, -24.848501],
            [-57.059916, -24.840513],
            [-57.041338, -24.819165],
            [-57.050303, -24.795039],
            [-57.027052, -24.782844],
            [-57.010843, -24.785379],
            [-57.001263, -24.756031],
            [-57.004635, -24.719734],
            [-56.963375, -24.728157],
            [-56.901557, -24.736438],
            [-56.890849, -24.728014],
            [-56.904983, -24.7056],
            [-56.907124, -24.690324],
            [-56.894275, -24.681329],
            [-56.860582, -24.698604],
            [-56.853927, -24.678462],
            [-56.873974, -24.678898],
            [-56.889719, -24.663497],
            [-56.872572, -24.656109],
            [-56.861314, -24.640233],
            [-56.83131, -24.648172],
            [-56.809212, -24.643518],
            [-56.78092, -24.643728],
            [-56.767985, -24.671777],
            [-56.753991, -24.670903],
            [-56.742969, -24.651413],
            [-56.727621, -24.670219],
            [-56.704115, -24.643025],
            [-56.710401, -24.664757],
            [-56.685778, -24.675031],
            [-56.668654, -24.660227],
            [-56.629563, -24.653275],
            [-56.573363, -24.632804],
            [-56.553135, -24.632157],
            [-56.539387, -24.646881],
            [-56.562544, -24.678307],
            [-56.568268, -24.705683],
            [-56.552849, -24.744365],
            [-56.538868, -24.770441]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "25 DE DICIEMBRE"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.811618, -24.194675],
            [-56.819757, -24.226506],
            [-56.819768, -24.276691],
            [-56.850303, -24.302786],
            [-56.853703, -24.311252],
            [-56.884139, -24.341542],
            [-56.907838, -24.360388],
            [-56.945386, -24.396651],
            [-56.96209, -24.379947],
            [-56.97965, -24.404217],
            [-57.007918, -24.41778],
            [-56.989787, -24.449475],
            [-56.997639, -24.481455],
            [-56.997211, -24.525427],
            [-56.982458, -24.535926],
            [-56.968229, -24.557122],
            [-57.025193, -24.658201],
            [-57.0152, -24.672906],
            [-57.024479, -24.684613],
            [-57.033474, -24.714594],
            [-57.004635, -24.719734],
            [-57.001263, -24.756031],
            [-57.010843, -24.785379],
            [-57.027052, -24.782844],
            [-57.050303, -24.795039],
            [-57.041338, -24.819165],
            [-57.059916, -24.840513],
            [-57.048331, -24.848501],
            [-57.055711, -24.865224],
            [-57.037692, -24.882633],
            [-57.054076, -24.90801],
            [-57.053443, -24.921408],
            [-57.030568, -24.977489],
            [-57.048962, -24.984312],
            [-57.039551, -25.00407],
            [-57.050596, -25.012718],
            [-57.066075, -25.003591],
            [-57.103678, -25.010618],
            [-57.120214, -25.00661],
            [-57.160999, -24.973513],
            [-57.199748, -24.971682],
            [-57.236079, -24.956669],
            [-57.257124, -24.954286],
            [-57.269082, -24.924028],
            [-57.24383, -24.935],
            [-57.223572, -24.932765],
            [-57.216592, -24.920651],
            [-57.21967, -24.904729],
            [-57.249341, -24.894825],
            [-57.259757, -24.885631],
            [-57.257468, -24.86014],
            [-57.291723, -24.851466],
            [-57.298504, -24.831286],
            [-57.265434, -24.810102],
            [-57.246369, -24.774159],
            [-57.232066, -24.756792],
            [-57.226572, -24.738273],
            [-57.234583, -24.709879],
            [-57.227118, -24.697197],
            [-57.196238, -24.698261],
            [-57.172417, -24.692456],
            [-57.174728, -24.659764],
            [-57.157441, -24.618256],
            [-57.190109, -24.582187],
            [-57.194797, -24.569149],
            [-57.187958, -24.552788],
            [-57.162167, -24.534117],
            [-57.163638, -24.522844],
            [-57.194061, -24.493401],
            [-57.187103, -24.476981],
            [-57.157995, -24.466646],
            [-57.149308, -24.44898],
            [-57.167715, -24.421707],
            [-57.181411, -24.393309],
            [-57.177552, -24.375919],
            [-57.164042, -24.355937],
            [-57.180308, -24.312634],
            [-57.198583, -24.296633],
            [-57.206462, -24.27594],
            [-57.204586, -24.26132],
            [-57.179011, -24.266654],
            [-57.134941, -24.26013],
            [-57.108529, -24.251135],
            [-57.103675, -24.242284],
            [-57.077692, -24.243426],
            [-57.08326, -24.224723],
            [-57.09925, -24.203308],
            [-57.089094, -24.196215],
            [-57.048744, -24.188076],
            [-57.036353, -24.178399],
            [-56.999125, -24.167662],
            [-56.986365, -24.176337],
            [-56.949734, -24.187484],
            [-56.9441, -24.197053],
            [-56.849061, -24.200776],
            [-56.811618, -24.194675]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "VILLA DEL ROSARIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.02729, -23.822219],
            [-56.027214, -23.822321],
            [-56.0257, -23.828573],
            [-56.004341, -23.91669],
            [-56.014811, -23.924913],
            [-56.048626, -23.924919],
            [-56.052487, -23.948239],
            [-56.072426, -23.946685],
            [-56.073823, -23.959228],
            [-56.187307, -23.948024],
            [-56.200347, -23.980981],
            [-56.203994, -24.00058],
            [-56.224387, -24.020584],
            [-56.231259, -24.016141],
            [-56.250519, -24.034491],
            [-56.229111, -24.063194],
            [-56.229147, -24.093259],
            [-56.189737, -24.098081],
            [-56.18662, -24.129195],
            [-56.202666, -24.143846],
            [-56.22343, -24.15878],
            [-56.245, -24.153739],
            [-56.260197, -24.157525],
            [-56.27656, -24.147582],
            [-56.287026, -24.152108],
            [-56.316651, -24.133964],
            [-56.329637, -24.140076],
            [-56.368464, -24.119805],
            [-56.39265, -24.120089],
            [-56.414384, -24.10318],
            [-56.428388, -24.110106],
            [-56.452727, -24.093498],
            [-56.464863, -24.078319],
            [-56.458105, -24.073718],
            [-56.448687, -24.046314],
            [-56.429338, -24.019386],
            [-56.370375, -23.947518],
            [-56.369717, -23.915129],
            [-56.33013, -23.920308],
            [-56.301163, -23.914211],
            [-56.286735, -23.919189],
            [-56.260562, -23.897712],
            [-56.243592, -23.904991],
            [-56.220009, -23.898],
            [-56.204314, -23.878369],
            [-56.174422, -23.860184],
            [-56.136837, -23.867407],
            [-56.122868, -23.859706],
            [-56.097725, -23.859026],
            [-56.081813, -23.848902],
            [-56.055578, -23.842359],
            [-56.02729, -23.822219]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "GENERAL FRANCISCO ISIDORO RESQUÍN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.219968, -25.265591],
            [-55.248298, -25.252297],
            [-55.289862, -25.251734],
            [-55.307153, -25.277279],
            [-55.32846, -25.33526],
            [-55.355386, -25.357609],
            [-55.378436, -25.361914],
            [-55.417028, -25.362798],
            [-55.481062, -25.355105],
            [-55.507797, -25.345503],
            [-55.513194, -25.31071],
            [-55.545577, -25.274248],
            [-55.557725, -25.267269],
            [-55.564704, -25.254208],
            [-55.541818, -25.251375],
            [-55.542382, -25.239612],
            [-55.510804, -25.237546],
            [-55.511065, -25.228502],
            [-55.463912, -25.228834],
            [-55.45367, -25.219371],
            [-55.441192, -25.230638],
            [-55.418211, -25.225008],
            [-55.424101, -25.200288],
            [-55.403844, -25.199962],
            [-55.418148, -25.154697],
            [-55.412968, -25.140638],
            [-55.388691, -25.142119],
            [-55.363075, -25.134097],
            [-55.340186, -25.152131],
            [-55.296841, -25.171167],
            [-55.242094, -25.200438],
            [-55.224168, -25.238349],
            [-55.219968, -25.265591]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "TEMBIAPORÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.348866, -24.842709],
            [-55.340843, -24.868244],
            [-55.329277, -24.877442],
            [-55.326876, -24.900817],
            [-55.344111, -24.914792],
            [-55.331563, -24.924489],
            [-55.33469, -24.949664],
            [-55.3311, -24.970963],
            [-55.308838, -24.982178],
            [-55.312739, -25.001805],
            [-55.33585, -25.000012],
            [-55.356896, -25.005297],
            [-55.380003, -24.990766],
            [-55.403666, -24.993568],
            [-55.41055, -25.023848],
            [-55.422312, -25.038546],
            [-55.420659, -25.071352],
            [-55.404069, -25.093414],
            [-55.402366, -25.106807],
            [-55.434485, -25.113142],
            [-55.446607, -25.090014],
            [-55.472955, -25.073697],
            [-55.489112, -25.083523],
            [-55.523404, -25.071214],
            [-55.553831, -25.064159],
            [-55.572749, -25.065042],
            [-55.60709, -25.036077],
            [-55.631199, -25.03999],
            [-55.648726, -25.022999],
            [-55.676851, -25.011667],
            [-55.700167, -25.017125],
            [-55.708073, -24.993322],
            [-55.682672, -24.987434],
            [-55.665345, -24.974168],
            [-55.657521, -24.951116],
            [-55.630877, -24.92729],
            [-55.600989, -24.917611],
            [-55.586, -24.901232],
            [-55.559482, -24.901976],
            [-55.548747, -24.893222],
            [-55.530079, -24.890899],
            [-55.457276, -24.893636],
            [-55.422299, -24.8751],
            [-55.400576, -24.879478],
            [-55.377267, -24.864319],
            [-55.364012, -24.831314],
            [-55.348866, -24.842709]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAGUAZÚ",
        "dist_desc_": "NUEVA TOLEDO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.180444, -26.063412],
            [-56.179505, -26.071068],
            [-56.202596, -26.095771],
            [-56.212011, -26.122662],
            [-56.223916, -26.129832],
            [-56.198658, -26.155747],
            [-56.164737, -26.1504],
            [-56.140913, -26.141375],
            [-56.127988, -26.126051],
            [-56.104643, -26.130335],
            [-56.113968, -26.162168],
            [-56.118708, -26.181451],
            [-56.129093, -26.181293],
            [-56.148491, -26.201363],
            [-56.15202, -26.213682],
            [-56.145387, -26.249749],
            [-56.167135, -26.266581],
            [-56.183231, -26.262727],
            [-56.213712, -26.279502],
            [-56.218989, -26.296221],
            [-56.246794, -26.303412],
            [-56.260238, -26.368075],
            [-56.275264, -26.378],
            [-56.306767, -26.372697],
            [-56.330928, -26.386441],
            [-56.357216, -26.388721],
            [-56.369488, -26.406595],
            [-56.366203, -26.387544],
            [-56.376161, -26.376609],
            [-56.389548, -26.3572],
            [-56.388572, -26.336235],
            [-56.397334, -26.318515],
            [-56.38275, -26.31719],
            [-56.368098, -26.274188],
            [-56.372398, -26.247656],
            [-56.389328, -26.235915],
            [-56.40079, -26.208356],
            [-56.40231, -26.177733],
            [-56.396427, -26.166543],
            [-56.410134, -26.139789],
            [-56.402443, -26.137133],
            [-56.410906, -26.023869],
            [-56.392453, -26.016739],
            [-56.37144, -26.017638],
            [-56.352383, -26.026281],
            [-56.335464, -26.002497],
            [-56.323347, -26.002197],
            [-56.301645, -25.983688],
            [-56.280961, -25.976187],
            [-56.27254, -25.977978],
            [-56.180444, -26.063412]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "CAAZAPÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.476412, -25.523741],
            [-55.432483, -25.543784],
            [-55.426062, -25.557542],
            [-55.408404, -25.598393],
            [-55.39926, -25.604094],
            [-55.400011, -25.622747],
            [-55.419411, -25.637492],
            [-55.427199, -25.659704],
            [-55.452592, -25.654134],
            [-55.46278, -25.677548],
            [-55.477607, -25.68364],
            [-55.466178, -25.709268],
            [-55.480194, -25.733308],
            [-55.497341, -25.775743],
            [-55.511496, -25.782718],
            [-55.521961, -25.80619],
            [-55.528283, -25.850023],
            [-55.512066, -25.870352],
            [-55.526787, -25.888793],
            [-55.515895, -25.90193],
            [-55.528221, -25.942823],
            [-55.55064, -25.996946],
            [-55.576381, -26.014491],
            [-55.599051, -26.016482],
            [-55.647214, -26.056155],
            [-55.649988, -26.092339],
            [-55.671505, -26.143801],
            [-55.706748, -26.151186],
            [-55.711541, -26.17896],
            [-55.719781, -26.181281],
            [-55.75648, -26.133586],
            [-55.763874, -26.113141],
            [-55.786827, -26.112163],
            [-55.798881, -26.121107],
            [-55.814448, -26.092024],
            [-55.841676, -26.076464],
            [-55.858792, -26.08998],
            [-55.872729, -26.092031],
            [-55.895175, -26.111896],
            [-55.907119, -26.10996],
            [-55.926982, -26.091366],
            [-55.968379, -26.07054],
            [-55.994792, -26.082021],
            [-55.982042, -26.055148],
            [-55.994164, -26.014396],
            [-55.991104, -26.002658],
            [-55.999427, -25.984514],
            [-55.999178, -25.948351],
            [-55.991184, -25.934484],
            [-56.00921, -25.922469],
            [-56.02716, -25.892457],
            [-56.009762, -25.877585],
            [-55.997689, -25.872776],
            [-55.983205, -25.854364],
            [-55.93567, -25.854463],
            [-55.912355, -25.876045],
            [-55.887567, -25.855247],
            [-55.867591, -25.819641],
            [-55.848217, -25.802523],
            [-55.823717, -25.797352],
            [-55.813625, -25.784088],
            [-55.789392, -25.78833],
            [-55.778722, -25.776616],
            [-55.755193, -25.771686],
            [-55.765212, -25.726537],
            [-55.73582, -25.710407],
            [-55.703147, -25.721492],
            [-55.689608, -25.742986],
            [-55.674354, -25.738374],
            [-55.662527, -25.699718],
            [-55.643693, -25.676042],
            [-55.633585, -25.65027],
            [-55.614144, -25.648977],
            [-55.590661, -25.656408],
            [-55.573884, -25.634279],
            [-55.56187, -25.637357],
            [-55.546121, -25.619203],
            [-55.53396, -25.579993],
            [-55.514017, -25.562642],
            [-55.495888, -25.561066],
            [-55.476412, -25.523741]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "ABAÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.08594, -26.28996],
            [-56.09798, -26.285733],
            [-56.103594, -26.271019],
            [-56.129242, -26.247147],
            [-56.145387, -26.249749],
            [-56.15202, -26.213682],
            [-56.148491, -26.201363],
            [-56.129093, -26.181293],
            [-56.118708, -26.181451],
            [-56.113968, -26.162168],
            [-56.035557, -26.155752],
            [-56.021741, -26.162129],
            [-56.026579, -26.177743],
            [-56.055047, -26.199556],
            [-56.05916, -26.210689],
            [-56.015073, -26.230866],
            [-56.027606, -26.247727],
            [-56.040685, -26.285471],
            [-56.049793, -26.281779],
            [-56.08594, -26.28996]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "BUENA VISTA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.397334, -26.318515],
            [-56.388572, -26.336235],
            [-56.389548, -26.3572],
            [-56.376161, -26.376609],
            [-56.400539, -26.376564],
            [-56.4208, -26.365655],
            [-56.422631, -26.388908],
            [-56.434169, -26.39252],
            [-56.441563, -26.413562],
            [-56.546014, -26.479377],
            [-56.576863, -26.478297],
            [-56.79594, -26.492734],
            [-56.805035, -26.489874],
            [-56.787159, -26.462082],
            [-56.791365, -26.434187],
            [-56.781246, -26.434359],
            [-56.759429, -26.415425],
            [-56.763958, -26.391534],
            [-56.755367, -26.366029],
            [-56.738884, -26.365066],
            [-56.736365, -26.334299],
            [-56.72243, -26.326858],
            [-56.725113, -26.312683],
            [-56.699077, -26.300785],
            [-56.693793, -26.287431],
            [-56.647517, -26.283029],
            [-56.639385, -26.287727],
            [-56.590885, -26.296129],
            [-56.549209, -26.280785],
            [-56.535779, -26.28393],
            [-56.512015, -26.264216],
            [-56.460852, -26.274317],
            [-56.398325, -26.312839],
            [-56.397334, -26.318515]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "DOCTOR MOISÉS S. BERTONI"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.02716, -25.892457],
            [-56.00921, -25.922469],
            [-55.991184, -25.934484],
            [-55.999178, -25.948351],
            [-55.999427, -25.984514],
            [-55.991104, -26.002658],
            [-55.994164, -26.014396],
            [-55.982042, -26.055148],
            [-55.994792, -26.082021],
            [-56.016369, -26.089317],
            [-56.033084, -26.083186],
            [-56.087031, -26.109726],
            [-56.104643, -26.130335],
            [-56.127988, -26.126051],
            [-56.140913, -26.141375],
            [-56.164737, -26.1504],
            [-56.198658, -26.155747],
            [-56.223916, -26.129832],
            [-56.212011, -26.122662],
            [-56.202596, -26.095771],
            [-56.179505, -26.071068],
            [-56.180444, -26.063412],
            [-56.161596, -26.054514],
            [-56.136796, -26.030134],
            [-56.120771, -26.027396],
            [-56.099252, -26.019043],
            [-56.048453, -25.89086],
            [-56.02716, -25.892457]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "GENERAL HIGINIO MORINIGO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.410134, -26.139789],
            [-56.396427, -26.166543],
            [-56.40231, -26.177733],
            [-56.40079, -26.208356],
            [-56.389328, -26.235915],
            [-56.372398, -26.247656],
            [-56.368098, -26.274188],
            [-56.38275, -26.31719],
            [-56.397334, -26.318515],
            [-56.398325, -26.312839],
            [-56.460852, -26.274317],
            [-56.512015, -26.264216],
            [-56.535779, -26.28393],
            [-56.549209, -26.280785],
            [-56.590885, -26.296129],
            [-56.639385, -26.287727],
            [-56.647517, -26.283029],
            [-56.693793, -26.287431],
            [-56.694399, -26.260439],
            [-56.684218, -26.253538],
            [-56.673942, -26.227274],
            [-56.638871, -26.221206],
            [-56.629165, -26.194631],
            [-56.615798, -26.176472],
            [-56.603696, -26.173139],
            [-56.586182, -26.185884],
            [-56.561302, -26.188953],
            [-56.538739, -26.14871],
            [-56.546402, -26.128445],
            [-56.532745, -26.121778],
            [-56.48085, -26.116594],
            [-56.437506, -26.119072],
            [-56.410134, -26.139789]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "MACIEL"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.711541, -26.17896],
            [-55.697986, -26.206103],
            [-55.722551, -26.222542],
            [-55.723049, -26.26037],
            [-55.740481, -26.298435],
            [-55.761511, -26.304516],
            [-55.764804, -26.318858],
            [-55.755231, -26.334898],
            [-55.758967, -26.346342],
            [-55.788029, -26.346485],
            [-55.802138, -26.357404],
            [-55.803671, -26.387667],
            [-55.823708, -26.40854],
            [-55.818978, -26.414306],
            [-55.835524, -26.435486],
            [-55.851127, -26.439226],
            [-55.849836, -26.416783],
            [-55.871097, -26.394537],
            [-55.881498, -26.363772],
            [-55.894049, -26.358154],
            [-55.918938, -26.366045],
            [-55.936871, -26.36511],
            [-55.951607, -26.375646],
            [-55.964852, -26.375404],
            [-55.96845, -26.347017],
            [-55.986011, -26.343019],
            [-56.015689, -26.358261],
            [-56.025956, -26.349645],
            [-56.05309, -26.358637],
            [-56.104082, -26.337487],
            [-56.071086, -26.295124],
            [-56.08594, -26.28996],
            [-56.049793, -26.281779],
            [-56.040685, -26.285471],
            [-56.027606, -26.247727],
            [-56.015073, -26.230866],
            [-56.05916, -26.210689],
            [-56.055047, -26.199556],
            [-56.026579, -26.177743],
            [-56.021741, -26.162129],
            [-56.035557, -26.155752],
            [-56.113968, -26.162168],
            [-56.104643, -26.130335],
            [-56.087031, -26.109726],
            [-56.033084, -26.083186],
            [-56.016369, -26.089317],
            [-55.994792, -26.082021],
            [-55.968379, -26.07054],
            [-55.926982, -26.091366],
            [-55.907119, -26.10996],
            [-55.895175, -26.111896],
            [-55.872729, -26.092031],
            [-55.858792, -26.08998],
            [-55.841676, -26.076464],
            [-55.814448, -26.092024],
            [-55.798881, -26.121107],
            [-55.786827, -26.112163],
            [-55.763874, -26.113141],
            [-55.75648, -26.133586],
            [-55.719781, -26.181281],
            [-55.711541, -26.17896]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "SAN JUAN NEPOMUCENO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.357259, -25.993078],
            [-55.327943, -26.022099],
            [-55.28759, -26.049178],
            [-55.253528, -26.043205],
            [-55.249222, -26.058675],
            [-55.249651, -26.069093],
            [-55.286861, -26.090758],
            [-55.299558, -26.103186],
            [-55.317148, -26.097023],
            [-55.334594, -26.104511],
            [-55.347285, -26.11813],
            [-55.343039, -26.148815],
            [-55.354241, -26.201153],
            [-55.367148, -26.210066],
            [-55.357302, -26.230951],
            [-55.360003, -26.269488],
            [-55.375114, -26.297436],
            [-55.391636, -26.310047],
            [-55.452063, -26.324578],
            [-55.482375, -26.310219],
            [-55.507194, -26.307913],
            [-55.513137, -26.313866],
            [-55.498236, -26.350111],
            [-55.532806, -26.355603],
            [-55.545852, -26.366186],
            [-55.562965, -26.367225],
            [-55.567476, -26.390021],
            [-55.595002, -26.416836],
            [-55.612579, -26.409338],
            [-55.63269, -26.392207],
            [-55.651582, -26.372855],
            [-55.684837, -26.361076],
            [-55.717589, -26.36205],
            [-55.736492, -26.379547],
            [-55.766044, -26.39383],
            [-55.803671, -26.387667],
            [-55.802138, -26.357404],
            [-55.788029, -26.346485],
            [-55.758967, -26.346342],
            [-55.755231, -26.334898],
            [-55.764804, -26.318858],
            [-55.761511, -26.304516],
            [-55.740481, -26.298435],
            [-55.723049, -26.26037],
            [-55.722551, -26.222542],
            [-55.697986, -26.206103],
            [-55.711541, -26.17896],
            [-55.706748, -26.151186],
            [-55.671505, -26.143801],
            [-55.649988, -26.092339],
            [-55.647214, -26.056155],
            [-55.599051, -26.016482],
            [-55.576381, -26.014491],
            [-55.55064, -25.996946],
            [-55.501749, -25.986196],
            [-55.432133, -26.006918],
            [-55.411279, -25.998593],
            [-55.40175, -26.026031],
            [-55.391728, -26.035087],
            [-55.376636, -26.017328],
            [-55.378425, -26.000864],
            [-55.357259, -25.993078]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "TAVAÍ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.376161, -26.376609],
            [-56.366203, -26.387544],
            [-56.369488, -26.406595],
            [-56.351916, -26.431243],
            [-56.346112, -26.459309],
            [-56.338038, -26.46521],
            [-56.340281, -26.486268],
            [-56.33006, -26.491469],
            [-56.330163, -26.521246],
            [-56.340568, -26.543475],
            [-56.339346, -26.563752],
            [-56.330937, -26.595554],
            [-56.340105, -26.612293],
            [-56.366111, -26.618834],
            [-56.4148, -26.594038],
            [-56.459064, -26.609232],
            [-56.482715, -26.623366],
            [-56.503311, -26.620353],
            [-56.536199, -26.626844],
            [-56.582504, -26.665603],
            [-56.600576, -26.667023],
            [-56.608461, -26.680904],
            [-56.624924, -26.674588],
            [-56.635073, -26.681476],
            [-56.63568, -26.668611],
            [-56.666235, -26.657003],
            [-56.703661, -26.653583],
            [-56.716518, -26.648052],
            [-56.74061, -26.622067],
            [-56.753325, -26.635502],
            [-56.766468, -26.635655],
            [-56.777467, -26.619114],
            [-56.79784, -26.62048],
            [-56.814409, -26.60365],
            [-56.821245, -26.587204],
            [-56.813814, -26.566978],
            [-56.820651, -26.543998],
            [-56.848325, -26.541554],
            [-56.846848, -26.529396],
            [-56.811707, -26.487158],
            [-56.805035, -26.489874],
            [-56.79594, -26.492734],
            [-56.576863, -26.478297],
            [-56.546014, -26.479377],
            [-56.441563, -26.413562],
            [-56.434169, -26.39252],
            [-56.422631, -26.388908],
            [-56.4208, -26.365655],
            [-56.400539, -26.376564],
            [-56.376161, -26.376609]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "YEGROS"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.275264, -26.378],
            [-56.24998, -26.391672],
            [-56.230832, -26.4096],
            [-56.216591, -26.413752],
            [-56.210641, -26.427787],
            [-56.184984, -26.437517],
            [-56.144752, -26.472265],
            [-56.1358, -26.493834],
            [-56.108004, -26.520889],
            [-56.094861, -26.550894],
            [-56.10615, -26.562982],
            [-56.121747, -26.595897],
            [-56.116496, -26.626097],
            [-56.130645, -26.634806],
            [-56.155789, -26.639919],
            [-56.159533, -26.656305],
            [-56.175564, -26.662529],
            [-56.184779, -26.678919],
            [-56.175596, -26.706033],
            [-56.184914, -26.711174],
            [-56.216052, -26.69764],
            [-56.254838, -26.701921],
            [-56.283807, -26.718411],
            [-56.31363, -26.729115],
            [-56.353063, -26.7244],
            [-56.370124, -26.738914],
            [-56.383767, -26.741123],
            [-56.431168, -26.774826],
            [-56.461416, -26.773048],
            [-56.477889, -26.786486],
            [-56.501938, -26.791827],
            [-56.508777, -26.780195],
            [-56.52848, -26.778316],
            [-56.538692, -26.758107],
            [-56.573014, -26.758359],
            [-56.60341, -26.74309],
            [-56.623234, -26.747297],
            [-56.658796, -26.726241],
            [-56.649056, -26.706291],
            [-56.652459, -26.687253],
            [-56.635073, -26.681476],
            [-56.624924, -26.674588],
            [-56.608461, -26.680904],
            [-56.600576, -26.667023],
            [-56.582504, -26.665603],
            [-56.536199, -26.626844],
            [-56.503311, -26.620353],
            [-56.482715, -26.623366],
            [-56.459064, -26.609232],
            [-56.4148, -26.594038],
            [-56.366111, -26.618834],
            [-56.340105, -26.612293],
            [-56.330937, -26.595554],
            [-56.339346, -26.563752],
            [-56.340568, -26.543475],
            [-56.330163, -26.521246],
            [-56.33006, -26.491469],
            [-56.340281, -26.486268],
            [-56.338038, -26.46521],
            [-56.346112, -26.459309],
            [-56.351916, -26.431243],
            [-56.369488, -26.406595],
            [-56.357216, -26.388721],
            [-56.330928, -26.386441],
            [-56.306767, -26.372697],
            [-56.275264, -26.378]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "YUTY"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.08594, -26.28996],
            [-56.071086, -26.295124],
            [-56.104082, -26.337487],
            [-56.05309, -26.358637],
            [-56.025956, -26.349645],
            [-56.015689, -26.358261],
            [-55.986011, -26.343019],
            [-55.96845, -26.347017],
            [-55.964852, -26.375404],
            [-55.951607, -26.375646],
            [-55.936871, -26.36511],
            [-55.918938, -26.366045],
            [-55.894049, -26.358154],
            [-55.881498, -26.363772],
            [-55.871097, -26.394537],
            [-55.849836, -26.416783],
            [-55.851127, -26.439226],
            [-55.86037, -26.44007],
            [-55.876135, -26.457655],
            [-55.893158, -26.475005],
            [-55.919502, -26.516751],
            [-55.955553, -26.511295],
            [-56.018722, -26.516326],
            [-56.020374, -26.531216],
            [-56.050702, -26.534125],
            [-56.055874, -26.523506],
            [-56.094861, -26.550894],
            [-56.108004, -26.520889],
            [-56.1358, -26.493834],
            [-56.144752, -26.472265],
            [-56.184984, -26.437517],
            [-56.210641, -26.427787],
            [-56.216591, -26.413752],
            [-56.230832, -26.4096],
            [-56.24998, -26.391672],
            [-56.275264, -26.378],
            [-56.260238, -26.368075],
            [-56.246794, -26.303412],
            [-56.218989, -26.296221],
            [-56.213712, -26.279502],
            [-56.183231, -26.262727],
            [-56.167135, -26.266581],
            [-56.145387, -26.249749],
            [-56.129242, -26.247147],
            [-56.103594, -26.271019],
            [-56.09798, -26.285733],
            [-56.08594, -26.28996]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CAAZAPÁ",
        "dist_desc_": "3 DE MAYO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.41205, -26.9876],
            [-55.436531, -27.010671],
            [-55.450662, -27.035836],
            [-55.456543, -27.058332],
            [-55.449116, -27.097082],
            [-55.45863, -27.107152],
            [-55.484358, -27.109309],
            [-55.531918, -27.101683],
            [-55.535433, -27.095821],
            [-55.647965, -26.994747],
            [-55.646013, -26.986974],
            [-55.61354, -26.961238],
            [-55.579605, -26.946871],
            [-55.699111, -26.83916],
            [-55.696101, -26.83186],
            [-55.761764, -26.773016],
            [-55.751131, -26.766954],
            [-55.509422, -26.983646],
            [-55.48631, -26.973412],
            [-55.476033, -26.950079],
            [-55.46083, -26.950338],
            [-55.447202, -26.962032],
            [-55.426571, -26.968618],
            [-55.41205, -26.9876]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "BELLA VISTA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.717075, -27.319519],
            [-55.662177, -27.370152],
            [-55.688417, -27.382702],
            [-55.714021, -27.412398],
            [-55.731537, -27.443191],
            [-55.785553, -27.441238],
            [-55.816379, -27.426313],
            [-55.80991, -27.411387],
            [-55.789292, -27.390857],
            [-55.822345, -27.360422],
            [-55.842151, -27.35741],
            [-55.853848, -27.340455],
            [-55.848637, -27.324407],
            [-55.832057, -27.331337],
            [-55.812566, -27.323306],
            [-55.806586, -27.306068],
            [-55.825993, -27.302251],
            [-55.818366, -27.267267],
            [-55.803112, -27.268111],
            [-55.7967, -27.2487],
            [-55.717075, -27.319519]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CAMBYRETÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.194361, -26.759874],
            [-55.180552, -26.771673],
            [-55.196382, -26.783576],
            [-55.210708, -26.780954],
            [-55.224, -26.793969],
            [-55.206123, -26.818719],
            [-55.184571, -26.813431],
            [-55.189743, -26.837794],
            [-55.171043, -26.873767],
            [-55.146681, -26.878925],
            [-55.147295, -26.903247],
            [-55.131043, -26.935209],
            [-55.139813, -26.952346],
            [-55.194673, -26.968631],
            [-55.213636, -26.965613],
            [-55.238891, -26.941691],
            [-55.271731, -26.940938],
            [-55.367165, -26.854776],
            [-55.34912, -26.838874],
            [-55.37215, -26.817987],
            [-55.390051, -26.83376],
            [-55.406991, -26.818288],
            [-55.389218, -26.802685],
            [-55.480756, -26.7206],
            [-55.456461, -26.694808],
            [-55.436634, -26.684575],
            [-55.421573, -26.685239],
            [-55.397101, -26.670155],
            [-55.374505, -26.700117],
            [-55.368666, -26.732542],
            [-55.303063, -26.763026],
            [-55.292466, -26.782392],
            [-55.266341, -26.76222],
            [-55.194361, -26.759874]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "CAPITÁN MEZA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.534474, -25.443702],
            [-57.544613, -25.455432],
            [-57.559407, -25.44375],
            [-57.597797, -25.40176],
            [-57.572362, -25.392606],
            [-57.571855, -25.384836],
            [-57.538957, -25.419052],
            [-57.534474, -25.443702]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "SAN ANTONIO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.784935, -27.212132],
            [-57.700041, -27.244614],
            [-57.625647, -27.262778],
            [-57.419766, -27.281365],
            [-57.420726, -27.247338],
            [-57.249706, -27.239019],
            [-57.325792, -27.386776],
            [-57.341979, -27.416305],
            [-57.365868, -27.422851],
            [-57.415151, -27.427632],
            [-57.450632, -27.439745],
            [-57.495671, -27.443754],
            [-57.51981, -27.433736],
            [-57.566051, -27.407914],
            [-57.610046, -27.391381],
            [-57.634044, -27.377812],
            [-57.675874, -27.343639],
            [-57.711974, -27.334592],
            [-57.756933, -27.332175],
            [-57.816636, -27.332154],
            [-57.826027, -27.328105],
            [-57.853621, -27.287162],
            [-57.87235, -27.276978],
            [-57.875252, -27.269875],
            [-57.863325, -27.247697],
            [-57.847519, -27.246664],
            [-57.812567, -27.209314],
            [-57.784935, -27.212132]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "CERRITO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.255656, -27.055887],
            [-58.282411, -27.129864],
            [-58.285652, -27.171102],
            [-58.281147, -27.18518],
            [-58.276301, -27.265032],
            [-58.290445, -27.278815],
            [-58.317592, -27.274581],
            [-58.355939, -27.283093],
            [-58.402031, -27.286044],
            [-58.431368, -27.285078],
            [-58.413698, -27.223172],
            [-58.41772, -27.207819],
            [-58.429626, -27.197346],
            [-58.41731, -27.156237],
            [-58.400158, -27.153292],
            [-58.387952, -27.07085],
            [-58.374123, -27.073871],
            [-58.360949, -27.035023],
            [-58.367068, -27.026986],
            [-58.322418, -27.029313],
            [-58.307461, -27.050896],
            [-58.255656, -27.055887]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "GRAL. JOSÉ EDUVIGIS DÍAZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.610891, -27.099167],
            [-57.501853, -27.163521],
            [-57.327969, -27.148349],
            [-57.218765, -27.179547],
            [-57.249706, -27.239019],
            [-57.420726, -27.247338],
            [-57.419766, -27.281365],
            [-57.625647, -27.262778],
            [-57.700041, -27.244614],
            [-57.784935, -27.212132],
            [-57.781868, -27.194812],
            [-57.830418, -27.105243],
            [-57.987119, -27.054777],
            [-58.011342, -27.035812],
            [-58.009561, -27.018194],
            [-57.972466, -27.034233],
            [-57.918368, -27.048364],
            [-57.894506, -27.05811],
            [-57.627753, -27.097526],
            [-57.610891, -27.099167]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "LAURELES"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-58.431368, -27.285078],
            [-58.477331, -27.273806],
            [-58.504831, -27.279473],
            [-58.537336, -27.295882],
            [-58.610192, -27.306219],
            [-58.606699, -27.279939],
            [-58.593692, -27.260688],
            [-58.596251, -27.226077],
            [-58.616509, -27.209189],
            [-58.645827, -27.196756],
            [-58.567273, -27.182015],
            [-58.540708, -27.161752],
            [-58.507806, -27.164873],
            [-58.498697, -27.15849],
            [-58.48299, -27.167049],
            [-58.41731, -27.156237],
            [-58.429626, -27.197346],
            [-58.41772, -27.207819],
            [-58.413698, -27.223172],
            [-58.431368, -27.285078]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "PASO DE PATRIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.784935, -27.212132],
            [-57.812567, -27.209314],
            [-57.847519, -27.246664],
            [-57.863325, -27.247697],
            [-57.875252, -27.269875],
            [-57.87235, -27.276978],
            [-57.891457, -27.278834],
            [-57.89722, -27.292985],
            [-57.913387, -27.297925],
            [-57.953317, -27.286833],
            [-57.995984, -27.266778],
            [-58.017551, -27.2395],
            [-58.01101, -27.202519],
            [-58.010584, -27.164573],
            [-58.001939, -27.132182],
            [-57.987119, -27.054777],
            [-57.830418, -27.105243],
            [-57.781868, -27.194812],
            [-57.784935, -27.212132]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ÑEEMBUCÚ",
        "dist_desc_": "VILLALBÍN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-59.879513, -20.630417],
            [-59.886381, -20.711153],
            [-59.886896, -20.791957],
            [-59.863118, -20.820841],
            [-59.83831, -20.8807],
            [-59.839607, -20.903143],
            [-59.817786, -20.936654],
            [-59.814891, -20.976694],
            [-59.785691, -21.022105],
            [-59.768323, -21.037456],
            [-59.755849, -21.096831],
            [-59.75087, -21.182933],
            [-59.76635, -21.200573],
            [-59.715013, -21.345861],
            [-59.769895, -21.383322],
            [-59.845566, -21.432452],
            [-59.872402, -21.447163],
            [-59.887532, -21.554004],
            [-59.904947, -21.646972],
            [-59.926285, -21.776837],
            [-59.932733, -21.834242],
            [-59.947422, -21.926573],
            [-59.951841, -21.98222],
            [-59.953068, -22.054504],
            [-59.860806, -22.054194],
            [-59.740028, -22.055499],
            [-59.738584, -22.178351],
            [-59.739024, -22.349135],
            [-59.83867, -22.347806],
            [-59.969289, -22.349068],
            [-59.991241, -22.35116],
            [-59.991474, -22.467149],
            [-59.953439, -22.466968],
            [-59.953142, -22.518525],
            [-60.055265, -22.467076],
            [-60.092925, -22.464336],
            [-60.235643, -22.357273],
            [-60.414827, -22.221657],
            [-60.411613, -22.214723],
            [-60.411432, -22.114677],
            [-60.409478, -22.007795],
            [-60.503483, -22.009059],
            [-60.49315, -21.83566],
            [-60.580217, -21.828382],
            [-60.569343, -21.618064],
            [-60.566876, -21.553906],
            [-60.556401, -21.348593],
            [-60.548584, -21.14489],
            [-60.545691, -21.049968],
            [-60.544415, -20.963788],
            [-60.541836, -20.891984],
            [-60.54178, -20.819171],
            [-60.537717, -20.677446],
            [-60.535834, -20.456691],
            [-60.111019, -20.58095],
            [-59.9273, -20.632887],
            [-59.879513, -20.630417]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "BOQUERÓN",
        "dist_desc_": "FILADELFIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-59.86902, -22.672305],
            [-59.91616, -22.673429],
            [-59.915582, -22.635369],
            [-59.933295, -22.634872],
            [-59.93292, -22.611542],
            [-59.923047, -22.589398],
            [-59.957886, -22.58949],
            [-59.953142, -22.518525],
            [-59.953439, -22.466968],
            [-59.991474, -22.467149],
            [-59.991241, -22.35116],
            [-59.969289, -22.349068],
            [-59.83867, -22.347806],
            [-59.739024, -22.349135],
            [-59.738584, -22.178351],
            [-59.740028, -22.055499],
            [-59.412897, -22.05682],
            [-59.367744, -22.076224],
            [-59.336595, -22.170403],
            [-59.614392, -22.335895],
            [-59.639343, -22.368923],
            [-59.639763, -22.388631],
            [-59.626237, -22.427976],
            [-59.7118, -22.427977],
            [-59.712167, -22.467009],
            [-59.747181, -22.466983],
            [-59.747184, -22.500433],
            [-59.75177, -22.525404],
            [-59.787933, -22.566777],
            [-59.843758, -22.634372],
            [-59.86902, -22.672305]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "BOQUERÓN",
        "dist_desc_": "LOMA PLATA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.92087, -21.278237],
            [-57.919655, -21.285886],
            [-57.897859, -21.305497],
            [-57.855339, -21.316245],
            [-57.854277, -21.335203],
            [-57.863489, -21.353899],
            [-57.881116, -21.369607],
            [-57.89541, -21.392358],
            [-57.906962, -21.401278],
            [-57.9099, -21.421359],
            [-57.927269, -21.452257],
            [-57.926536, -21.469507],
            [-57.937318, -21.4888],
            [-57.961949, -21.511051],
            [-57.968614, -21.530405],
            [-57.959566, -21.561961],
            [-57.923754, -21.578863],
            [-57.914616, -21.595386],
            [-57.941622, -21.619563],
            [-57.942746, -21.632193],
            [-57.923853, -21.664491],
            [-57.884753, -21.683734],
            [-57.898526, -21.70629],
            [-57.945115, -21.738184],
            [-57.939994, -21.758796],
            [-57.909607, -21.770589],
            [-57.913589, -21.790056],
            [-57.933349, -21.827103],
            [-57.96568, -21.851695],
            [-57.921584, -21.872856],
            [-57.919885, -21.890777],
            [-57.935816, -21.889175],
            [-57.949239, -21.901959],
            [-57.936943, -21.917278],
            [-57.937811, -21.930511],
            [-57.964326, -21.981204],
            [-57.964557, -21.999886],
            [-57.976682, -22.016565],
            [-58.005149, -22.031421],
            [-58.009501, -22.043386],
            [-58.063702, -22.029555],
            [-58.096951, -22.027904],
            [-58.104763, -22.043623],
            [-58.157444, -22.043259],
            [-58.176484, -22.020541],
            [-58.236575, -22.033363],
            [-58.334228, -21.949784],
            [-58.384894, -21.951137],
            [-58.384705, -21.80818],
            [-58.53523, -21.80796],
            [-58.563144, -21.807016],
            [-58.659237, -21.945152],
            [-58.675656, -21.948661],
            [-58.685874, -21.880587],
            [-58.668688, -21.876193],
            [-58.683801, -21.808069],
            [-58.708875, -21.807812],
            [-58.708733, -21.692442],
            [-58.720316, -21.690031],
            [-58.720178, -21.575226],
            [-58.756763, -21.574003],
            [-58.758101, -21.529707],
            [-58.76476, -21.508073],
            [-58.752276, -21.490483],
            [-58.72602, -21.481506],
            [-58.714492, -21.468606],
            [-58.699583, -21.465956],
            [-58.70121, -21.445851],
            [-58.681469, -21.432393],
            [-58.656693, -21.424839],
            [-58.638442, -21.399884],
            [-58.599784, -21.404998],
            [-58.583678, -21.400747],
            [-58.577906, -21.388982],
            [-58.561317, -21.39504],
            [-58.518245, -21.38501],
            [-58.494879, -21.385191],
            [-58.494432, -21.364954],
            [-58.468628, -21.347147],
            [-58.457284, -21.353022],
            [-58.389024, -21.338662],
            [-58.377341, -21.348026],
            [-58.350814, -21.352701],
            [-58.318586, -21.347205],
            [-58.308136, -21.350212],
            [-58.273599, -21.341862],
            [-58.260938, -21.367575],
            [-58.249007, -21.381015],
            [-58.190855, -21.369939],
            [-58.176211, -21.356729],
            [-58.149805, -21.363984],
            [-58.139638, -21.354894],
            [-58.117433, -21.350517],
            [-58.080803, -21.374623],
            [-58.037701, -21.306574],
            [-57.977002, -21.299952],
            [-57.92087, -21.278237]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ALTO PARAGUAY",
        "dist_desc_": "CARMELO PERALTA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.906347, -23.09302],
            [-56.90081, -23.1157],
            [-57.14352, -23.255227],
            [-57.178065, -23.239618],
            [-57.214028, -23.294973],
            [-57.20778, -23.310097],
            [-57.187629, -23.308403],
            [-57.182641, -23.325818],
            [-57.203639, -23.329146],
            [-57.203259, -23.354884],
            [-57.22518, -23.350542],
            [-57.259998, -23.335272],
            [-57.309353, -23.323368],
            [-57.327013, -23.305875],
            [-57.340993, -23.30179],
            [-57.375202, -23.266881],
            [-57.357477, -23.258729],
            [-57.352092, -23.224298],
            [-57.331155, -23.213472],
            [-57.319673, -23.170184],
            [-57.294573, -23.176383],
            [-57.280811, -23.147217],
            [-57.254291, -23.109059],
            [-57.239461, -23.1148],
            [-57.225138, -23.099582],
            [-57.195463, -23.083878],
            [-57.177893, -23.098206],
            [-57.153299, -23.092539],
            [-57.134253, -23.078728],
            [-57.12152, -23.058083],
            [-57.084286, -23.064782],
            [-57.066178, -23.055798],
            [-57.044354, -23.075579],
            [-57.036076, -23.07067],
            [-57.004279, -23.076593],
            [-57.001856, -23.085989],
            [-56.976425, -23.09236],
            [-56.945306, -23.08613],
            [-56.906347, -23.09302]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "LORETO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.859051, -23.082451],
            [-56.853049, -23.110674],
            [-56.842858, -23.119625],
            [-56.827946, -23.152802],
            [-56.829043, -23.170269],
            [-56.802999, -23.218146],
            [-56.77454, -23.204947],
            [-56.769093, -23.242032],
            [-56.754562, -23.228389],
            [-56.737353, -23.261486],
            [-56.746775, -23.306924],
            [-56.743858, -23.364108],
            [-56.734367, -23.379782],
            [-56.706745, -23.401394],
            [-56.713095, -23.424877],
            [-56.726586, -23.432975],
            [-56.750304, -23.451018],
            [-56.776877, -23.435472],
            [-56.8043, -23.425255],
            [-56.811787, -23.439036],
            [-56.868424, -23.437473],
            [-56.883314, -23.443147],
            [-56.906258, -23.439452],
            [-56.925053, -23.445124],
            [-56.948807, -23.435403],
            [-56.967555, -23.437644],
            [-56.979582, -23.448158],
            [-57.005781, -23.45173],
            [-57.032925, -23.442126],
            [-57.059101, -23.45751],
            [-57.135394, -23.46857],
            [-57.146124, -23.475622],
            [-57.15699, -23.458254],
            [-57.147587, -23.441549],
            [-57.144362, -23.40327],
            [-57.138474, -23.393588],
            [-57.140822, -23.354675],
            [-57.144293, -23.329804],
            [-57.177298, -23.339871],
            [-57.182641, -23.325818],
            [-57.187629, -23.308403],
            [-57.20778, -23.310097],
            [-57.214028, -23.294973],
            [-57.178065, -23.239618],
            [-57.14352, -23.255227],
            [-56.90081, -23.1157],
            [-56.906347, -23.09302],
            [-56.893358, -23.079823],
            [-56.894186, -23.067118],
            [-56.859051, -23.082451]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "HORQUETA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.693818, -22.993669],
            [-56.671859, -23.005846],
            [-56.644147, -23.00719],
            [-56.617587, -23.018854],
            [-56.594045, -23.018786],
            [-56.564692, -23.036391],
            [-56.558866, -23.055489],
            [-56.547022, -23.11619],
            [-56.563878, -23.136182],
            [-56.576701, -23.165724],
            [-56.595127, -23.180749],
            [-56.601395, -23.193055],
            [-56.593877, -23.209065],
            [-56.59024, -23.235712],
            [-56.565439, -23.269717],
            [-56.575217, -23.311249],
            [-56.622323, -23.352114],
            [-56.634005, -23.377597],
            [-56.658494, -23.381721],
            [-56.666777, -23.376356],
            [-56.698361, -23.384929],
            [-56.706745, -23.401394],
            [-56.734367, -23.379782],
            [-56.743858, -23.364108],
            [-56.746775, -23.306924],
            [-56.737353, -23.261486],
            [-56.754562, -23.228389],
            [-56.769093, -23.242032],
            [-56.77454, -23.204947],
            [-56.802999, -23.218146],
            [-56.829043, -23.170269],
            [-56.827946, -23.152802],
            [-56.842858, -23.119625],
            [-56.853049, -23.110674],
            [-56.859051, -23.082451],
            [-56.837121, -23.073298],
            [-56.826412, -23.080009],
            [-56.804394, -23.055785],
            [-56.787466, -23.05205],
            [-56.793578, -23.035041],
            [-56.763191, -23.014187],
            [-56.747314, -23.017754],
            [-56.725377, -23.009107],
            [-56.708876, -22.995162],
            [-56.693818, -22.993669]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CONCEPCIÓN",
        "dist_desc_": "ARROYITO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-56.759429, -26.415425],
            [-56.781246, -26.434359],
            [-56.791365, -26.434187],
            [-56.787159, -26.462082],
            [-56.805035, -26.489874],
            [-56.811707, -26.487158],
            [-56.846848, -26.529396],
            [-56.848325, -26.541554],
            [-56.879578, -26.523098],
            [-56.880812, -26.504596],
            [-56.896304, -26.49316],
            [-56.912381, -26.460795],
            [-56.925715, -26.464992],
            [-56.949111, -26.485057],
            [-56.961298, -26.472731],
            [-56.955298, -26.449317],
            [-56.971571, -26.448548],
            [-56.996131, -26.419516],
            [-57.007329, -26.412427],
            [-56.993027, -26.399275],
            [-56.995709, -26.386667],
            [-56.983908, -26.36476],
            [-56.941758, -26.363567],
            [-56.927558, -26.348074],
            [-56.9265, -26.32283],
            [-56.909009, -26.32063],
            [-56.889395, -26.297552],
            [-56.832621, -26.333287],
            [-56.845559, -26.350692],
            [-56.828217, -26.359747],
            [-56.850044, -26.385063],
            [-56.759429, -26.415425]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "PARAGUARÍ",
        "dist_desc_": "MARÍA ANTONIA"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.977107, -24.028614],
            [-55.960326, -24.049306],
            [-55.922912, -24.061552],
            [-55.887589, -24.05121],
            [-55.86868, -24.068876],
            [-55.845777, -24.067284],
            [-55.848579, -24.092421],
            [-55.835908, -24.10989],
            [-55.829909, -24.135655],
            [-55.836826, -24.160732],
            [-55.830325, -24.172585],
            [-55.835332, -24.203947],
            [-55.804074, -24.195476],
            [-55.793868, -24.239769],
            [-55.775785, -24.282713],
            [-55.805633, -24.286608],
            [-55.801719, -24.298041],
            [-55.833878, -24.299203],
            [-55.857529, -24.29006],
            [-55.860115, -24.274854],
            [-55.882226, -24.288628],
            [-55.913695, -24.334024],
            [-55.922346, -24.352549],
            [-55.938791, -24.372457],
            [-55.95659, -24.367014],
            [-55.991671, -24.378726],
            [-56.00945, -24.398716],
            [-56.024464, -24.394777],
            [-56.057731, -24.403086],
            [-56.103686, -24.399671],
            [-56.123032, -24.379706],
            [-56.11616, -24.37041],
            [-56.125143, -24.342606],
            [-56.126647, -24.300913],
            [-56.155609, -24.282739],
            [-56.170484, -24.235816],
            [-56.158022, -24.219139],
            [-56.151384, -24.194697],
            [-56.160641, -24.149331],
            [-56.149615, -24.121171],
            [-56.129663, -24.109064],
            [-56.115013, -24.111105],
            [-56.103796, -24.08979],
            [-56.080617, -24.067524],
            [-56.01599, -24.024658],
            [-55.977107, -24.028614]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "MARACANÁ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.977107, -24.028614],
            [-56.01599, -24.024658],
            [-56.080617, -24.067524],
            [-56.103796, -24.08979],
            [-56.115013, -24.111105],
            [-56.129663, -24.109064],
            [-56.149615, -24.121171],
            [-56.160641, -24.149331],
            [-56.189059, -24.156885],
            [-56.202666, -24.143846],
            [-56.18662, -24.129195],
            [-56.189737, -24.098081],
            [-56.229147, -24.093259],
            [-56.229111, -24.063194],
            [-56.250519, -24.034491],
            [-56.231259, -24.016141],
            [-56.224387, -24.020584],
            [-56.203994, -24.00058],
            [-56.200347, -23.980981],
            [-56.187307, -23.948024],
            [-56.073823, -23.959228],
            [-56.072426, -23.946685],
            [-56.052487, -23.948239],
            [-56.048626, -23.924919],
            [-56.014811, -23.924913],
            [-56.004341, -23.91669],
            [-55.977107, -24.028614]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "SAN PEDRO",
        "dist_desc_": "SAN VICENTE PANCHOLO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-57.469994, -25.324433],
            [-57.483177, -25.342099],
            [-57.484566, -25.401887],
            [-57.507406, -25.403112],
            [-57.523278, -25.385783],
            [-57.526884, -25.372394],
            [-57.566758, -25.360922],
            [-57.570284, -25.355547],
            [-57.551821, -25.356953],
            [-57.540099, -25.332433],
            [-57.517974, -25.31878],
            [-57.535964, -25.295812],
            [-57.493767, -25.312162],
            [-57.469994, -25.324433]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CENTRAL",
        "dist_desc_": "SAN LORENZO"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.875891, -26.891587],
            [-55.791817, -26.968093],
            [-55.800939, -26.988511],
            [-55.822887, -27.011457],
            [-55.855078, -27.044988],
            [-55.875308, -27.056666],
            [-55.878446, -27.075518],
            [-55.885537, -27.081464],
            [-55.987018, -26.989745],
            [-55.997271, -26.99884],
            [-56.023823, -26.97842],
            [-56.014605, -26.967487],
            [-55.959289, -26.944299],
            [-55.959733, -26.925831],
            [-55.934721, -26.907277],
            [-55.904001, -26.904488],
            [-55.888119, -26.891639],
            [-55.875891, -26.891587]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "LA PAZ"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-55.818366, -27.267267],
            [-55.825993, -27.302251],
            [-55.806586, -27.306068],
            [-55.812566, -27.323306],
            [-55.832057, -27.331337],
            [-55.848637, -27.324407],
            [-55.853848, -27.340455],
            [-55.842151, -27.35741],
            [-55.822345, -27.360422],
            [-55.789292, -27.390857],
            [-55.80991, -27.411387],
            [-55.816379, -27.426313],
            [-55.826569, -27.425046],
            [-55.863622, -27.391933],
            [-55.864364, -27.374631],
            [-55.879461, -27.347271],
            [-55.88864, -27.341237],
            [-55.911769, -27.344723],
            [-55.911257, -27.323478],
            [-55.918148, -27.312596],
            [-55.901563, -27.300119],
            [-55.916445, -27.291539],
            [-55.930837, -27.293117],
            [-55.965479, -27.260468],
            [-55.985247, -27.255219],
            [-56.011724, -27.228529],
            [-56.020418, -27.21402],
            [-55.993186, -27.189335],
            [-55.973999, -27.172694],
            [-55.96101, -27.172632],
            [-55.948289, -27.148859],
            [-55.932225, -27.145562],
            [-55.926239, -27.134262],
            [-55.82219, -27.226416],
            [-55.818366, -27.267267]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "ITAPÚA",
        "dist_desc_": "ENCARNACIÓN"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-54.611941, -24.513567],
            [-54.603578, -24.472279],
            [-54.637158, -24.441454],
            [-54.620971, -24.425588],
            [-54.603881, -24.418864],
            [-54.579236, -24.384045],
            [-54.49758, -24.401217],
            [-54.46433, -24.390279],
            [-54.459086, -24.379668],
            [-54.490005, -24.354397],
            [-54.498803, -24.334191],
            [-54.478352, -24.320633],
            [-54.447858, -24.307814],
            [-54.447445, -24.307959],
            [-54.445345, -24.324269],
            [-54.430938, -24.327871],
            [-54.412957, -24.342413],
            [-54.41822, -24.364543],
            [-54.412638, -24.37657],
            [-54.39264, -24.366014],
            [-54.375194, -24.381066],
            [-54.377209, -24.390649],
            [-54.339665, -24.383397],
            [-54.340951, -24.396511],
            [-54.322073, -24.411449],
            [-54.309458, -24.439749],
            [-54.321035, -24.452039],
            [-54.328446, -24.487829],
            [-54.335034, -24.499178],
            [-54.337188, -24.529039],
            [-54.388003, -24.514849],
            [-54.403721, -24.526962],
            [-54.4263, -24.520206],
            [-54.451739, -24.52495],
            [-54.471294, -24.519171],
            [-54.478974, -24.529503],
            [-54.514831, -24.51625],
            [-54.528989, -24.500552],
            [-54.544408, -24.531095],
            [-54.553883, -24.536435],
            [-54.568911, -24.5254],
            [-54.590618, -24.525721],
            [-54.6119, -24.513576],
            [-54.611941, -24.513567]
          ]
        ]
      },
      "properties": {
        "dpto_desc": "CANINDEYÚ",
        "dist_desc_": "PUERTO ADELA"
      }
    }
  ]
}];



//////////////////
// WEBPACK FOOTER
// ./municipios.js
// module id = 763
// module chunks = 0